var b1 = Object.defineProperty;
var Ac = (o) => {
  throw TypeError(o);
};
var m1 = (o, r, n) => r in o ? b1(o, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[r] = n;
var Cr = (o, r, n) => m1(o, typeof r != "symbol" ? r + "" : r, n), za = (o, r, n) => r.has(o) || Ac("Cannot " + n);
var Be = (o, r, n) => (za(o, r, "read from private field"), n ? n.call(o) : r.get(o)), _o = (o, r, n) => r.has(o) ? Ac("Cannot add the same private member more than once") : r instanceof WeakSet ? r.add(o) : r.set(o, n), mf = (o, r, n, s) => (za(o, r, "write to private field"), s ? s.call(o, n) : r.set(o, n), n), Dt = (o, r, n) => (za(o, r, "access private method"), n);
var di = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ro(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
function al(o) {
  if (o.__esModule) return o;
  var r = o.default;
  if (typeof r == "function") {
    var n = function s() {
      return this instanceof s ? Reflect.construct(r, arguments, this.constructor) : r.apply(this, arguments);
    };
    n.prototype = r.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(o).forEach(function(s) {
    var v = Object.getOwnPropertyDescriptor(o, s);
    Object.defineProperty(n, s, v.get ? v : {
      enumerable: !0,
      get: function() {
        return o[s];
      }
    });
  }), n;
}
var yo = {}, Ja = { exports: {} }, Ze = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tc;
function w1() {
  if (Tc) return Ze;
  Tc = 1;
  var o = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), v = Symbol.for("react.profiler"), R = Symbol.for("react.provider"), I = Symbol.for("react.context"), L = Symbol.for("react.forward_ref"), G = Symbol.for("react.suspense"), Z = Symbol.for("react.memo"), he = Symbol.for("react.lazy"), me = Symbol.iterator;
  function Me(O) {
    return O === null || typeof O != "object" ? null : (O = me && O[me] || O["@@iterator"], typeof O == "function" ? O : null);
  }
  var be = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, tt = Object.assign, We = {};
  function Ge(O, J, Ee) {
    this.props = O, this.context = J, this.refs = We, this.updater = Ee || be;
  }
  Ge.prototype.isReactComponent = {}, Ge.prototype.setState = function(O, J) {
    if (typeof O != "object" && typeof O != "function" && O != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, O, J, "setState");
  }, Ge.prototype.forceUpdate = function(O) {
    this.updater.enqueueForceUpdate(this, O, "forceUpdate");
  };
  function mt() {
  }
  mt.prototype = Ge.prototype;
  function Fe(O, J, Ee) {
    this.props = O, this.context = J, this.refs = We, this.updater = Ee || be;
  }
  var yt = Fe.prototype = new mt();
  yt.constructor = Fe, tt(yt, Ge.prototype), yt.isPureReactComponent = !0;
  var ft = Array.isArray, nt = Object.prototype.hasOwnProperty, ht = { current: null }, Ut = { key: !0, ref: !0, __self: !0, __source: !0 };
  function nn(O, J, Ee) {
    var Oe, ee = {}, $e = null, st = null;
    if (J != null) for (Oe in J.ref !== void 0 && (st = J.ref), J.key !== void 0 && ($e = "" + J.key), J) nt.call(J, Oe) && !Ut.hasOwnProperty(Oe) && (ee[Oe] = J[Oe]);
    var Xe = arguments.length - 2;
    if (Xe === 1) ee.children = Ee;
    else if (1 < Xe) {
      for (var Ke = Array(Xe), St = 0; St < Xe; St++) Ke[St] = arguments[St + 2];
      ee.children = Ke;
    }
    if (O && O.defaultProps) for (Oe in Xe = O.defaultProps, Xe) ee[Oe] === void 0 && (ee[Oe] = Xe[Oe]);
    return { $$typeof: o, type: O, key: $e, ref: st, props: ee, _owner: ht.current };
  }
  function Sn(O, J) {
    return { $$typeof: o, type: O.type, key: J, ref: O.ref, props: O.props, _owner: O._owner };
  }
  function Mn(O) {
    return typeof O == "object" && O !== null && O.$$typeof === o;
  }
  function zn(O) {
    var J = { "=": "=0", ":": "=2" };
    return "$" + O.replace(/[=:]/g, function(Ee) {
      return J[Ee];
    });
  }
  var $n = /\/+/g;
  function kt(O, J) {
    return typeof O == "object" && O !== null && O.key != null ? zn("" + O.key) : J.toString(36);
  }
  function Kt(O, J, Ee, Oe, ee) {
    var $e = typeof O;
    ($e === "undefined" || $e === "boolean") && (O = null);
    var st = !1;
    if (O === null) st = !0;
    else switch ($e) {
      case "string":
      case "number":
        st = !0;
        break;
      case "object":
        switch (O.$$typeof) {
          case o:
          case r:
            st = !0;
        }
    }
    if (st) return st = O, ee = ee(st), O = Oe === "" ? "." + kt(st, 0) : Oe, ft(ee) ? (Ee = "", O != null && (Ee = O.replace($n, "$&/") + "/"), Kt(ee, J, Ee, "", function(St) {
      return St;
    })) : ee != null && (Mn(ee) && (ee = Sn(ee, Ee + (!ee.key || st && st.key === ee.key ? "" : ("" + ee.key).replace($n, "$&/") + "/") + O)), J.push(ee)), 1;
    if (st = 0, Oe = Oe === "" ? "." : Oe + ":", ft(O)) for (var Xe = 0; Xe < O.length; Xe++) {
      $e = O[Xe];
      var Ke = Oe + kt($e, Xe);
      st += Kt($e, J, Ee, Ke, ee);
    }
    else if (Ke = Me(O), typeof Ke == "function") for (O = Ke.call(O), Xe = 0; !($e = O.next()).done; ) $e = $e.value, Ke = Oe + kt($e, Xe++), st += Kt($e, J, Ee, Ke, ee);
    else if ($e === "object") throw J = String(O), Error("Objects are not valid as a React child (found: " + (J === "[object Object]" ? "object with keys {" + Object.keys(O).join(", ") + "}" : J) + "). If you meant to render a collection of children, use an array instead.");
    return st;
  }
  function Lt(O, J, Ee) {
    if (O == null) return O;
    var Oe = [], ee = 0;
    return Kt(O, Oe, "", "", function($e) {
      return J.call(Ee, $e, ee++);
    }), Oe;
  }
  function Mt(O) {
    if (O._status === -1) {
      var J = O._result;
      J = J(), J.then(function(Ee) {
        (O._status === 0 || O._status === -1) && (O._status = 1, O._result = Ee);
      }, function(Ee) {
        (O._status === 0 || O._status === -1) && (O._status = 2, O._result = Ee);
      }), O._status === -1 && (O._status = 0, O._result = J);
    }
    if (O._status === 1) return O._result.default;
    throw O._result;
  }
  var de = { current: null }, It = { transition: null }, ln = { ReactCurrentDispatcher: de, ReactCurrentBatchConfig: It, ReactCurrentOwner: ht };
  function fn() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return Ze.Children = { map: Lt, forEach: function(O, J, Ee) {
    Lt(O, function() {
      J.apply(this, arguments);
    }, Ee);
  }, count: function(O) {
    var J = 0;
    return Lt(O, function() {
      J++;
    }), J;
  }, toArray: function(O) {
    return Lt(O, function(J) {
      return J;
    }) || [];
  }, only: function(O) {
    if (!Mn(O)) throw Error("React.Children.only expected to receive a single React element child.");
    return O;
  } }, Ze.Component = Ge, Ze.Fragment = n, Ze.Profiler = v, Ze.PureComponent = Fe, Ze.StrictMode = s, Ze.Suspense = G, Ze.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ln, Ze.act = fn, Ze.cloneElement = function(O, J, Ee) {
    if (O == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + O + ".");
    var Oe = tt({}, O.props), ee = O.key, $e = O.ref, st = O._owner;
    if (J != null) {
      if (J.ref !== void 0 && ($e = J.ref, st = ht.current), J.key !== void 0 && (ee = "" + J.key), O.type && O.type.defaultProps) var Xe = O.type.defaultProps;
      for (Ke in J) nt.call(J, Ke) && !Ut.hasOwnProperty(Ke) && (Oe[Ke] = J[Ke] === void 0 && Xe !== void 0 ? Xe[Ke] : J[Ke]);
    }
    var Ke = arguments.length - 2;
    if (Ke === 1) Oe.children = Ee;
    else if (1 < Ke) {
      Xe = Array(Ke);
      for (var St = 0; St < Ke; St++) Xe[St] = arguments[St + 2];
      Oe.children = Xe;
    }
    return { $$typeof: o, type: O.type, key: ee, ref: $e, props: Oe, _owner: st };
  }, Ze.createContext = function(O) {
    return O = { $$typeof: I, _currentValue: O, _currentValue2: O, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, O.Provider = { $$typeof: R, _context: O }, O.Consumer = O;
  }, Ze.createElement = nn, Ze.createFactory = function(O) {
    var J = nn.bind(null, O);
    return J.type = O, J;
  }, Ze.createRef = function() {
    return { current: null };
  }, Ze.forwardRef = function(O) {
    return { $$typeof: L, render: O };
  }, Ze.isValidElement = Mn, Ze.lazy = function(O) {
    return { $$typeof: he, _payload: { _status: -1, _result: O }, _init: Mt };
  }, Ze.memo = function(O, J) {
    return { $$typeof: Z, type: O, compare: J === void 0 ? null : J };
  }, Ze.startTransition = function(O) {
    var J = It.transition;
    It.transition = {};
    try {
      O();
    } finally {
      It.transition = J;
    }
  }, Ze.unstable_act = fn, Ze.useCallback = function(O, J) {
    return de.current.useCallback(O, J);
  }, Ze.useContext = function(O) {
    return de.current.useContext(O);
  }, Ze.useDebugValue = function() {
  }, Ze.useDeferredValue = function(O) {
    return de.current.useDeferredValue(O);
  }, Ze.useEffect = function(O, J) {
    return de.current.useEffect(O, J);
  }, Ze.useId = function() {
    return de.current.useId();
  }, Ze.useImperativeHandle = function(O, J, Ee) {
    return de.current.useImperativeHandle(O, J, Ee);
  }, Ze.useInsertionEffect = function(O, J) {
    return de.current.useInsertionEffect(O, J);
  }, Ze.useLayoutEffect = function(O, J) {
    return de.current.useLayoutEffect(O, J);
  }, Ze.useMemo = function(O, J) {
    return de.current.useMemo(O, J);
  }, Ze.useReducer = function(O, J, Ee) {
    return de.current.useReducer(O, J, Ee);
  }, Ze.useRef = function(O) {
    return de.current.useRef(O);
  }, Ze.useState = function(O) {
    return de.current.useState(O);
  }, Ze.useSyncExternalStore = function(O, J, Ee) {
    return de.current.useSyncExternalStore(O, J, Ee);
  }, Ze.useTransition = function() {
    return de.current.useTransition();
  }, Ze.version = "18.3.1", Ze;
}
var wo = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
wo.exports;
var Oc;
function E1() {
  return Oc || (Oc = 1, function(o, r) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var n = "18.3.1", s = Symbol.for("react.element"), v = Symbol.for("react.portal"), R = Symbol.for("react.fragment"), I = Symbol.for("react.strict_mode"), L = Symbol.for("react.profiler"), G = Symbol.for("react.provider"), Z = Symbol.for("react.context"), he = Symbol.for("react.forward_ref"), me = Symbol.for("react.suspense"), Me = Symbol.for("react.suspense_list"), be = Symbol.for("react.memo"), tt = Symbol.for("react.lazy"), We = Symbol.for("react.offscreen"), Ge = Symbol.iterator, mt = "@@iterator";
      function Fe(c) {
        if (c === null || typeof c != "object")
          return null;
        var w = Ge && c[Ge] || c[mt];
        return typeof w == "function" ? w : null;
      }
      var yt = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, ft = {
        transition: null
      }, nt = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1
      }, ht = {
        /**
         * @internal
         * @type {ReactComponent}
         */
        current: null
      }, Ut = {}, nn = null;
      function Sn(c) {
        nn = c;
      }
      Ut.setExtraStackFrame = function(c) {
        nn = c;
      }, Ut.getCurrentStack = null, Ut.getStackAddendum = function() {
        var c = "";
        nn && (c += nn);
        var w = Ut.getCurrentStack;
        return w && (c += w() || ""), c;
      };
      var Mn = !1, zn = !1, $n = !1, kt = !1, Kt = !1, Lt = {
        ReactCurrentDispatcher: yt,
        ReactCurrentBatchConfig: ft,
        ReactCurrentOwner: ht
      };
      Lt.ReactDebugCurrentFrame = Ut, Lt.ReactCurrentActQueue = nt;
      function Mt(c) {
        {
          for (var w = arguments.length, P = new Array(w > 1 ? w - 1 : 0), N = 1; N < w; N++)
            P[N - 1] = arguments[N];
          It("warn", c, P);
        }
      }
      function de(c) {
        {
          for (var w = arguments.length, P = new Array(w > 1 ? w - 1 : 0), N = 1; N < w; N++)
            P[N - 1] = arguments[N];
          It("error", c, P);
        }
      }
      function It(c, w, P) {
        {
          var N = Lt.ReactDebugCurrentFrame, q = N.getStackAddendum();
          q !== "" && (w += "%s", P = P.concat([q]));
          var we = P.map(function(le) {
            return String(le);
          });
          we.unshift("Warning: " + w), Function.prototype.apply.call(console[c], console, we);
        }
      }
      var ln = {};
      function fn(c, w) {
        {
          var P = c.constructor, N = P && (P.displayName || P.name) || "ReactClass", q = N + "." + w;
          if (ln[q])
            return;
          de("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", w, N), ln[q] = !0;
        }
      }
      var O = {
        /**
         * Checks whether or not this composite component is mounted.
         * @param {ReactClass} publicInstance The instance we want to test.
         * @return {boolean} True if mounted, false otherwise.
         * @protected
         * @final
         */
        isMounted: function(c) {
          return !1;
        },
        /**
         * Forces an update. This should only be invoked when it is known with
         * certainty that we are **not** in a DOM transaction.
         *
         * You may want to call this when you know that some deeper aspect of the
         * component's state has changed but `setState` was not called.
         *
         * This will not invoke `shouldComponentUpdate`, but it will invoke
         * `componentWillUpdate` and `componentDidUpdate`.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueForceUpdate: function(c, w, P) {
          fn(c, "forceUpdate");
        },
        /**
         * Replaces all of the state. Always use this or `setState` to mutate state.
         * You should treat `this.state` as immutable.
         *
         * There is no guarantee that `this.state` will be immediately updated, so
         * accessing `this.state` after calling this method may return the old value.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} completeState Next state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} callerName name of the calling function in the public API.
         * @internal
         */
        enqueueReplaceState: function(c, w, P, N) {
          fn(c, "replaceState");
        },
        /**
         * Sets a subset of the state. This only exists because _pendingState is
         * internal. This provides a merging strategy that is not available to deep
         * properties which is confusing. TODO: Expose pendingState or don't use it
         * during the merge.
         *
         * @param {ReactClass} publicInstance The instance that should rerender.
         * @param {object} partialState Next partial state to be merged with state.
         * @param {?function} callback Called after component is updated.
         * @param {?string} Name of the calling function in the public API.
         * @internal
         */
        enqueueSetState: function(c, w, P, N) {
          fn(c, "setState");
        }
      }, J = Object.assign, Ee = {};
      Object.freeze(Ee);
      function Oe(c, w, P) {
        this.props = c, this.context = w, this.refs = Ee, this.updater = P || O;
      }
      Oe.prototype.isReactComponent = {}, Oe.prototype.setState = function(c, w) {
        if (typeof c != "object" && typeof c != "function" && c != null)
          throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, c, w, "setState");
      }, Oe.prototype.forceUpdate = function(c) {
        this.updater.enqueueForceUpdate(this, c, "forceUpdate");
      };
      {
        var ee = {
          isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
          replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
        }, $e = function(c, w) {
          Object.defineProperty(Oe.prototype, c, {
            get: function() {
              Mt("%s(...) is deprecated in plain JavaScript React classes. %s", w[0], w[1]);
            }
          });
        };
        for (var st in ee)
          ee.hasOwnProperty(st) && $e(st, ee[st]);
      }
      function Xe() {
      }
      Xe.prototype = Oe.prototype;
      function Ke(c, w, P) {
        this.props = c, this.context = w, this.refs = Ee, this.updater = P || O;
      }
      var St = Ke.prototype = new Xe();
      St.constructor = Ke, J(St, Oe.prototype), St.isPureReactComponent = !0;
      function sr() {
        var c = {
          current: null
        };
        return Object.seal(c), c;
      }
      var Rn = Array.isArray;
      function Hn(c) {
        return Rn(c);
      }
      function an(c) {
        {
          var w = typeof Symbol == "function" && Symbol.toStringTag, P = w && c[Symbol.toStringTag] || c.constructor.name || "Object";
          return P;
        }
      }
      function An(c) {
        try {
          return Gn(c), !1;
        } catch {
          return !0;
        }
      }
      function Gn(c) {
        return "" + c;
      }
      function qt(c) {
        if (An(c))
          return de("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", an(c)), Gn(c);
      }
      function mr(c, w, P) {
        var N = c.displayName;
        if (N)
          return N;
        var q = w.displayName || w.name || "";
        return q !== "" ? P + "(" + q + ")" : P;
      }
      function sn(c) {
        return c.displayName || "Context";
      }
      function Yt(c) {
        if (c == null)
          return null;
        if (typeof c.tag == "number" && de("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof c == "function")
          return c.displayName || c.name || null;
        if (typeof c == "string")
          return c;
        switch (c) {
          case R:
            return "Fragment";
          case v:
            return "Portal";
          case L:
            return "Profiler";
          case I:
            return "StrictMode";
          case me:
            return "Suspense";
          case Me:
            return "SuspenseList";
        }
        if (typeof c == "object")
          switch (c.$$typeof) {
            case Z:
              var w = c;
              return sn(w) + ".Consumer";
            case G:
              var P = c;
              return sn(P._context) + ".Provider";
            case he:
              return mr(c, c.render, "ForwardRef");
            case be:
              var N = c.displayName || null;
              return N !== null ? N : Yt(c.type) || "Memo";
            case tt: {
              var q = c, we = q._payload, le = q._init;
              try {
                return Yt(le(we));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var Bt = Object.prototype.hasOwnProperty, hn = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Nn, ur, dn;
      dn = {};
      function qn(c) {
        if (Bt.call(c, "ref")) {
          var w = Object.getOwnPropertyDescriptor(c, "ref").get;
          if (w && w.isReactWarning)
            return !1;
        }
        return c.ref !== void 0;
      }
      function rn(c) {
        if (Bt.call(c, "key")) {
          var w = Object.getOwnPropertyDescriptor(c, "key").get;
          if (w && w.isReactWarning)
            return !1;
        }
        return c.key !== void 0;
      }
      function Tn(c, w) {
        var P = function() {
          Nn || (Nn = !0, de("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        P.isReactWarning = !0, Object.defineProperty(c, "key", {
          get: P,
          configurable: !0
        });
      }
      function cr(c, w) {
        var P = function() {
          ur || (ur = !0, de("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        P.isReactWarning = !0, Object.defineProperty(c, "ref", {
          get: P,
          configurable: !0
        });
      }
      function wr(c) {
        if (typeof c.ref == "string" && ht.current && c.__self && ht.current.stateNode !== c.__self) {
          var w = Yt(ht.current.type);
          dn[w] || (de('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', w, c.ref), dn[w] = !0);
        }
      }
      var vn = function(c, w, P, N, q, we, le) {
        var Ce = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: s,
          // Built-in properties that belong on the element
          type: c,
          key: w,
          ref: P,
          props: le,
          // Record the component responsible for creating this element.
          _owner: we
        };
        return Ce._store = {}, Object.defineProperty(Ce._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Ce, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: N
        }), Object.defineProperty(Ce, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: q
        }), Object.freeze && (Object.freeze(Ce.props), Object.freeze(Ce)), Ce;
      };
      function lr(c, w, P) {
        var N, q = {}, we = null, le = null, Ce = null, Qe = null;
        if (w != null) {
          qn(w) && (le = w.ref, wr(w)), rn(w) && (qt(w.key), we = "" + w.key), Ce = w.__self === void 0 ? null : w.__self, Qe = w.__source === void 0 ? null : w.__source;
          for (N in w)
            Bt.call(w, N) && !hn.hasOwnProperty(N) && (q[N] = w[N]);
        }
        var gt = arguments.length - 2;
        if (gt === 1)
          q.children = P;
        else if (gt > 1) {
          for (var At = Array(gt), Je = 0; Je < gt; Je++)
            At[Je] = arguments[Je + 2];
          Object.freeze && Object.freeze(At), q.children = At;
        }
        if (c && c.defaultProps) {
          var Pt = c.defaultProps;
          for (N in Pt)
            q[N] === void 0 && (q[N] = Pt[N]);
        }
        if (we || le) {
          var at = typeof c == "function" ? c.displayName || c.name || "Unknown" : c;
          we && Tn(q, at), le && cr(q, at);
        }
        return vn(c, we, le, Ce, Qe, ht.current, q);
      }
      function Vn(c, w) {
        var P = vn(c.type, w, c.ref, c._self, c._source, c._owner, c.props);
        return P;
      }
      function Fn(c, w, P) {
        if (c == null)
          throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + c + ".");
        var N, q = J({}, c.props), we = c.key, le = c.ref, Ce = c._self, Qe = c._source, gt = c._owner;
        if (w != null) {
          qn(w) && (le = w.ref, gt = ht.current), rn(w) && (qt(w.key), we = "" + w.key);
          var At;
          c.type && c.type.defaultProps && (At = c.type.defaultProps);
          for (N in w)
            Bt.call(w, N) && !hn.hasOwnProperty(N) && (w[N] === void 0 && At !== void 0 ? q[N] = At[N] : q[N] = w[N]);
        }
        var Je = arguments.length - 2;
        if (Je === 1)
          q.children = P;
        else if (Je > 1) {
          for (var Pt = Array(Je), at = 0; at < Je; at++)
            Pt[at] = arguments[at + 2];
          q.children = Pt;
        }
        return vn(c.type, we, le, Ce, Qe, gt, q);
      }
      function Jt(c) {
        return typeof c == "object" && c !== null && c.$$typeof === s;
      }
      var On = ".", Jn = ":";
      function hr(c) {
        var w = /[=:]/g, P = {
          "=": "=0",
          ":": "=2"
        }, N = c.replace(w, function(q) {
          return P[q];
        });
        return "$" + N;
      }
      var In = !1, Er = /\/+/g;
      function _n(c) {
        return c.replace(Er, "$&/");
      }
      function Zn(c, w) {
        return typeof c == "object" && c !== null && c.key != null ? (qt(c.key), hr("" + c.key)) : w.toString(36);
      }
      function Xn(c, w, P, N, q) {
        var we = typeof c;
        (we === "undefined" || we === "boolean") && (c = null);
        var le = !1;
        if (c === null)
          le = !0;
        else
          switch (we) {
            case "string":
            case "number":
              le = !0;
              break;
            case "object":
              switch (c.$$typeof) {
                case s:
                case v:
                  le = !0;
              }
          }
        if (le) {
          var Ce = c, Qe = q(Ce), gt = N === "" ? On + Zn(Ce, 0) : N;
          if (Hn(Qe)) {
            var At = "";
            gt != null && (At = _n(gt) + "/"), Xn(Qe, w, At, "", function(Kf) {
              return Kf;
            });
          } else Qe != null && (Jt(Qe) && (Qe.key && (!Ce || Ce.key !== Qe.key) && qt(Qe.key), Qe = Vn(
            Qe,
            // Keep both the (mapped) and old keys if they differ, just as
            // traverseAllChildren used to do for objects as children
            P + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
            (Qe.key && (!Ce || Ce.key !== Qe.key) ? (
              // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
              // eslint-disable-next-line react-internal/safe-string-coercion
              _n("" + Qe.key) + "/"
            ) : "") + gt
          )), w.push(Qe));
          return 1;
        }
        var Je, Pt, at = 0, Qt = N === "" ? On : N + Jn;
        if (Hn(c))
          for (var ti = 0; ti < c.length; ti++)
            Je = c[ti], Pt = Qt + Zn(Je, ti), at += Xn(Je, w, P, Pt, q);
        else {
          var Qn = Fe(c);
          if (typeof Qn == "function") {
            var ni = c;
            Qn === ni.entries && (In || Mt("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), In = !0);
            for (var eo = Qn.call(ni), Tt, Tr = 0; !(Tt = eo.next()).done; )
              Je = Tt.value, Pt = Qt + Zn(Je, Tr++), at += Xn(Je, w, P, Pt, q);
          } else if (we === "object") {
            var yi = String(c);
            throw new Error("Objects are not valid as a React child (found: " + (yi === "[object Object]" ? "object with keys {" + Object.keys(c).join(", ") + "}" : yi) + "). If you meant to render a collection of children, use an array instead.");
          }
        }
        return at;
      }
      function Zt(c, w, P) {
        if (c == null)
          return c;
        var N = [], q = 0;
        return Xn(c, N, "", "", function(we) {
          return w.call(P, we, q++);
        }), N;
      }
      function Dn(c) {
        var w = 0;
        return Zt(c, function() {
          w++;
        }), w;
      }
      function Bn(c, w, P) {
        Zt(c, function() {
          w.apply(this, arguments);
        }, P);
      }
      function Sr(c) {
        return Zt(c, function(w) {
          return w;
        }) || [];
      }
      function Rr(c) {
        if (!Jt(c))
          throw new Error("React.Children.only expected to receive a single React element child.");
        return c;
      }
      function Ur(c) {
        var w = {
          $$typeof: Z,
          // As a workaround to support multiple concurrent renderers, we categorize
          // some renderers as primary and others as secondary. We only expect
          // there to be two concurrent renderers at most: React Native (primary) and
          // Fabric (secondary); React DOM (primary) and React ART (secondary).
          // Secondary renderers store their context values on separate fields.
          _currentValue: c,
          _currentValue2: c,
          // Used to track how many concurrent renderers this context currently
          // supports within in a single renderer. Such as parallel server rendering.
          _threadCount: 0,
          // These are circular
          Provider: null,
          Consumer: null,
          // Add these to use same hidden class in VM as ServerContext
          _defaultValue: null,
          _globalName: null
        };
        w.Provider = {
          $$typeof: G,
          _context: w
        };
        var P = !1, N = !1, q = !1;
        {
          var we = {
            $$typeof: Z,
            _context: w
          };
          Object.defineProperties(we, {
            Provider: {
              get: function() {
                return N || (N = !0, de("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), w.Provider;
              },
              set: function(le) {
                w.Provider = le;
              }
            },
            _currentValue: {
              get: function() {
                return w._currentValue;
              },
              set: function(le) {
                w._currentValue = le;
              }
            },
            _currentValue2: {
              get: function() {
                return w._currentValue2;
              },
              set: function(le) {
                w._currentValue2 = le;
              }
            },
            _threadCount: {
              get: function() {
                return w._threadCount;
              },
              set: function(le) {
                w._threadCount = le;
              }
            },
            Consumer: {
              get: function() {
                return P || (P = !0, de("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), w.Consumer;
              }
            },
            displayName: {
              get: function() {
                return w.displayName;
              },
              set: function(le) {
                q || (Mt("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", le), q = !0);
              }
            }
          }), w.Consumer = we;
        }
        return w._currentRenderer = null, w._currentRenderer2 = null, w;
      }
      var dr = -1, $t = 0, Ar = 1, u = 2;
      function p(c) {
        if (c._status === dr) {
          var w = c._result, P = w();
          if (P.then(function(we) {
            if (c._status === $t || c._status === dr) {
              var le = c;
              le._status = Ar, le._result = we;
            }
          }, function(we) {
            if (c._status === $t || c._status === dr) {
              var le = c;
              le._status = u, le._result = we;
            }
          }), c._status === dr) {
            var N = c;
            N._status = $t, N._result = P;
          }
        }
        if (c._status === Ar) {
          var q = c._result;
          return q === void 0 && de(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, q), "default" in q || de(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, q), q.default;
        } else
          throw c._result;
      }
      function d(c) {
        var w = {
          // We use these fields to store the result.
          _status: dr,
          _result: c
        }, P = {
          $$typeof: tt,
          _payload: w,
          _init: p
        };
        {
          var N, q;
          Object.defineProperties(P, {
            defaultProps: {
              configurable: !0,
              get: function() {
                return N;
              },
              set: function(we) {
                de("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), N = we, Object.defineProperty(P, "defaultProps", {
                  enumerable: !0
                });
              }
            },
            propTypes: {
              configurable: !0,
              get: function() {
                return q;
              },
              set: function(we) {
                de("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), q = we, Object.defineProperty(P, "propTypes", {
                  enumerable: !0
                });
              }
            }
          });
        }
        return P;
      }
      function f(c) {
        c != null && c.$$typeof === be ? de("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof c != "function" ? de("forwardRef requires a render function but was given %s.", c === null ? "null" : typeof c) : c.length !== 0 && c.length !== 2 && de("forwardRef render functions accept exactly two parameters: props and ref. %s", c.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), c != null && (c.defaultProps != null || c.propTypes != null) && de("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        var w = {
          $$typeof: he,
          render: c
        };
        {
          var P;
          Object.defineProperty(w, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return P;
            },
            set: function(N) {
              P = N, !c.name && !c.displayName && (c.displayName = N);
            }
          });
        }
        return w;
      }
      var y;
      y = Symbol.for("react.module.reference");
      function h(c) {
        return !!(typeof c == "string" || typeof c == "function" || c === R || c === L || Kt || c === I || c === me || c === Me || kt || c === We || Mn || zn || $n || typeof c == "object" && c !== null && (c.$$typeof === tt || c.$$typeof === be || c.$$typeof === G || c.$$typeof === Z || c.$$typeof === he || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        c.$$typeof === y || c.getModuleId !== void 0));
      }
      function x(c, w) {
        h(c) || de("memo: The first argument must be a component. Instead received: %s", c === null ? "null" : typeof c);
        var P = {
          $$typeof: be,
          type: c,
          compare: w === void 0 ? null : w
        };
        {
          var N;
          Object.defineProperty(P, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
              return N;
            },
            set: function(q) {
              N = q, !c.name && !c.displayName && (c.displayName = q);
            }
          });
        }
        return P;
      }
      function S() {
        var c = yt.current;
        return c === null && de(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), c;
      }
      function M(c) {
        var w = S();
        if (c._context !== void 0) {
          var P = c._context;
          P.Consumer === c ? de("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : P.Provider === c && de("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return w.useContext(c);
      }
      function V(c) {
        var w = S();
        return w.useState(c);
      }
      function Y(c, w, P) {
        var N = S();
        return N.useReducer(c, w, P);
      }
      function ie(c) {
        var w = S();
        return w.useRef(c);
      }
      function k(c, w) {
        var P = S();
        return P.useEffect(c, w);
      }
      function ae(c, w) {
        var P = S();
        return P.useInsertionEffect(c, w);
      }
      function oe(c, w) {
        var P = S();
        return P.useLayoutEffect(c, w);
      }
      function se(c, w) {
        var P = S();
        return P.useCallback(c, w);
      }
      function pe(c, w) {
        var P = S();
        return P.useMemo(c, w);
      }
      function xe(c, w, P) {
        var N = S();
        return N.useImperativeHandle(c, w, P);
      }
      function ve(c, w) {
        {
          var P = S();
          return P.useDebugValue(c, w);
        }
      }
      function ce() {
        var c = S();
        return c.useTransition();
      }
      function ne(c) {
        var w = S();
        return w.useDeferredValue(c);
      }
      function ge() {
        var c = S();
        return c.useId();
      }
      function Q(c, w, P) {
        var N = S();
        return N.useSyncExternalStore(c, w, P);
      }
      var re = 0, fe, X, C, U, K, D, B;
      function H() {
      }
      H.__reactDisabledLog = !0;
      function ye() {
        {
          if (re === 0) {
            fe = console.log, X = console.info, C = console.warn, U = console.error, K = console.group, D = console.groupCollapsed, B = console.groupEnd;
            var c = {
              configurable: !0,
              enumerable: !0,
              value: H,
              writable: !0
            };
            Object.defineProperties(console, {
              info: c,
              log: c,
              warn: c,
              error: c,
              group: c,
              groupCollapsed: c,
              groupEnd: c
            });
          }
          re++;
        }
      }
      function Ue() {
        {
          if (re--, re === 0) {
            var c = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: J({}, c, {
                value: fe
              }),
              info: J({}, c, {
                value: X
              }),
              warn: J({}, c, {
                value: C
              }),
              error: J({}, c, {
                value: U
              }),
              group: J({}, c, {
                value: K
              }),
              groupCollapsed: J({}, c, {
                value: D
              }),
              groupEnd: J({}, c, {
                value: B
              })
            });
          }
          re < 0 && de("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var Ie = Lt.ReactCurrentDispatcher, Se;
      function b(c, w, P) {
        {
          if (Se === void 0)
            try {
              throw Error();
            } catch (q) {
              var N = q.stack.trim().match(/\n( *(at )?)/);
              Se = N && N[1] || "";
            }
          return `
` + Se + c;
        }
      }
      var Le = !1, je;
      {
        var qe = typeof WeakMap == "function" ? WeakMap : Map;
        je = new qe();
      }
      function Pe(c, w) {
        if (!c || Le)
          return "";
        {
          var P = je.get(c);
          if (P !== void 0)
            return P;
        }
        var N;
        Le = !0;
        var q = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var we;
        we = Ie.current, Ie.current = null, ye();
        try {
          if (w) {
            var le = function() {
              throw Error();
            };
            if (Object.defineProperty(le.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(le, []);
              } catch (Qt) {
                N = Qt;
              }
              Reflect.construct(c, [], le);
            } else {
              try {
                le.call();
              } catch (Qt) {
                N = Qt;
              }
              c.call(le.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Qt) {
              N = Qt;
            }
            c();
          }
        } catch (Qt) {
          if (Qt && N && typeof Qt.stack == "string") {
            for (var Ce = Qt.stack.split(`
`), Qe = N.stack.split(`
`), gt = Ce.length - 1, At = Qe.length - 1; gt >= 1 && At >= 0 && Ce[gt] !== Qe[At]; )
              At--;
            for (; gt >= 1 && At >= 0; gt--, At--)
              if (Ce[gt] !== Qe[At]) {
                if (gt !== 1 || At !== 1)
                  do
                    if (gt--, At--, At < 0 || Ce[gt] !== Qe[At]) {
                      var Je = `
` + Ce[gt].replace(" at new ", " at ");
                      return c.displayName && Je.includes("<anonymous>") && (Je = Je.replace("<anonymous>", c.displayName)), typeof c == "function" && je.set(c, Je), Je;
                    }
                  while (gt >= 1 && At >= 0);
                break;
              }
          }
        } finally {
          Le = !1, Ie.current = we, Ue(), Error.prepareStackTrace = q;
        }
        var Pt = c ? c.displayName || c.name : "", at = Pt ? b(Pt) : "";
        return typeof c == "function" && je.set(c, at), at;
      }
      function Ve(c, w, P) {
        return Pe(c, !1);
      }
      function ze(c) {
        var w = c.prototype;
        return !!(w && w.isReactComponent);
      }
      function dt(c, w, P) {
        if (c == null)
          return "";
        if (typeof c == "function")
          return Pe(c, ze(c));
        if (typeof c == "string")
          return b(c);
        switch (c) {
          case me:
            return b("Suspense");
          case Me:
            return b("SuspenseList");
        }
        if (typeof c == "object")
          switch (c.$$typeof) {
            case he:
              return Ve(c.render);
            case be:
              return dt(c.type, w, P);
            case tt: {
              var N = c, q = N._payload, we = N._init;
              try {
                return dt(we(q), w, P);
              } catch {
              }
            }
          }
        return "";
      }
      var rt = {}, ut = Lt.ReactDebugCurrentFrame;
      function pt(c) {
        if (c) {
          var w = c._owner, P = dt(c.type, c._source, w ? w.type : null);
          ut.setExtraStackFrame(P);
        } else
          ut.setExtraStackFrame(null);
      }
      function Rt(c, w, P, N, q) {
        {
          var we = Function.call.bind(Bt);
          for (var le in c)
            if (we(c, le)) {
              var Ce = void 0;
              try {
                if (typeof c[le] != "function") {
                  var Qe = Error((N || "React class") + ": " + P + " type `" + le + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[le] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Qe.name = "Invariant Violation", Qe;
                }
                Ce = c[le](w, le, N, P, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (gt) {
                Ce = gt;
              }
              Ce && !(Ce instanceof Error) && (pt(q), de("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", N || "React class", P, le, typeof Ce), pt(null)), Ce instanceof Error && !(Ce.message in rt) && (rt[Ce.message] = !0, pt(q), de("Failed %s type: %s", P, Ce.message), pt(null));
            }
        }
      }
      function wt(c) {
        if (c) {
          var w = c._owner, P = dt(c.type, c._source, w ? w.type : null);
          Sn(P);
        } else
          Sn(null);
      }
      var Nt;
      Nt = !1;
      function Wt() {
        if (ht.current) {
          var c = Yt(ht.current.type);
          if (c)
            return `

Check the render method of \`` + c + "`.";
        }
        return "";
      }
      function zt(c) {
        if (c !== void 0) {
          var w = c.fileName.replace(/^.*[\\\/]/, ""), P = c.lineNumber;
          return `

Check your code at ` + w + ":" + P + ".";
        }
        return "";
      }
      function To(c) {
        return c != null ? zt(c.__source) : "";
      }
      var Oo = {};
      function Nf(c) {
        var w = Wt();
        if (!w) {
          var P = typeof c == "string" ? c : c.displayName || c.name;
          P && (w = `

Check the top-level render call using <` + P + ">.");
        }
        return w;
      }
      function Io(c, w) {
        if (!(!c._store || c._store.validated || c.key != null)) {
          c._store.validated = !0;
          var P = Nf(w);
          if (!Oo[P]) {
            Oo[P] = !0;
            var N = "";
            c && c._owner && c._owner !== ht.current && (N = " It was passed a child from " + Yt(c._owner.type) + "."), wt(c), de('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', P, N), wt(null);
          }
        }
      }
      function Vi(c, w) {
        if (typeof c == "object") {
          if (Hn(c))
            for (var P = 0; P < c.length; P++) {
              var N = c[P];
              Jt(N) && Io(N, w);
            }
          else if (Jt(c))
            c._store && (c._store.validated = !0);
          else if (c) {
            var q = Fe(c);
            if (typeof q == "function" && q !== c.entries)
              for (var we = q.call(c), le; !(le = we.next()).done; )
                Jt(le.value) && Io(le.value, w);
          }
        }
      }
      function Po(c) {
        {
          var w = c.type;
          if (w == null || typeof w == "string")
            return;
          var P;
          if (typeof w == "function")
            P = w.propTypes;
          else if (typeof w == "object" && (w.$$typeof === he || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          w.$$typeof === be))
            P = w.propTypes;
          else
            return;
          if (P) {
            var N = Yt(w);
            Rt(P, c.props, "prop", N, c);
          } else if (w.PropTypes !== void 0 && !Nt) {
            Nt = !0;
            var q = Yt(w);
            de("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", q || "Unknown");
          }
          typeof w.getDefaultProps == "function" && !w.getDefaultProps.isReactClassApproved && de("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Ff(c) {
        {
          for (var w = Object.keys(c.props), P = 0; P < w.length; P++) {
            var N = w[P];
            if (N !== "children" && N !== "key") {
              wt(c), de("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", N), wt(null);
              break;
            }
          }
          c.ref !== null && (wt(c), de("Invalid attribute `ref` supplied to `React.Fragment`."), wt(null));
        }
      }
      function Co(c, w, P) {
        var N = h(c);
        if (!N) {
          var q = "";
          (c === void 0 || typeof c == "object" && c !== null && Object.keys(c).length === 0) && (q += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var we = To(w);
          we ? q += we : q += Wt();
          var le;
          c === null ? le = "null" : Hn(c) ? le = "array" : c !== void 0 && c.$$typeof === s ? (le = "<" + (Yt(c.type) || "Unknown") + " />", q = " Did you accidentally export a JSX literal instead of a component?") : le = typeof c, de("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", le, q);
        }
        var Ce = lr.apply(this, arguments);
        if (Ce == null)
          return Ce;
        if (N)
          for (var Qe = 2; Qe < arguments.length; Qe++)
            Vi(arguments[Qe], c);
        return c === R ? Ff(Ce) : Po(Ce), Ce;
      }
      var Uo = !1;
      function Ji(c) {
        var w = Co.bind(null, c);
        return w.type = c, Uo || (Uo = !0, Mt("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(w, "type", {
          enumerable: !1,
          get: function() {
            return Mt("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
              value: c
            }), c;
          }
        }), w;
      }
      function Df(c, w, P) {
        for (var N = Fn.apply(this, arguments), q = 2; q < arguments.length; q++)
          Vi(arguments[q], N.type);
        return Po(N), N;
      }
      function Bf(c, w) {
        var P = ft.transition;
        ft.transition = {};
        var N = ft.transition;
        ft.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          c();
        } finally {
          if (ft.transition = P, P === null && N._updatedFibers) {
            var q = N._updatedFibers.size;
            q > 10 && Mt("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), N._updatedFibers.clear();
          }
        }
      }
      var Lo = !1, vi = null;
      function Wf(c) {
        if (vi === null)
          try {
            var w = ("require" + Math.random()).slice(0, 7), P = o && o[w];
            vi = P.call(o, "timers").setImmediate;
          } catch {
            vi = function(q) {
              Lo === !1 && (Lo = !0, typeof MessageChannel > "u" && de("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
              var we = new MessageChannel();
              we.port1.onmessage = q, we.port2.postMessage(void 0);
            };
          }
        return vi(c);
      }
      var ct = 0, xt = !1;
      function Mo(c) {
        {
          var w = ct;
          ct++, nt.current === null && (nt.current = []);
          var P = nt.isBatchingLegacy, N;
          try {
            if (nt.isBatchingLegacy = !0, N = c(), !P && nt.didScheduleLegacyUpdate) {
              var q = nt.current;
              q !== null && (nt.didScheduleLegacyUpdate = !1, Qi(q));
            }
          } catch (Pt) {
            throw _i(w), Pt;
          } finally {
            nt.isBatchingLegacy = P;
          }
          if (N !== null && typeof N == "object" && typeof N.then == "function") {
            var we = N, le = !1, Ce = {
              then: function(Pt, at) {
                le = !0, we.then(function(Qt) {
                  _i(w), ct === 0 ? Zi(Qt, Pt, at) : Pt(Qt);
                }, function(Qt) {
                  _i(w), at(Qt);
                });
              }
            };
            return !xt && typeof Promise < "u" && Promise.resolve().then(function() {
            }).then(function() {
              le || (xt = !0, de("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            }), Ce;
          } else {
            var Qe = N;
            if (_i(w), ct === 0) {
              var gt = nt.current;
              gt !== null && (Qi(gt), nt.current = null);
              var At = {
                then: function(Pt, at) {
                  nt.current === null ? (nt.current = [], Zi(Qe, Pt, at)) : Pt(Qe);
                }
              };
              return At;
            } else {
              var Je = {
                then: function(Pt, at) {
                  Pt(Qe);
                }
              };
              return Je;
            }
          }
        }
      }
      function _i(c) {
        c !== ct - 1 && de("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), ct = c;
      }
      function Zi(c, w, P) {
        {
          var N = nt.current;
          if (N !== null)
            try {
              Qi(N), Wf(function() {
                N.length === 0 ? (nt.current = null, w(c)) : Zi(c, w, P);
              });
            } catch (q) {
              P(q);
            }
          else
            w(c);
        }
      }
      var Xi = !1;
      function Qi(c) {
        if (!Xi) {
          Xi = !0;
          var w = 0;
          try {
            for (; w < c.length; w++) {
              var P = c[w];
              do
                P = P(!0);
              while (P !== null);
            }
            c.length = 0;
          } catch (N) {
            throw c = c.slice(w + 1), N;
          } finally {
            Xi = !1;
          }
        }
      }
      var jf = Co, $o = Df, kf = Ji, Xt = {
        map: Zt,
        forEach: Bn,
        count: Dn,
        toArray: Sr,
        only: Rr
      };
      r.Children = Xt, r.Component = Oe, r.Fragment = R, r.Profiler = L, r.PureComponent = Ke, r.StrictMode = I, r.Suspense = me, r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Lt, r.act = Mo, r.cloneElement = $o, r.createContext = Ur, r.createElement = jf, r.createFactory = kf, r.createRef = sr, r.forwardRef = f, r.isValidElement = Jt, r.lazy = d, r.memo = x, r.startTransition = Bf, r.unstable_act = Mo, r.useCallback = se, r.useContext = M, r.useDebugValue = ve, r.useDeferredValue = ne, r.useEffect = k, r.useId = ge, r.useImperativeHandle = xe, r.useInsertionEffect = ae, r.useLayoutEffect = oe, r.useMemo = pe, r.useReducer = Y, r.useRef = ie, r.useState = V, r.useSyncExternalStore = Q, r.useTransition = ce, r.version = n, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(wo, wo.exports)), wo.exports;
}
process.env.NODE_ENV === "production" ? Ja.exports = w1() : Ja.exports = E1();
var ds = Ja.exports;
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ic;
function S1() {
  if (Ic) return yo;
  Ic = 1;
  var o = ds, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, v = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, R = { key: !0, ref: !0, __self: !0, __source: !0 };
  function I(L, G, Z) {
    var he, me = {}, Me = null, be = null;
    Z !== void 0 && (Me = "" + Z), G.key !== void 0 && (Me = "" + G.key), G.ref !== void 0 && (be = G.ref);
    for (he in G) s.call(G, he) && !R.hasOwnProperty(he) && (me[he] = G[he]);
    if (L && L.defaultProps) for (he in G = L.defaultProps, G) me[he] === void 0 && (me[he] = G[he]);
    return { $$typeof: r, type: L, key: Me, ref: be, props: me, _owner: v.current };
  }
  return yo.Fragment = n, yo.jsx = I, yo.jsxs = I, yo;
}
var xo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pc;
function R1() {
  return Pc || (Pc = 1, process.env.NODE_ENV !== "production" && function() {
    var o = ds, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), v = Symbol.for("react.strict_mode"), R = Symbol.for("react.profiler"), I = Symbol.for("react.provider"), L = Symbol.for("react.context"), G = Symbol.for("react.forward_ref"), Z = Symbol.for("react.suspense"), he = Symbol.for("react.suspense_list"), me = Symbol.for("react.memo"), Me = Symbol.for("react.lazy"), be = Symbol.for("react.offscreen"), tt = Symbol.iterator, We = "@@iterator";
    function Ge(h) {
      if (h === null || typeof h != "object")
        return null;
      var x = tt && h[tt] || h[We];
      return typeof x == "function" ? x : null;
    }
    var mt = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Fe(h) {
      {
        for (var x = arguments.length, S = new Array(x > 1 ? x - 1 : 0), M = 1; M < x; M++)
          S[M - 1] = arguments[M];
        yt("error", h, S);
      }
    }
    function yt(h, x, S) {
      {
        var M = mt.ReactDebugCurrentFrame, V = M.getStackAddendum();
        V !== "" && (x += "%s", S = S.concat([V]));
        var Y = S.map(function(ie) {
          return String(ie);
        });
        Y.unshift("Warning: " + x), Function.prototype.apply.call(console[h], console, Y);
      }
    }
    var ft = !1, nt = !1, ht = !1, Ut = !1, nn = !1, Sn;
    Sn = Symbol.for("react.module.reference");
    function Mn(h) {
      return !!(typeof h == "string" || typeof h == "function" || h === s || h === R || nn || h === v || h === Z || h === he || Ut || h === be || ft || nt || ht || typeof h == "object" && h !== null && (h.$$typeof === Me || h.$$typeof === me || h.$$typeof === I || h.$$typeof === L || h.$$typeof === G || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      h.$$typeof === Sn || h.getModuleId !== void 0));
    }
    function zn(h, x, S) {
      var M = h.displayName;
      if (M)
        return M;
      var V = x.displayName || x.name || "";
      return V !== "" ? S + "(" + V + ")" : S;
    }
    function $n(h) {
      return h.displayName || "Context";
    }
    function kt(h) {
      if (h == null)
        return null;
      if (typeof h.tag == "number" && Fe("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof h == "function")
        return h.displayName || h.name || null;
      if (typeof h == "string")
        return h;
      switch (h) {
        case s:
          return "Fragment";
        case n:
          return "Portal";
        case R:
          return "Profiler";
        case v:
          return "StrictMode";
        case Z:
          return "Suspense";
        case he:
          return "SuspenseList";
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case L:
            var x = h;
            return $n(x) + ".Consumer";
          case I:
            var S = h;
            return $n(S._context) + ".Provider";
          case G:
            return zn(h, h.render, "ForwardRef");
          case me:
            var M = h.displayName || null;
            return M !== null ? M : kt(h.type) || "Memo";
          case Me: {
            var V = h, Y = V._payload, ie = V._init;
            try {
              return kt(ie(Y));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Kt = Object.assign, Lt = 0, Mt, de, It, ln, fn, O, J;
    function Ee() {
    }
    Ee.__reactDisabledLog = !0;
    function Oe() {
      {
        if (Lt === 0) {
          Mt = console.log, de = console.info, It = console.warn, ln = console.error, fn = console.group, O = console.groupCollapsed, J = console.groupEnd;
          var h = {
            configurable: !0,
            enumerable: !0,
            value: Ee,
            writable: !0
          };
          Object.defineProperties(console, {
            info: h,
            log: h,
            warn: h,
            error: h,
            group: h,
            groupCollapsed: h,
            groupEnd: h
          });
        }
        Lt++;
      }
    }
    function ee() {
      {
        if (Lt--, Lt === 0) {
          var h = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Kt({}, h, {
              value: Mt
            }),
            info: Kt({}, h, {
              value: de
            }),
            warn: Kt({}, h, {
              value: It
            }),
            error: Kt({}, h, {
              value: ln
            }),
            group: Kt({}, h, {
              value: fn
            }),
            groupCollapsed: Kt({}, h, {
              value: O
            }),
            groupEnd: Kt({}, h, {
              value: J
            })
          });
        }
        Lt < 0 && Fe("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var $e = mt.ReactCurrentDispatcher, st;
    function Xe(h, x, S) {
      {
        if (st === void 0)
          try {
            throw Error();
          } catch (V) {
            var M = V.stack.trim().match(/\n( *(at )?)/);
            st = M && M[1] || "";
          }
        return `
` + st + h;
      }
    }
    var Ke = !1, St;
    {
      var sr = typeof WeakMap == "function" ? WeakMap : Map;
      St = new sr();
    }
    function Rn(h, x) {
      if (!h || Ke)
        return "";
      {
        var S = St.get(h);
        if (S !== void 0)
          return S;
      }
      var M;
      Ke = !0;
      var V = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Y;
      Y = $e.current, $e.current = null, Oe();
      try {
        if (x) {
          var ie = function() {
            throw Error();
          };
          if (Object.defineProperty(ie.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ie, []);
            } catch (ce) {
              M = ce;
            }
            Reflect.construct(h, [], ie);
          } else {
            try {
              ie.call();
            } catch (ce) {
              M = ce;
            }
            h.call(ie.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ce) {
            M = ce;
          }
          h();
        }
      } catch (ce) {
        if (ce && M && typeof ce.stack == "string") {
          for (var k = ce.stack.split(`
`), ae = M.stack.split(`
`), oe = k.length - 1, se = ae.length - 1; oe >= 1 && se >= 0 && k[oe] !== ae[se]; )
            se--;
          for (; oe >= 1 && se >= 0; oe--, se--)
            if (k[oe] !== ae[se]) {
              if (oe !== 1 || se !== 1)
                do
                  if (oe--, se--, se < 0 || k[oe] !== ae[se]) {
                    var pe = `
` + k[oe].replace(" at new ", " at ");
                    return h.displayName && pe.includes("<anonymous>") && (pe = pe.replace("<anonymous>", h.displayName)), typeof h == "function" && St.set(h, pe), pe;
                  }
                while (oe >= 1 && se >= 0);
              break;
            }
        }
      } finally {
        Ke = !1, $e.current = Y, ee(), Error.prepareStackTrace = V;
      }
      var xe = h ? h.displayName || h.name : "", ve = xe ? Xe(xe) : "";
      return typeof h == "function" && St.set(h, ve), ve;
    }
    function Hn(h, x, S) {
      return Rn(h, !1);
    }
    function an(h) {
      var x = h.prototype;
      return !!(x && x.isReactComponent);
    }
    function An(h, x, S) {
      if (h == null)
        return "";
      if (typeof h == "function")
        return Rn(h, an(h));
      if (typeof h == "string")
        return Xe(h);
      switch (h) {
        case Z:
          return Xe("Suspense");
        case he:
          return Xe("SuspenseList");
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case G:
            return Hn(h.render);
          case me:
            return An(h.type, x, S);
          case Me: {
            var M = h, V = M._payload, Y = M._init;
            try {
              return An(Y(V), x, S);
            } catch {
            }
          }
        }
      return "";
    }
    var Gn = Object.prototype.hasOwnProperty, qt = {}, mr = mt.ReactDebugCurrentFrame;
    function sn(h) {
      if (h) {
        var x = h._owner, S = An(h.type, h._source, x ? x.type : null);
        mr.setExtraStackFrame(S);
      } else
        mr.setExtraStackFrame(null);
    }
    function Yt(h, x, S, M, V) {
      {
        var Y = Function.call.bind(Gn);
        for (var ie in h)
          if (Y(h, ie)) {
            var k = void 0;
            try {
              if (typeof h[ie] != "function") {
                var ae = Error((M || "React class") + ": " + S + " type `" + ie + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[ie] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ae.name = "Invariant Violation", ae;
              }
              k = h[ie](x, ie, M, S, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (oe) {
              k = oe;
            }
            k && !(k instanceof Error) && (sn(V), Fe("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", M || "React class", S, ie, typeof k), sn(null)), k instanceof Error && !(k.message in qt) && (qt[k.message] = !0, sn(V), Fe("Failed %s type: %s", S, k.message), sn(null));
          }
      }
    }
    var Bt = Array.isArray;
    function hn(h) {
      return Bt(h);
    }
    function Nn(h) {
      {
        var x = typeof Symbol == "function" && Symbol.toStringTag, S = x && h[Symbol.toStringTag] || h.constructor.name || "Object";
        return S;
      }
    }
    function ur(h) {
      try {
        return dn(h), !1;
      } catch {
        return !0;
      }
    }
    function dn(h) {
      return "" + h;
    }
    function qn(h) {
      if (ur(h))
        return Fe("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Nn(h)), dn(h);
    }
    var rn = mt.ReactCurrentOwner, Tn = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, cr, wr, vn;
    vn = {};
    function lr(h) {
      if (Gn.call(h, "ref")) {
        var x = Object.getOwnPropertyDescriptor(h, "ref").get;
        if (x && x.isReactWarning)
          return !1;
      }
      return h.ref !== void 0;
    }
    function Vn(h) {
      if (Gn.call(h, "key")) {
        var x = Object.getOwnPropertyDescriptor(h, "key").get;
        if (x && x.isReactWarning)
          return !1;
      }
      return h.key !== void 0;
    }
    function Fn(h, x) {
      if (typeof h.ref == "string" && rn.current && x && rn.current.stateNode !== x) {
        var S = kt(rn.current.type);
        vn[S] || (Fe('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', kt(rn.current.type), h.ref), vn[S] = !0);
      }
    }
    function Jt(h, x) {
      {
        var S = function() {
          cr || (cr = !0, Fe("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", x));
        };
        S.isReactWarning = !0, Object.defineProperty(h, "key", {
          get: S,
          configurable: !0
        });
      }
    }
    function On(h, x) {
      {
        var S = function() {
          wr || (wr = !0, Fe("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", x));
        };
        S.isReactWarning = !0, Object.defineProperty(h, "ref", {
          get: S,
          configurable: !0
        });
      }
    }
    var Jn = function(h, x, S, M, V, Y, ie) {
      var k = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: h,
        key: x,
        ref: S,
        props: ie,
        // Record the component responsible for creating this element.
        _owner: Y
      };
      return k._store = {}, Object.defineProperty(k._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(k, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: M
      }), Object.defineProperty(k, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: V
      }), Object.freeze && (Object.freeze(k.props), Object.freeze(k)), k;
    };
    function hr(h, x, S, M, V) {
      {
        var Y, ie = {}, k = null, ae = null;
        S !== void 0 && (qn(S), k = "" + S), Vn(x) && (qn(x.key), k = "" + x.key), lr(x) && (ae = x.ref, Fn(x, V));
        for (Y in x)
          Gn.call(x, Y) && !Tn.hasOwnProperty(Y) && (ie[Y] = x[Y]);
        if (h && h.defaultProps) {
          var oe = h.defaultProps;
          for (Y in oe)
            ie[Y] === void 0 && (ie[Y] = oe[Y]);
        }
        if (k || ae) {
          var se = typeof h == "function" ? h.displayName || h.name || "Unknown" : h;
          k && Jt(ie, se), ae && On(ie, se);
        }
        return Jn(h, k, ae, V, M, rn.current, ie);
      }
    }
    var In = mt.ReactCurrentOwner, Er = mt.ReactDebugCurrentFrame;
    function _n(h) {
      if (h) {
        var x = h._owner, S = An(h.type, h._source, x ? x.type : null);
        Er.setExtraStackFrame(S);
      } else
        Er.setExtraStackFrame(null);
    }
    var Zn;
    Zn = !1;
    function Xn(h) {
      return typeof h == "object" && h !== null && h.$$typeof === r;
    }
    function Zt() {
      {
        if (In.current) {
          var h = kt(In.current.type);
          if (h)
            return `

Check the render method of \`` + h + "`.";
        }
        return "";
      }
    }
    function Dn(h) {
      return "";
    }
    var Bn = {};
    function Sr(h) {
      {
        var x = Zt();
        if (!x) {
          var S = typeof h == "string" ? h : h.displayName || h.name;
          S && (x = `

Check the top-level render call using <` + S + ">.");
        }
        return x;
      }
    }
    function Rr(h, x) {
      {
        if (!h._store || h._store.validated || h.key != null)
          return;
        h._store.validated = !0;
        var S = Sr(x);
        if (Bn[S])
          return;
        Bn[S] = !0;
        var M = "";
        h && h._owner && h._owner !== In.current && (M = " It was passed a child from " + kt(h._owner.type) + "."), _n(h), Fe('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', S, M), _n(null);
      }
    }
    function Ur(h, x) {
      {
        if (typeof h != "object")
          return;
        if (hn(h))
          for (var S = 0; S < h.length; S++) {
            var M = h[S];
            Xn(M) && Rr(M, x);
          }
        else if (Xn(h))
          h._store && (h._store.validated = !0);
        else if (h) {
          var V = Ge(h);
          if (typeof V == "function" && V !== h.entries)
            for (var Y = V.call(h), ie; !(ie = Y.next()).done; )
              Xn(ie.value) && Rr(ie.value, x);
        }
      }
    }
    function dr(h) {
      {
        var x = h.type;
        if (x == null || typeof x == "string")
          return;
        var S;
        if (typeof x == "function")
          S = x.propTypes;
        else if (typeof x == "object" && (x.$$typeof === G || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        x.$$typeof === me))
          S = x.propTypes;
        else
          return;
        if (S) {
          var M = kt(x);
          Yt(S, h.props, "prop", M, h);
        } else if (x.PropTypes !== void 0 && !Zn) {
          Zn = !0;
          var V = kt(x);
          Fe("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", V || "Unknown");
        }
        typeof x.getDefaultProps == "function" && !x.getDefaultProps.isReactClassApproved && Fe("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function $t(h) {
      {
        for (var x = Object.keys(h.props), S = 0; S < x.length; S++) {
          var M = x[S];
          if (M !== "children" && M !== "key") {
            _n(h), Fe("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", M), _n(null);
            break;
          }
        }
        h.ref !== null && (_n(h), Fe("Invalid attribute `ref` supplied to `React.Fragment`."), _n(null));
      }
    }
    var Ar = {};
    function u(h, x, S, M, V, Y) {
      {
        var ie = Mn(h);
        if (!ie) {
          var k = "";
          (h === void 0 || typeof h == "object" && h !== null && Object.keys(h).length === 0) && (k += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ae = Dn();
          ae ? k += ae : k += Zt();
          var oe;
          h === null ? oe = "null" : hn(h) ? oe = "array" : h !== void 0 && h.$$typeof === r ? (oe = "<" + (kt(h.type) || "Unknown") + " />", k = " Did you accidentally export a JSX literal instead of a component?") : oe = typeof h, Fe("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", oe, k);
        }
        var se = hr(h, x, S, V, Y);
        if (se == null)
          return se;
        if (ie) {
          var pe = x.children;
          if (pe !== void 0)
            if (M)
              if (hn(pe)) {
                for (var xe = 0; xe < pe.length; xe++)
                  Ur(pe[xe], h);
                Object.freeze && Object.freeze(pe);
              } else
                Fe("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ur(pe, h);
        }
        if (Gn.call(x, "key")) {
          var ve = kt(h), ce = Object.keys(x).filter(function(Q) {
            return Q !== "key";
          }), ne = ce.length > 0 ? "{key: someKey, " + ce.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ar[ve + ne]) {
            var ge = ce.length > 0 ? "{" + ce.join(": ..., ") + ": ...}" : "{}";
            Fe(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ne, ve, ge, ve), Ar[ve + ne] = !0;
          }
        }
        return h === s ? $t(se) : dr(se), se;
      }
    }
    function p(h, x, S) {
      return u(h, x, S, !0);
    }
    function d(h, x, S) {
      return u(h, x, S, !1);
    }
    var f = d, y = p;
    xo.Fragment = s, xo.jsx = f, xo.jsxs = y;
  }()), xo;
}
process.env.NODE_ENV === "production" ? S1() : R1();
var A1 = Object.defineProperty, T1 = (o, r, n) => r in o ? A1(o, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : o[r] = n, Eo = (o, r, n) => (T1(o, typeof r != "symbol" ? r + "" : r, n), n);
function sl(o, r) {
  let n;
  const s = () => {
    n !== void 0 && r && r(n), n = void 0;
  };
  return [() => n === void 0 ? n = o(s) : n, s];
}
class O1 {
  constructor(r, n = {}) {
    this.scope = r, this.options = n;
  }
  /**
   * Prints message into a console in case, logger is currently enabled.
   * @param level - log level.
   * @param args - arguments.
   */
  print(r, ...n) {
    const s = /* @__PURE__ */ new Date(), v = Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      fractionalSecondDigits: 3,
      timeZone: "UTC"
    }).format(s), { textColor: R, bgColor: I } = this.options, L = "font-weight: bold;padding: 0 5px;border-radius:5px";
    console[r](
      `%c${v}%c / %c${this.scope}`,
      `${L};background-color: lightblue;color:black`,
      "",
      `${L};${R ? `color:${R};` : ""}${I ? `background-color:${I}` : ""}`,
      ...n
    );
  }
  /**
   * Prints error message into a console.
   * @param args
   */
  error(...r) {
    this.print("error", ...r);
  }
  /**
   * Prints log message into a console.
   * @param args
   */
  log(...r) {
    this.print("log", ...r);
  }
}
const I1 = new O1("SDK", {
  bgColor: "forestgreen",
  textColor: "white"
});
class Cc {
  constructor() {
    Eo(this, "listeners", /* @__PURE__ */ new Map()), Eo(this, "listenersCount", 0), Eo(this, "subscribeListeners", []);
  }
  /**
   * Removes all event listeners.
   */
  clear() {
    this.listeners.clear(), this.subscribeListeners = [];
  }
  /**
   * Returns count of bound listeners.
   */
  get count() {
    return this.listenersCount + this.subscribeListeners.length;
  }
  emit(r, ...n) {
    this.subscribeListeners.forEach((s) => s({
      event: r,
      args: n
    })), (this.listeners.get(r) || []).forEach(([s, v]) => {
      s(...n), v && this.off(r, s);
    });
  }
  /**
   * Adds new event listener.
   * @param event - event name.
   * @param listener - event listener.
   * @param once - should listener be called only once.
   * @returns Function to remove bound event listener.
   */
  on(r, n, s) {
    let v = this.listeners.get(r);
    return v || this.listeners.set(r, v = []), v.push([n, s]), this.listenersCount += 1, () => this.off(r, n);
  }
  /**
   * Removes event listener. In case, specified listener was bound several times, it removes
   * only a single one.
   * @param event - event name.
   * @param listener - event listener.
   */
  off(r, n) {
    const s = this.listeners.get(r) || [];
    for (let v = 0; v < s.length; v += 1)
      if (n === s[v][0]) {
        s.splice(v, 1), this.listenersCount -= 1;
        return;
      }
  }
  /**
   * Adds a new event listener for all events.
   * @param listener - event listener.
   * @returns Function to remove event listener.
   */
  subscribe(r) {
    return this.subscribeListeners.push(r), () => this.unsubscribe(r);
  }
  /**
   * Removes global event listener. In case, specified listener was bound several times, it removes
   * only a single one.
   * @param listener - event listener.
   */
  unsubscribe(r) {
    for (let n = 0; n < this.subscribeListeners.length; n += 1)
      if (this.subscribeListeners[n] === r) {
        this.subscribeListeners.splice(n, 1);
        return;
      }
  }
}
function Uc(o, r, n) {
  return window.addEventListener(o, r, n), () => window.removeEventListener(o, r, n);
}
function ps(...o) {
  let r = !1;
  const n = o.flat(1);
  return [
    (s) => !r && n.push(s),
    () => {
      r || (r = !0, n.forEach((s) => s()));
    },
    r
  ];
}
class gs extends Error {
  constructor(r, n, s) {
    super(n, { cause: s }), this.type = r, Object.setPrototypeOf(this, gs.prototype);
  }
}
function gi(o, r, n) {
  return new gs(o, r, n);
}
const P1 = "ERR_METHOD_UNSUPPORTED", C1 = "ERR_METHOD_PARAMETER_UNSUPPORTED", U1 = "ERR_UNKNOWN_ENV", L1 = "ERR_TIMED_OUT", M1 = "ERR_UNEXPECTED_TYPE", ul = "ERR_PARSE";
function Ao() {
  return gi(M1, "Value has unexpected type");
}
class vs {
  constructor(r, n, s) {
    this.parser = r, this.isOptional = n, this.type = s;
  }
  /**
   * Attempts to parse passed value
   * @param value - value to parse.
   * @throws {SDKError} ERR_PARSE
   * @see ERR_PARSE
   */
  parse(r) {
    if (!(this.isOptional && r === void 0))
      try {
        return this.parser(r);
      } catch (n) {
        throw gi(
          ul,
          `Unable to parse value${this.type ? ` as ${this.type}` : ""}`,
          n
        );
      }
  }
  optional() {
    return this.isOptional = !0, this;
  }
}
function Gi(o, r) {
  return () => new vs(o, !1, r);
}
const ei = Gi((o) => {
  if (typeof o == "boolean")
    return o;
  const r = String(o);
  if (r === "1" || r === "true")
    return !0;
  if (r === "0" || r === "false")
    return !1;
  throw Ao();
}, "boolean");
function cl(o, r) {
  const n = {};
  for (const s in o) {
    const v = o[s];
    if (!v)
      continue;
    let R, I;
    if (typeof v == "function" || "parse" in v)
      R = s, I = typeof v == "function" ? v : v.parse.bind(v);
    else {
      const { type: L } = v;
      R = v.from || s, I = typeof L == "function" ? L : L.parse.bind(L);
    }
    try {
      const L = I(r(R));
      L !== void 0 && (n[s] = L);
    } catch (L) {
      throw gi(ul, `Unable to parse field "${s}"`, L);
    }
  }
  return n;
}
function ll(o) {
  let r = o;
  if (typeof r == "string" && (r = JSON.parse(r)), typeof r != "object" || r === null || Array.isArray(r))
    throw Ao();
  return r;
}
function pi(o, r) {
  return new vs((n) => {
    const s = ll(n);
    return cl(o, (v) => s[v]);
  }, !1, r);
}
const Wi = Gi((o) => {
  if (typeof o == "number")
    return o;
  if (typeof o == "string") {
    const r = Number(o);
    if (!Number.isNaN(r))
      return r;
  }
  throw Ao();
}, "number"), Ct = Gi((o) => {
  if (typeof o == "string" || typeof o == "number")
    return o.toString();
  throw Ao();
}, "string");
function $1(o) {
  return pi({
    eventType: Ct(),
    eventData: (r) => r
  }).parse(o);
}
function N1() {
  ["TelegramGameProxy_receiveEvent", "TelegramGameProxy", "Telegram"].forEach((o) => {
    delete window[o];
  });
}
function F1(o, r) {
  window.dispatchEvent(new MessageEvent("message", {
    data: JSON.stringify({ eventType: o, eventData: r }),
    // We specify window.parent to imitate the case, the parent iframe sent us this event.
    source: window.parent
  }));
}
function D1() {
  [
    ["TelegramGameProxy_receiveEvent"],
    // Windows Phone.
    ["TelegramGameProxy", "receiveEvent"],
    // Desktop.
    ["Telegram", "WebView", "receiveEvent"]
    // Android and iOS.
  ].forEach((o) => {
    let r = window;
    o.forEach((n, s, v) => {
      if (s === v.length - 1) {
        r[n] = F1;
        return;
      }
      n in r || (r[n] = {}), r = r[n];
    });
  });
}
const B1 = {
  clipboard_text_received: pi({
    req_id: Ct(),
    data: (o) => o === null ? o : Ct().optional().parse(o)
  }),
  custom_method_invoked: pi({
    req_id: Ct(),
    result: (o) => o,
    error: Ct().optional()
  }),
  popup_closed: {
    parse(o) {
      return pi({
        button_id: (r) => r == null ? void 0 : Ct().parse(r)
      }).parse(o ?? {});
    }
  },
  viewport_changed: pi({
    height: Wi(),
    width: (o) => o == null ? window.innerWidth : Wi().parse(o),
    is_state_stable: ei(),
    is_expanded: ei()
  })
};
function W1() {
  const o = new Cc(), r = new Cc();
  r.subscribe((s) => {
    o.emit("event", { name: s.event, payload: s.args[0] });
  }), D1();
  const [, n] = ps(
    // Don't forget to remove created handlers.
    N1,
    // Add "resize" event listener to make sure, we always have fresh viewport information.
    // Desktop version of Telegram is sometimes not sending the viewport_changed
    // event. For example, when the MainButton is shown. That's why we should
    // add our own listener to make sure, viewport information is always fresh.
    // Issue: https://github.com/Telegram-Mini-Apps/telegram-apps/issues/10
    Uc("resize", () => {
      r.emit("viewport_changed", {
        width: window.innerWidth,
        height: window.innerHeight,
        is_state_stable: !0,
        is_expanded: !0
      });
    }),
    // Add listener, which handles events sent from the Telegram web application and also events
    // generated by the local emitEvent function.
    Uc("message", (s) => {
      if (s.source !== window.parent)
        return;
      let v;
      try {
        v = $1(s.data);
      } catch {
        return;
      }
      const { eventType: R, eventData: I } = v, L = B1[R];
      try {
        const G = L ? L.parse(I) : I;
        r.emit(...G ? [R, G] : [R]);
      } catch (G) {
        I1.error(
          `An error occurred processing the "${R}" event from the Telegram application.
Please, file an issue here:
https://github.com/Telegram-Mini-Apps/telegram-apps/issues/new/choose`,
          v,
          G
        );
      }
    }),
    // Clear emitters.
    () => o.clear(),
    () => r.clear()
  );
  return [{
    on: r.on.bind(r),
    off: r.off.bind(r),
    subscribe(s) {
      return o.on("event", s);
    },
    unsubscribe(s) {
      o.off("event", s);
    },
    get count() {
      return r.count + o.count;
    }
  }, n];
}
const [j1, Hy] = sl(
  (o) => {
    const [r, n] = W1(), s = r.off.bind(r);
    return r.off = (v, R) => {
      const { count: I } = r;
      s(v, R), I && !r.count && o();
    }, [r, n];
  },
  ([, o]) => o()
);
function k1() {
  return j1()[0];
}
function K1(o, r, n) {
  return k1().on(o, r, n);
}
function _s(o) {
  return typeof o == "object" && o !== null && !Array.isArray(o);
}
function Y1(o, r) {
  const n = o.split("."), s = r.split("."), v = Math.max(n.length, s.length);
  for (let R = 0; R < v; R += 1) {
    const I = parseInt(n[R] || "0", 10), L = parseInt(s[R] || "0", 10);
    if (I !== L)
      return I > L ? 1 : -1;
  }
  return 0;
}
function fr(o, r) {
  return Y1(o, r) <= 0;
}
function ji(o, r, n) {
  if (typeof n == "string") {
    if (o === "web_app_open_link") {
      if (r === "try_instant_view")
        return fr("6.4", n);
      if (r === "try_browser")
        return fr("7.6", n);
    }
    if (o === "web_app_set_header_color" && r === "color")
      return fr("6.9", n);
    if (o === "web_app_close" && r === "return_back")
      return fr("7.6", n);
  }
  switch (o) {
    case "web_app_open_tg_link":
    case "web_app_open_invoice":
    case "web_app_setup_back_button":
    case "web_app_set_background_color":
    case "web_app_set_header_color":
    case "web_app_trigger_haptic_feedback":
      return fr("6.1", r);
    case "web_app_open_popup":
      return fr("6.2", r);
    case "web_app_close_scan_qr_popup":
    case "web_app_open_scan_qr_popup":
    case "web_app_read_text_from_clipboard":
      return fr("6.4", r);
    case "web_app_switch_inline_query":
      return fr("6.7", r);
    case "web_app_invoke_custom_method":
    case "web_app_request_write_access":
    case "web_app_request_phone":
      return fr("6.9", r);
    case "web_app_setup_settings_button":
      return fr("6.10", r);
    case "web_app_biometry_get_info":
    case "web_app_biometry_open_settings":
    case "web_app_biometry_request_access":
    case "web_app_biometry_request_auth":
    case "web_app_biometry_update_token":
      return fr("7.2", r);
    case "web_app_setup_swipe_behavior":
      return fr("7.7", r);
    default:
      return [
        "iframe_ready",
        "iframe_will_reload",
        "web_app_close",
        "web_app_data_send",
        "web_app_expand",
        "web_app_open_link",
        "web_app_ready",
        "web_app_request_theme",
        "web_app_request_viewport",
        "web_app_setup_main_button",
        "web_app_setup_closing_behavior"
      ].includes(o);
  }
}
function z1(o) {
  return "external" in o && _s(o.external) && "notify" in o.external && typeof o.external.notify == "function";
}
function hl(o) {
  return "TelegramWebviewProxy" in o && _s(o.TelegramWebviewProxy) && "postEvent" in o.TelegramWebviewProxy && typeof o.TelegramWebviewProxy.postEvent == "function";
}
function H1() {
  try {
    return window.self !== window.top;
  } catch {
    return !0;
  }
}
const G1 = "https://web.telegram.org";
let q1 = G1;
function V1() {
  return q1;
}
function dl(o, r, n) {
  let s = {}, v;
  if (!r && !n ? s = {} : r && n ? (s = n, v = r) : r && ("targetOrigin" in r ? s = r : v = r), H1())
    return window.parent.postMessage(
      JSON.stringify({ eventType: o, eventData: v }),
      s.targetOrigin || V1()
    );
  if (z1(window)) {
    window.external.notify(JSON.stringify({ eventType: o, eventData: v }));
    return;
  }
  if (hl(window)) {
    window.TelegramWebviewProxy.postEvent(o, JSON.stringify(v));
    return;
  }
  throw gi(
    U1,
    "Unable to determine current environment and possible way to send event. You are probably trying to use Mini Apps method outside the Telegram application environment."
  );
}
function J1(o) {
  return (r, n) => {
    if (!ji(r, o))
      throw gi(P1, `Method "${r}" is unsupported in Mini Apps version ${o}`);
    if (_s(n) && r === "web_app_set_header_color" && "color" in n && !ji(r, "color", o))
      throw gi(
        C1,
        `Parameter "color" of "${r}" method is unsupported in Mini Apps version ${o}`
      );
    return dl(r, n);
  };
}
function Z1(o) {
  return ({ req_id: r }) => r === o;
}
function X1(o) {
  return gi(L1, `Timeout reached: ${o}ms`);
}
function Q1(o, r) {
  return Promise.race([
    typeof o == "function" ? o() : o,
    new Promise((n, s) => {
      setTimeout(() => {
        s(X1(r));
      }, r);
    })
  ]);
}
async function pl(o) {
  let r;
  const n = new Promise((L) => r = L), { event: s, capture: v, timeout: R } = o, [, I] = ps(
    // We need to iterate over all tracked events, and create their event listeners.
    (Array.isArray(s) ? s : [s]).map((L) => K1(L, (G) => {
      (!v || (Array.isArray(s) ? v({
        event: L,
        payload: G
      }) : v(G))) && r(G);
    }))
  );
  try {
    return (o.postEvent || dl)(o.method, o.params), await (R ? Q1(n, R) : n);
  } finally {
    I();
  }
}
function e_(o) {
  return /^#[\da-f]{6}$/i.test(o);
}
function t_(o) {
  return /^#[\da-f]{3}$/i.test(o);
}
function n_(o) {
  const r = o.replace(/\s/g, "").toLowerCase();
  if (e_(r))
    return r;
  if (t_(r)) {
    let s = "#";
    for (let v = 0; v < 3; v += 1)
      s += r[1 + v].repeat(2);
    return s;
  }
  const n = r.match(/^rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)$/) || r.match(/^rgba\((\d{1,3}),(\d{1,3}),(\d{1,3}),\d{1,3}\)$/);
  if (!n)
    throw new Error(`Value "${o}" does not satisfy any of known RGB formats.`);
  return n.slice(1).reduce((s, v) => {
    const R = parseInt(v, 10).toString(16);
    return s + (R.length === 1 ? "0" : "") + R;
  }, "#");
}
function r_(o, r) {
  return (n) => ji(r[n], o);
}
const i_ = Gi((o) => o instanceof Date ? o : new Date(Wi().parse(o) * 1e3), "Date");
function gl(o, r) {
  return new vs((n) => {
    if (typeof n != "string" && !(n instanceof URLSearchParams))
      throw Ao();
    const s = typeof n == "string" ? new URLSearchParams(n) : n;
    return cl(o, (v) => {
      const R = s.get(v);
      return R === null ? void 0 : R;
    });
  }, !1, r);
}
const o_ = pi({
  id: Wi(),
  type: Ct(),
  title: Ct(),
  photoUrl: {
    type: Ct().optional(),
    from: "photo_url"
  },
  username: Ct().optional()
}, "Chat").optional(), Lc = pi({
  addedToAttachmentMenu: {
    type: ei().optional(),
    from: "added_to_attachment_menu"
  },
  allowsWriteToPm: {
    type: ei().optional(),
    from: "allows_write_to_pm"
  },
  firstName: {
    type: Ct(),
    from: "first_name"
  },
  id: Wi(),
  isBot: {
    type: ei().optional(),
    from: "is_bot"
  },
  isPremium: {
    type: ei().optional(),
    from: "is_premium"
  },
  languageCode: {
    type: Ct().optional(),
    from: "language_code"
  },
  lastName: {
    type: Ct().optional(),
    from: "last_name"
  },
  photoUrl: {
    type: Ct().optional(),
    from: "photo_url"
  },
  username: Ct().optional()
}, "User").optional();
function f_() {
  return gl({
    authDate: {
      type: i_(),
      from: "auth_date"
    },
    canSendAfter: {
      type: Wi().optional(),
      from: "can_send_after"
    },
    chat: o_,
    chatInstance: {
      type: Ct().optional(),
      from: "chat_instance"
    },
    chatType: {
      type: Ct().optional(),
      from: "chat_type"
    },
    hash: Ct(),
    queryId: {
      type: Ct().optional(),
      from: "query_id"
    },
    receiver: Lc,
    startParam: {
      type: Ct().optional(),
      from: "start_param"
    },
    user: Lc
  }, "InitData");
}
const a_ = Gi((o) => n_(Ct().parse(o)), "rgb");
function s_(o) {
  return o.replace(/_[a-z]/g, (r) => r[1].toUpperCase());
}
function u_(o) {
  return o.replace(/[A-Z]/g, (r) => `_${r.toLowerCase()}`);
}
const c_ = Gi(
  (o) => {
    const r = a_().optional();
    return Object.entries(ll(o)).reduce((n, [s, v]) => (n[s_(s)] = r.parse(v), n), {});
  },
  "ThemeParams"
);
function vl(o) {
  return gl({
    botInline: {
      type: ei().optional(),
      from: "tgWebAppBotInline"
    },
    initData: {
      type: f_().optional(),
      from: "tgWebAppData"
    },
    initDataRaw: {
      type: Ct().optional(),
      from: "tgWebAppData"
    },
    platform: {
      type: Ct(),
      from: "tgWebAppPlatform"
    },
    showSettings: {
      type: ei().optional(),
      from: "tgWebAppShowSettings"
    },
    startParam: {
      type: Ct().optional(),
      from: "tgWebAppStartParam"
    },
    themeParams: {
      type: c_(),
      from: "tgWebAppThemeParams"
    },
    version: {
      type: Ct(),
      from: "tgWebAppVersion"
    }
  }).parse(o);
}
function _l(o) {
  return vl(
    o.replace(/^[^?#]*[?#]/, "").replace(/[?#]/g, "&")
  );
}
function l_() {
  return _l(window.location.href);
}
function yl() {
  return performance.getEntriesByType("navigation")[0];
}
function h_() {
  const o = yl();
  if (!o)
    throw new Error("Unable to get first navigation entry.");
  return _l(o.name);
}
function xl(o) {
  return `telegram-apps/${o.replace(/[A-Z]/g, (r) => `-${r.toLowerCase()}`)}`;
}
function bl(o, r) {
  sessionStorage.setItem(xl(o), JSON.stringify(r));
}
function ml(o) {
  const r = sessionStorage.getItem(xl(o));
  try {
    return r ? JSON.parse(r) : void 0;
  } catch {
  }
}
function d_() {
  return vl(ml("launchParams") || "");
}
function p_(o) {
  return JSON.stringify(
    Object.fromEntries(
      Object.entries(o).map(([r, n]) => [u_(r), n])
    )
  );
}
function g_(o) {
  const {
    initDataRaw: r,
    themeParams: n,
    platform: s,
    version: v,
    showSettings: R,
    startParam: I,
    botInline: L
  } = o, G = new URLSearchParams();
  return G.set("tgWebAppPlatform", s), G.set("tgWebAppThemeParams", p_(n)), G.set("tgWebAppVersion", v), r && G.set("tgWebAppData", r), I && G.set("tgWebAppStartParam", I), typeof R == "boolean" && G.set("tgWebAppShowSettings", R ? "1" : "0"), typeof L == "boolean" && G.set("tgWebAppBotInline", L ? "1" : "0"), G.toString();
}
function v_(o) {
  bl("launchParams", g_(o));
}
function __() {
  const o = [];
  for (const r of [
    // Try to retrieve launch parameters from the current location. This method can return
    // nothing in case, location was changed, and then the page was reloaded.
    l_,
    // Then, try using the lower level API - window.performance.
    h_,
    // Finally, try to extract launch parameters from the session storage.
    d_
  ])
    try {
      const n = r();
      return v_(n), n;
    } catch (n) {
      o.push(n instanceof Error ? n.message : JSON.stringify(n));
    }
  throw new Error([
    `Unable to retrieve launch parameters from any known source. Perhaps, you have opened your app outside Telegram?
`,
    "📖 Refer to docs for more information:",
    `https://docs.telegram-mini-apps.com/packages/telegram-apps-sdk/environment
`,
    "Collected errors:",
    o.map((r) => `— ${r}`)
  ].join(`
`));
}
function y_() {
  const o = yl();
  return !!(o && o.type === "reload");
}
function x_() {
  let o = 0;
  return () => (o += 1).toString();
}
const [b_] = sl(x_);
function m_(o, r) {
  return () => {
    const n = __(), s = {
      ...n,
      postEvent: J1(n.version),
      createRequestId: b_()
    };
    if (typeof o == "function")
      return o(s);
    const [v, R, I] = ps(), L = r({
      ...s,
      // State should only be passed only in case, current page was reloaded. If we don't add
      // this check, state restoration will work improperly in the web version of Telegram,
      // when we are always working in the same "session" (tab).
      state: y_() ? ml(o) : void 0,
      addCleanup: v
    }), G = (Z) => (I || v(
      Z.on("change", (he) => {
        bl(o, he);
      })
    ), Z);
    return [
      L instanceof Promise ? L.then(G) : G(L),
      R
    ];
  };
}
class w_ {
  constructor(r, n) {
    Eo(this, "supports"), this.supports = r_(r, n);
  }
}
function E_(o, r) {
  return (n) => {
    const [s, v] = r[n];
    return ji(s, v, o);
  };
}
function Mc(o, r) {
  return o.startsWith(r) ? o : `${r}${o}`;
}
function S_(o) {
  return new URL(
    typeof o == "string" ? o : `${o.pathname || ""}${Mc(o.search || "", "?")}${Mc(o.hash || "", "#")}`,
    "http://a"
  );
}
class R_ extends w_ {
  constructor(r, n, s) {
    super(r, { readTextFromClipboard: "web_app_read_text_from_clipboard" }), Eo(this, "supportsParam"), this.version = r, this.createRequestId = n, this.postEvent = s, this.supportsParam = E_(r, {
      "openLink.tryInstantView": ["web_app_open_link", "try_instant_view"]
    });
  }
  openLink(r, n) {
    const s = S_(r).toString();
    if (!ji("web_app_open_link", this.version)) {
      window.open(s, "_blank");
      return;
    }
    const v = typeof n == "boolean" ? { tryInstantView: n } : n || {};
    this.postEvent("web_app_open_link", {
      url: s,
      try_browser: v.tryBrowser,
      try_instant_view: v.tryInstantView
    });
  }
  /**
   * Opens a Telegram link inside Telegram app. The Mini App will be closed. It expects passing
   * link in full format, with hostname "t.me".
   * @param url - URL to be opened.
   * @throws {Error} URL has not allowed hostname.
   */
  openTelegramLink(r) {
    const { hostname: n, pathname: s, search: v } = new URL(r, "https://t.me");
    if (n !== "t.me")
      throw new Error(`URL has not allowed hostname: ${n}. Only "t.me" is allowed`);
    if (!ji("web_app_open_tg_link", this.version)) {
      window.location.href = r;
      return;
    }
    this.postEvent("web_app_open_tg_link", { path_full: s + v });
  }
  /**
   * Reads text from clipboard and returns string or null. null is returned
   * in cases:
   * - Value in clipboard is not text
   * - Access to clipboard is not allowed
   */
  async readTextFromClipboard() {
    const r = this.createRequestId(), {
      data: n = null
    } = await pl({
      method: "web_app_read_text_from_clipboard",
      event: "clipboard_text_received",
      postEvent: this.postEvent,
      params: { req_id: r },
      capture: Z1(r)
    });
    return n;
  }
  /**
   * Shares specified URL with the passed to the chats, selected by user. After being called,
   * it closes the mini application.
   *
   * This method uses Telegram's Share Links.
   * @param url - URL to share.
   * @param text - text to append after the URL.
   * @see https://core.telegram.org/api/links#share-links
   * @see https://core.telegram.org/widgets/share#custom-buttons
   */
  shareURL(r, n) {
    this.openTelegramLink(
      "https://t.me/share/url?" + new URLSearchParams({ url: r, text: n || "" }).toString().replace(/\+/g, "%20")
    );
  }
}
const ys = m_(
  ({ version: o, postEvent: r, createRequestId: n }) => new R_(o, n, r)
);
async function wl() {
  if (hl(window))
    return !0;
  try {
    return await pl({ method: "web_app_request_theme", event: "theme_changed", timeout: 100 }), !0;
  } catch {
    return !1;
  }
}
ds.createContext(void 0);
const Kr = "OmniConnect", Vt = "Verification", ki = "OMNICONNECTION_CACHE", A_ = "https://omni-connect-bridge.bgwapi.io/bridge", $c = "https://t.me/BitgetWallet_TGBot/BGW";
function T_(o) {
  return o.replaceAll(".", "%2E").replaceAll("-", "%2D").replaceAll("_", "%5F").replaceAll("&", "-").replaceAll("=", "__").replaceAll("%", "--");
}
async function Nc(o) {
  await wl() ? ys().openTelegramLink(o) : window.open(o, "_blank", "noreferrer noopener");
}
const Ki = () => typeof window < "u" && typeof window.localStorage < "u" ? window.localStorage : localStorage;
function En(o, r) {
  if (!o)
    throw new Error(`[${Kr}] ${r}`);
}
function O_(o) {
  return o ? Array.prototype.map.call(o, (r) => ("00" + r.toString(16)).slice(-2)).join("") : "";
}
var Af = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Af.exports;
(function(o, r) {
  (function() {
    var n, s = "4.17.21", v = 200, R = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", I = "Expected a function", L = "Invalid `variable` option passed into `_.template`", G = "__lodash_hash_undefined__", Z = 500, he = "__lodash_placeholder__", me = 1, Me = 2, be = 4, tt = 1, We = 2, Ge = 1, mt = 2, Fe = 4, yt = 8, ft = 16, nt = 32, ht = 64, Ut = 128, nn = 256, Sn = 512, Mn = 30, zn = "...", $n = 800, kt = 16, Kt = 1, Lt = 2, Mt = 3, de = 1 / 0, It = 9007199254740991, ln = 17976931348623157e292, fn = NaN, O = 4294967295, J = O - 1, Ee = O >>> 1, Oe = [
      ["ary", Ut],
      ["bind", Ge],
      ["bindKey", mt],
      ["curry", yt],
      ["curryRight", ft],
      ["flip", Sn],
      ["partial", nt],
      ["partialRight", ht],
      ["rearg", nn]
    ], ee = "[object Arguments]", $e = "[object Array]", st = "[object AsyncFunction]", Xe = "[object Boolean]", Ke = "[object Date]", St = "[object DOMException]", sr = "[object Error]", Rn = "[object Function]", Hn = "[object GeneratorFunction]", an = "[object Map]", An = "[object Number]", Gn = "[object Null]", qt = "[object Object]", mr = "[object Promise]", sn = "[object Proxy]", Yt = "[object RegExp]", Bt = "[object Set]", hn = "[object String]", Nn = "[object Symbol]", ur = "[object Undefined]", dn = "[object WeakMap]", qn = "[object WeakSet]", rn = "[object ArrayBuffer]", Tn = "[object DataView]", cr = "[object Float32Array]", wr = "[object Float64Array]", vn = "[object Int8Array]", lr = "[object Int16Array]", Vn = "[object Int32Array]", Fn = "[object Uint8Array]", Jt = "[object Uint8ClampedArray]", On = "[object Uint16Array]", Jn = "[object Uint32Array]", hr = /\b__p \+= '';/g, In = /\b(__p \+=) '' \+/g, Er = /(__e\(.*?\)|\b__t\)) \+\n'';/g, _n = /&(?:amp|lt|gt|quot|#39);/g, Zn = /[&<>"']/g, Xn = RegExp(_n.source), Zt = RegExp(Zn.source), Dn = /<%-([\s\S]+?)%>/g, Bn = /<%([\s\S]+?)%>/g, Sr = /<%=([\s\S]+?)%>/g, Rr = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ur = /^\w*$/, dr = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, $t = /[\\^$.*+?()[\]{}|]/g, Ar = RegExp($t.source), u = /^\s+/, p = /\s/, d = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, f = /\{\n\/\* \[wrapped with (.+)\] \*/, y = /,? & /, h = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, x = /[()=,{}\[\]\/\s]/, S = /\\(\\)?/g, M = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, V = /\w*$/, Y = /^[-+]0x[0-9a-f]+$/i, ie = /^0b[01]+$/i, k = /^\[object .+?Constructor\]$/, ae = /^0o[0-7]+$/i, oe = /^(?:0|[1-9]\d*)$/, se = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, pe = /($^)/, xe = /['\n\r\u2028\u2029\\]/g, ve = "\\ud800-\\udfff", ce = "\\u0300-\\u036f", ne = "\\ufe20-\\ufe2f", ge = "\\u20d0-\\u20ff", Q = ce + ne + ge, re = "\\u2700-\\u27bf", fe = "a-z\\xdf-\\xf6\\xf8-\\xff", X = "\\xac\\xb1\\xd7\\xf7", C = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", U = "\\u2000-\\u206f", K = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", D = "A-Z\\xc0-\\xd6\\xd8-\\xde", B = "\\ufe0e\\ufe0f", H = X + C + U + K, ye = "['’]", Ue = "[" + ve + "]", Ie = "[" + H + "]", Se = "[" + Q + "]", b = "\\d+", Le = "[" + re + "]", je = "[" + fe + "]", qe = "[^" + ve + H + b + re + fe + D + "]", Pe = "\\ud83c[\\udffb-\\udfff]", Ve = "(?:" + Se + "|" + Pe + ")", ze = "[^" + ve + "]", dt = "(?:\\ud83c[\\udde6-\\uddff]){2}", rt = "[\\ud800-\\udbff][\\udc00-\\udfff]", ut = "[" + D + "]", pt = "\\u200d", Rt = "(?:" + je + "|" + qe + ")", wt = "(?:" + ut + "|" + qe + ")", Nt = "(?:" + ye + "(?:d|ll|m|re|s|t|ve))?", Wt = "(?:" + ye + "(?:D|LL|M|RE|S|T|VE))?", zt = Ve + "?", To = "[" + B + "]?", Oo = "(?:" + pt + "(?:" + [ze, dt, rt].join("|") + ")" + To + zt + ")*", Nf = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Io = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Vi = To + zt + Oo, Po = "(?:" + [Le, dt, rt].join("|") + ")" + Vi, Ff = "(?:" + [ze + Se + "?", Se, dt, rt, Ue].join("|") + ")", Co = RegExp(ye, "g"), Uo = RegExp(Se, "g"), Ji = RegExp(Pe + "(?=" + Pe + ")|" + Ff + Vi, "g"), Df = RegExp([
      ut + "?" + je + "+" + Nt + "(?=" + [Ie, ut, "$"].join("|") + ")",
      wt + "+" + Wt + "(?=" + [Ie, ut + Rt, "$"].join("|") + ")",
      ut + "?" + Rt + "+" + Nt,
      ut + "+" + Wt,
      Io,
      Nf,
      b,
      Po
    ].join("|"), "g"), Bf = RegExp("[" + pt + ve + Q + B + "]"), Lo = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, vi = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Wf = -1, ct = {};
    ct[cr] = ct[wr] = ct[vn] = ct[lr] = ct[Vn] = ct[Fn] = ct[Jt] = ct[On] = ct[Jn] = !0, ct[ee] = ct[$e] = ct[rn] = ct[Xe] = ct[Tn] = ct[Ke] = ct[sr] = ct[Rn] = ct[an] = ct[An] = ct[qt] = ct[Yt] = ct[Bt] = ct[hn] = ct[dn] = !1;
    var xt = {};
    xt[ee] = xt[$e] = xt[rn] = xt[Tn] = xt[Xe] = xt[Ke] = xt[cr] = xt[wr] = xt[vn] = xt[lr] = xt[Vn] = xt[an] = xt[An] = xt[qt] = xt[Yt] = xt[Bt] = xt[hn] = xt[Nn] = xt[Fn] = xt[Jt] = xt[On] = xt[Jn] = !0, xt[sr] = xt[Rn] = xt[dn] = !1;
    var Mo = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, _i = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Zi = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Xi = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Qi = parseFloat, jf = parseInt, $o = typeof di == "object" && di && di.Object === Object && di, kf = typeof self == "object" && self && self.Object === Object && self, Xt = $o || kf || Function("return this")(), c = r && !r.nodeType && r, w = c && !0 && o && !o.nodeType && o, P = w && w.exports === c, N = P && $o.process, q = function() {
      try {
        var A = w && w.require && w.require("util").types;
        return A || N && N.binding && N.binding("util");
      } catch {
      }
    }(), we = q && q.isArrayBuffer, le = q && q.isDate, Ce = q && q.isMap, Qe = q && q.isRegExp, gt = q && q.isSet, At = q && q.isTypedArray;
    function Je(A, F, $) {
      switch ($.length) {
        case 0:
          return A.call(F);
        case 1:
          return A.call(F, $[0]);
        case 2:
          return A.call(F, $[0], $[1]);
        case 3:
          return A.call(F, $[0], $[1], $[2]);
      }
      return A.apply(F, $);
    }
    function Pt(A, F, $, ue) {
      for (var Ne = -1, lt = A == null ? 0 : A.length; ++Ne < lt; ) {
        var en = A[Ne];
        F(ue, en, $(en), A);
      }
      return ue;
    }
    function at(A, F) {
      for (var $ = -1, ue = A == null ? 0 : A.length; ++$ < ue && F(A[$], $, A) !== !1; )
        ;
      return A;
    }
    function Qt(A, F) {
      for (var $ = A == null ? 0 : A.length; $-- && F(A[$], $, A) !== !1; )
        ;
      return A;
    }
    function ti(A, F) {
      for (var $ = -1, ue = A == null ? 0 : A.length; ++$ < ue; )
        if (!F(A[$], $, A))
          return !1;
      return !0;
    }
    function Qn(A, F) {
      for (var $ = -1, ue = A == null ? 0 : A.length, Ne = 0, lt = []; ++$ < ue; ) {
        var en = A[$];
        F(en, $, A) && (lt[Ne++] = en);
      }
      return lt;
    }
    function ni(A, F) {
      var $ = A == null ? 0 : A.length;
      return !!$ && xi(A, F, 0) > -1;
    }
    function eo(A, F, $) {
      for (var ue = -1, Ne = A == null ? 0 : A.length; ++ue < Ne; )
        if ($(F, A[ue]))
          return !0;
      return !1;
    }
    function Tt(A, F) {
      for (var $ = -1, ue = A == null ? 0 : A.length, Ne = Array(ue); ++$ < ue; )
        Ne[$] = F(A[$], $, A);
      return Ne;
    }
    function Tr(A, F) {
      for (var $ = -1, ue = F.length, Ne = A.length; ++$ < ue; )
        A[Ne + $] = F[$];
      return A;
    }
    function yi(A, F, $, ue) {
      var Ne = -1, lt = A == null ? 0 : A.length;
      for (ue && lt && ($ = A[++Ne]); ++Ne < lt; )
        $ = F($, A[Ne], Ne, A);
      return $;
    }
    function Kf(A, F, $, ue) {
      var Ne = A == null ? 0 : A.length;
      for (ue && Ne && ($ = A[--Ne]); Ne--; )
        $ = F($, A[Ne], Ne, A);
      return $;
    }
    function Yf(A, F) {
      for (var $ = -1, ue = A == null ? 0 : A.length; ++$ < ue; )
        if (F(A[$], $, A))
          return !0;
      return !1;
    }
    var Hl = zf("length");
    function Gl(A) {
      return A.split("");
    }
    function ql(A) {
      return A.match(h) || [];
    }
    function Os(A, F, $) {
      var ue;
      return $(A, function(Ne, lt, en) {
        if (F(Ne, lt, en))
          return ue = lt, !1;
      }), ue;
    }
    function No(A, F, $, ue) {
      for (var Ne = A.length, lt = $ + (ue ? 1 : -1); ue ? lt-- : ++lt < Ne; )
        if (F(A[lt], lt, A))
          return lt;
      return -1;
    }
    function xi(A, F, $) {
      return F === F ? fh(A, F, $) : No(A, Is, $);
    }
    function Vl(A, F, $, ue) {
      for (var Ne = $ - 1, lt = A.length; ++Ne < lt; )
        if (ue(A[Ne], F))
          return Ne;
      return -1;
    }
    function Is(A) {
      return A !== A;
    }
    function Ps(A, F) {
      var $ = A == null ? 0 : A.length;
      return $ ? Gf(A, F) / $ : fn;
    }
    function zf(A) {
      return function(F) {
        return F == null ? n : F[A];
      };
    }
    function Hf(A) {
      return function(F) {
        return A == null ? n : A[F];
      };
    }
    function Cs(A, F, $, ue, Ne) {
      return Ne(A, function(lt, en, Ot) {
        $ = ue ? (ue = !1, lt) : F($, lt, en, Ot);
      }), $;
    }
    function Jl(A, F) {
      var $ = A.length;
      for (A.sort(F); $--; )
        A[$] = A[$].value;
      return A;
    }
    function Gf(A, F) {
      for (var $, ue = -1, Ne = A.length; ++ue < Ne; ) {
        var lt = F(A[ue]);
        lt !== n && ($ = $ === n ? lt : $ + lt);
      }
      return $;
    }
    function qf(A, F) {
      for (var $ = -1, ue = Array(A); ++$ < A; )
        ue[$] = F($);
      return ue;
    }
    function Zl(A, F) {
      return Tt(F, function($) {
        return [$, A[$]];
      });
    }
    function Us(A) {
      return A && A.slice(0, Ns(A) + 1).replace(u, "");
    }
    function Wn(A) {
      return function(F) {
        return A(F);
      };
    }
    function Vf(A, F) {
      return Tt(F, function($) {
        return A[$];
      });
    }
    function to(A, F) {
      return A.has(F);
    }
    function Ls(A, F) {
      for (var $ = -1, ue = A.length; ++$ < ue && xi(F, A[$], 0) > -1; )
        ;
      return $;
    }
    function Ms(A, F) {
      for (var $ = A.length; $-- && xi(F, A[$], 0) > -1; )
        ;
      return $;
    }
    function Xl(A, F) {
      for (var $ = A.length, ue = 0; $--; )
        A[$] === F && ++ue;
      return ue;
    }
    var Ql = Hf(Mo), eh = Hf(_i);
    function th(A) {
      return "\\" + Xi[A];
    }
    function nh(A, F) {
      return A == null ? n : A[F];
    }
    function bi(A) {
      return Bf.test(A);
    }
    function rh(A) {
      return Lo.test(A);
    }
    function ih(A) {
      for (var F, $ = []; !(F = A.next()).done; )
        $.push(F.value);
      return $;
    }
    function Jf(A) {
      var F = -1, $ = Array(A.size);
      return A.forEach(function(ue, Ne) {
        $[++F] = [Ne, ue];
      }), $;
    }
    function $s(A, F) {
      return function($) {
        return A(F($));
      };
    }
    function Hr(A, F) {
      for (var $ = -1, ue = A.length, Ne = 0, lt = []; ++$ < ue; ) {
        var en = A[$];
        (en === F || en === he) && (A[$] = he, lt[Ne++] = $);
      }
      return lt;
    }
    function Fo(A) {
      var F = -1, $ = Array(A.size);
      return A.forEach(function(ue) {
        $[++F] = ue;
      }), $;
    }
    function oh(A) {
      var F = -1, $ = Array(A.size);
      return A.forEach(function(ue) {
        $[++F] = [ue, ue];
      }), $;
    }
    function fh(A, F, $) {
      for (var ue = $ - 1, Ne = A.length; ++ue < Ne; )
        if (A[ue] === F)
          return ue;
      return -1;
    }
    function ah(A, F, $) {
      for (var ue = $ + 1; ue--; )
        if (A[ue] === F)
          return ue;
      return ue;
    }
    function mi(A) {
      return bi(A) ? uh(A) : Hl(A);
    }
    function pr(A) {
      return bi(A) ? ch(A) : Gl(A);
    }
    function Ns(A) {
      for (var F = A.length; F-- && p.test(A.charAt(F)); )
        ;
      return F;
    }
    var sh = Hf(Zi);
    function uh(A) {
      for (var F = Ji.lastIndex = 0; Ji.test(A); )
        ++F;
      return F;
    }
    function ch(A) {
      return A.match(Ji) || [];
    }
    function lh(A) {
      return A.match(Df) || [];
    }
    var hh = function A(F) {
      F = F == null ? Xt : wi.defaults(Xt.Object(), F, wi.pick(Xt, vi));
      var $ = F.Array, ue = F.Date, Ne = F.Error, lt = F.Function, en = F.Math, Ot = F.Object, Zf = F.RegExp, dh = F.String, er = F.TypeError, Do = $.prototype, ph = lt.prototype, Ei = Ot.prototype, Bo = F["__core-js_shared__"], Wo = ph.toString, bt = Ei.hasOwnProperty, gh = 0, Fs = function() {
        var e = /[^.]+$/.exec(Bo && Bo.keys && Bo.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
      }(), jo = Ei.toString, vh = Wo.call(Ot), _h = Xt._, yh = Zf(
        "^" + Wo.call(bt).replace($t, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), ko = P ? F.Buffer : n, Gr = F.Symbol, Ko = F.Uint8Array, Ds = ko ? ko.allocUnsafe : n, Yo = $s(Ot.getPrototypeOf, Ot), Bs = Ot.create, Ws = Ei.propertyIsEnumerable, zo = Do.splice, js = Gr ? Gr.isConcatSpreadable : n, no = Gr ? Gr.iterator : n, ri = Gr ? Gr.toStringTag : n, Ho = function() {
        try {
          var e = si(Ot, "defineProperty");
          return e({}, "", {}), e;
        } catch {
        }
      }(), xh = F.clearTimeout !== Xt.clearTimeout && F.clearTimeout, bh = ue && ue.now !== Xt.Date.now && ue.now, mh = F.setTimeout !== Xt.setTimeout && F.setTimeout, Go = en.ceil, qo = en.floor, Xf = Ot.getOwnPropertySymbols, wh = ko ? ko.isBuffer : n, ks = F.isFinite, Eh = Do.join, Sh = $s(Ot.keys, Ot), tn = en.max, pn = en.min, Rh = ue.now, Ah = F.parseInt, Ks = en.random, Th = Do.reverse, Qf = si(F, "DataView"), ro = si(F, "Map"), ea = si(F, "Promise"), Si = si(F, "Set"), io = si(F, "WeakMap"), oo = si(Ot, "create"), Vo = io && new io(), Ri = {}, Oh = ui(Qf), Ih = ui(ro), Ph = ui(ea), Ch = ui(Si), Uh = ui(io), Jo = Gr ? Gr.prototype : n, fo = Jo ? Jo.valueOf : n, Ys = Jo ? Jo.toString : n;
      function g(e) {
        if (jt(e) && !De(e) && !(e instanceof it)) {
          if (e instanceof tr)
            return e;
          if (bt.call(e, "__wrapped__"))
            return zu(e);
        }
        return new tr(e);
      }
      var Ai = /* @__PURE__ */ function() {
        function e() {
        }
        return function(t) {
          if (!Ft(t))
            return {};
          if (Bs)
            return Bs(t);
          e.prototype = t;
          var i = new e();
          return e.prototype = n, i;
        };
      }();
      function Zo() {
      }
      function tr(e, t) {
        this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = n;
      }
      g.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Dn,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Bn,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Sr,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: g
        }
      }, g.prototype = Zo.prototype, g.prototype.constructor = g, tr.prototype = Ai(Zo.prototype), tr.prototype.constructor = tr;
      function it(e) {
        this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = O, this.__views__ = [];
      }
      function Lh() {
        var e = new it(this.__wrapped__);
        return e.__actions__ = Pn(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Pn(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Pn(this.__views__), e;
      }
      function Mh() {
        if (this.__filtered__) {
          var e = new it(this);
          e.__dir__ = -1, e.__filtered__ = !0;
        } else
          e = this.clone(), e.__dir__ *= -1;
        return e;
      }
      function $h() {
        var e = this.__wrapped__.value(), t = this.__dir__, i = De(e), a = t < 0, l = i ? e.length : 0, _ = Gd(0, l, this.__views__), m = _.start, E = _.end, T = E - m, W = a ? E : m - 1, j = this.__iteratees__, z = j.length, te = 0, _e = pn(T, this.__takeCount__);
        if (!i || !a && l == T && _e == T)
          return pu(e, this.__actions__);
        var Ae = [];
        e:
          for (; T-- && te < _e; ) {
            W += t;
            for (var Ye = -1, Te = e[W]; ++Ye < z; ) {
              var et = j[Ye], ot = et.iteratee, Kn = et.type, bn = ot(Te);
              if (Kn == Lt)
                Te = bn;
              else if (!bn) {
                if (Kn == Kt)
                  continue e;
                break e;
              }
            }
            Ae[te++] = Te;
          }
        return Ae;
      }
      it.prototype = Ai(Zo.prototype), it.prototype.constructor = it;
      function ii(e) {
        var t = -1, i = e == null ? 0 : e.length;
        for (this.clear(); ++t < i; ) {
          var a = e[t];
          this.set(a[0], a[1]);
        }
      }
      function Nh() {
        this.__data__ = oo ? oo(null) : {}, this.size = 0;
      }
      function Fh(e) {
        var t = this.has(e) && delete this.__data__[e];
        return this.size -= t ? 1 : 0, t;
      }
      function Dh(e) {
        var t = this.__data__;
        if (oo) {
          var i = t[e];
          return i === G ? n : i;
        }
        return bt.call(t, e) ? t[e] : n;
      }
      function Bh(e) {
        var t = this.__data__;
        return oo ? t[e] !== n : bt.call(t, e);
      }
      function Wh(e, t) {
        var i = this.__data__;
        return this.size += this.has(e) ? 0 : 1, i[e] = oo && t === n ? G : t, this;
      }
      ii.prototype.clear = Nh, ii.prototype.delete = Fh, ii.prototype.get = Dh, ii.prototype.has = Bh, ii.prototype.set = Wh;
      function Lr(e) {
        var t = -1, i = e == null ? 0 : e.length;
        for (this.clear(); ++t < i; ) {
          var a = e[t];
          this.set(a[0], a[1]);
        }
      }
      function jh() {
        this.__data__ = [], this.size = 0;
      }
      function kh(e) {
        var t = this.__data__, i = Xo(t, e);
        if (i < 0)
          return !1;
        var a = t.length - 1;
        return i == a ? t.pop() : zo.call(t, i, 1), --this.size, !0;
      }
      function Kh(e) {
        var t = this.__data__, i = Xo(t, e);
        return i < 0 ? n : t[i][1];
      }
      function Yh(e) {
        return Xo(this.__data__, e) > -1;
      }
      function zh(e, t) {
        var i = this.__data__, a = Xo(i, e);
        return a < 0 ? (++this.size, i.push([e, t])) : i[a][1] = t, this;
      }
      Lr.prototype.clear = jh, Lr.prototype.delete = kh, Lr.prototype.get = Kh, Lr.prototype.has = Yh, Lr.prototype.set = zh;
      function Mr(e) {
        var t = -1, i = e == null ? 0 : e.length;
        for (this.clear(); ++t < i; ) {
          var a = e[t];
          this.set(a[0], a[1]);
        }
      }
      function Hh() {
        this.size = 0, this.__data__ = {
          hash: new ii(),
          map: new (ro || Lr)(),
          string: new ii()
        };
      }
      function Gh(e) {
        var t = lf(this, e).delete(e);
        return this.size -= t ? 1 : 0, t;
      }
      function qh(e) {
        return lf(this, e).get(e);
      }
      function Vh(e) {
        return lf(this, e).has(e);
      }
      function Jh(e, t) {
        var i = lf(this, e), a = i.size;
        return i.set(e, t), this.size += i.size == a ? 0 : 1, this;
      }
      Mr.prototype.clear = Hh, Mr.prototype.delete = Gh, Mr.prototype.get = qh, Mr.prototype.has = Vh, Mr.prototype.set = Jh;
      function oi(e) {
        var t = -1, i = e == null ? 0 : e.length;
        for (this.__data__ = new Mr(); ++t < i; )
          this.add(e[t]);
      }
      function Zh(e) {
        return this.__data__.set(e, G), this;
      }
      function Xh(e) {
        return this.__data__.has(e);
      }
      oi.prototype.add = oi.prototype.push = Zh, oi.prototype.has = Xh;
      function gr(e) {
        var t = this.__data__ = new Lr(e);
        this.size = t.size;
      }
      function Qh() {
        this.__data__ = new Lr(), this.size = 0;
      }
      function ed(e) {
        var t = this.__data__, i = t.delete(e);
        return this.size = t.size, i;
      }
      function td(e) {
        return this.__data__.get(e);
      }
      function nd(e) {
        return this.__data__.has(e);
      }
      function rd(e, t) {
        var i = this.__data__;
        if (i instanceof Lr) {
          var a = i.__data__;
          if (!ro || a.length < v - 1)
            return a.push([e, t]), this.size = ++i.size, this;
          i = this.__data__ = new Mr(a);
        }
        return i.set(e, t), this.size = i.size, this;
      }
      gr.prototype.clear = Qh, gr.prototype.delete = ed, gr.prototype.get = td, gr.prototype.has = nd, gr.prototype.set = rd;
      function zs(e, t) {
        var i = De(e), a = !i && ci(e), l = !i && !a && Xr(e), _ = !i && !a && !l && Pi(e), m = i || a || l || _, E = m ? qf(e.length, dh) : [], T = E.length;
        for (var W in e)
          (t || bt.call(e, W)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
          (W == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          l && (W == "offset" || W == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          _ && (W == "buffer" || W == "byteLength" || W == "byteOffset") || // Skip index properties.
          Dr(W, T))) && E.push(W);
        return E;
      }
      function Hs(e) {
        var t = e.length;
        return t ? e[la(0, t - 1)] : n;
      }
      function id(e, t) {
        return hf(Pn(e), fi(t, 0, e.length));
      }
      function od(e) {
        return hf(Pn(e));
      }
      function ta(e, t, i) {
        (i !== n && !vr(e[t], i) || i === n && !(t in e)) && $r(e, t, i);
      }
      function ao(e, t, i) {
        var a = e[t];
        (!(bt.call(e, t) && vr(a, i)) || i === n && !(t in e)) && $r(e, t, i);
      }
      function Xo(e, t) {
        for (var i = e.length; i--; )
          if (vr(e[i][0], t))
            return i;
        return -1;
      }
      function fd(e, t, i, a) {
        return qr(e, function(l, _, m) {
          t(a, l, i(l), m);
        }), a;
      }
      function Gs(e, t) {
        return e && Ir(t, on(t), e);
      }
      function ad(e, t) {
        return e && Ir(t, Un(t), e);
      }
      function $r(e, t, i) {
        t == "__proto__" && Ho ? Ho(e, t, {
          configurable: !0,
          enumerable: !0,
          value: i,
          writable: !0
        }) : e[t] = i;
      }
      function na(e, t) {
        for (var i = -1, a = t.length, l = $(a), _ = e == null; ++i < a; )
          l[i] = _ ? n : Na(e, t[i]);
        return l;
      }
      function fi(e, t, i) {
        return e === e && (i !== n && (e = e <= i ? e : i), t !== n && (e = e >= t ? e : t)), e;
      }
      function nr(e, t, i, a, l, _) {
        var m, E = t & me, T = t & Me, W = t & be;
        if (i && (m = l ? i(e, a, l, _) : i(e)), m !== n)
          return m;
        if (!Ft(e))
          return e;
        var j = De(e);
        if (j) {
          if (m = Vd(e), !E)
            return Pn(e, m);
        } else {
          var z = gn(e), te = z == Rn || z == Hn;
          if (Xr(e))
            return _u(e, E);
          if (z == qt || z == ee || te && !l) {
            if (m = T || te ? {} : Nu(e), !E)
              return T ? Dd(e, ad(m, e)) : Fd(e, Gs(m, e));
          } else {
            if (!xt[z])
              return l ? e : {};
            m = Jd(e, z, E);
          }
        }
        _ || (_ = new gr());
        var _e = _.get(e);
        if (_e)
          return _e;
        _.set(e, m), lc(e) ? e.forEach(function(Te) {
          m.add(nr(Te, t, i, Te, e, _));
        }) : uc(e) && e.forEach(function(Te, et) {
          m.set(et, nr(Te, t, i, et, e, _));
        });
        var Ae = W ? T ? wa : ma : T ? Un : on, Ye = j ? n : Ae(e);
        return at(Ye || e, function(Te, et) {
          Ye && (et = Te, Te = e[et]), ao(m, et, nr(Te, t, i, et, e, _));
        }), m;
      }
      function sd(e) {
        var t = on(e);
        return function(i) {
          return qs(i, e, t);
        };
      }
      function qs(e, t, i) {
        var a = i.length;
        if (e == null)
          return !a;
        for (e = Ot(e); a--; ) {
          var l = i[a], _ = t[l], m = e[l];
          if (m === n && !(l in e) || !_(m))
            return !1;
        }
        return !0;
      }
      function Vs(e, t, i) {
        if (typeof e != "function")
          throw new er(I);
        return go(function() {
          e.apply(n, i);
        }, t);
      }
      function so(e, t, i, a) {
        var l = -1, _ = ni, m = !0, E = e.length, T = [], W = t.length;
        if (!E)
          return T;
        i && (t = Tt(t, Wn(i))), a ? (_ = eo, m = !1) : t.length >= v && (_ = to, m = !1, t = new oi(t));
        e:
          for (; ++l < E; ) {
            var j = e[l], z = i == null ? j : i(j);
            if (j = a || j !== 0 ? j : 0, m && z === z) {
              for (var te = W; te--; )
                if (t[te] === z)
                  continue e;
              T.push(j);
            } else _(t, z, a) || T.push(j);
          }
        return T;
      }
      var qr = wu(Or), Js = wu(ia, !0);
      function ud(e, t) {
        var i = !0;
        return qr(e, function(a, l, _) {
          return i = !!t(a, l, _), i;
        }), i;
      }
      function Qo(e, t, i) {
        for (var a = -1, l = e.length; ++a < l; ) {
          var _ = e[a], m = t(_);
          if (m != null && (E === n ? m === m && !kn(m) : i(m, E)))
            var E = m, T = _;
        }
        return T;
      }
      function cd(e, t, i, a) {
        var l = e.length;
        for (i = ke(i), i < 0 && (i = -i > l ? 0 : l + i), a = a === n || a > l ? l : ke(a), a < 0 && (a += l), a = i > a ? 0 : dc(a); i < a; )
          e[i++] = t;
        return e;
      }
      function Zs(e, t) {
        var i = [];
        return qr(e, function(a, l, _) {
          t(a, l, _) && i.push(a);
        }), i;
      }
      function un(e, t, i, a, l) {
        var _ = -1, m = e.length;
        for (i || (i = Xd), l || (l = []); ++_ < m; ) {
          var E = e[_];
          t > 0 && i(E) ? t > 1 ? un(E, t - 1, i, a, l) : Tr(l, E) : a || (l[l.length] = E);
        }
        return l;
      }
      var ra = Eu(), Xs = Eu(!0);
      function Or(e, t) {
        return e && ra(e, t, on);
      }
      function ia(e, t) {
        return e && Xs(e, t, on);
      }
      function ef(e, t) {
        return Qn(t, function(i) {
          return Br(e[i]);
        });
      }
      function ai(e, t) {
        t = Jr(t, e);
        for (var i = 0, a = t.length; e != null && i < a; )
          e = e[Pr(t[i++])];
        return i && i == a ? e : n;
      }
      function Qs(e, t, i) {
        var a = t(e);
        return De(e) ? a : Tr(a, i(e));
      }
      function yn(e) {
        return e == null ? e === n ? ur : Gn : ri && ri in Ot(e) ? Hd(e) : o0(e);
      }
      function oa(e, t) {
        return e > t;
      }
      function ld(e, t) {
        return e != null && bt.call(e, t);
      }
      function hd(e, t) {
        return e != null && t in Ot(e);
      }
      function dd(e, t, i) {
        return e >= pn(t, i) && e < tn(t, i);
      }
      function fa(e, t, i) {
        for (var a = i ? eo : ni, l = e[0].length, _ = e.length, m = _, E = $(_), T = 1 / 0, W = []; m--; ) {
          var j = e[m];
          m && t && (j = Tt(j, Wn(t))), T = pn(j.length, T), E[m] = !i && (t || l >= 120 && j.length >= 120) ? new oi(m && j) : n;
        }
        j = e[0];
        var z = -1, te = E[0];
        e:
          for (; ++z < l && W.length < T; ) {
            var _e = j[z], Ae = t ? t(_e) : _e;
            if (_e = i || _e !== 0 ? _e : 0, !(te ? to(te, Ae) : a(W, Ae, i))) {
              for (m = _; --m; ) {
                var Ye = E[m];
                if (!(Ye ? to(Ye, Ae) : a(e[m], Ae, i)))
                  continue e;
              }
              te && te.push(Ae), W.push(_e);
            }
          }
        return W;
      }
      function pd(e, t, i, a) {
        return Or(e, function(l, _, m) {
          t(a, i(l), _, m);
        }), a;
      }
      function uo(e, t, i) {
        t = Jr(t, e), e = Wu(e, t);
        var a = e == null ? e : e[Pr(ir(t))];
        return a == null ? n : Je(a, e, i);
      }
      function eu(e) {
        return jt(e) && yn(e) == ee;
      }
      function gd(e) {
        return jt(e) && yn(e) == rn;
      }
      function vd(e) {
        return jt(e) && yn(e) == Ke;
      }
      function co(e, t, i, a, l) {
        return e === t ? !0 : e == null || t == null || !jt(e) && !jt(t) ? e !== e && t !== t : _d(e, t, i, a, co, l);
      }
      function _d(e, t, i, a, l, _) {
        var m = De(e), E = De(t), T = m ? $e : gn(e), W = E ? $e : gn(t);
        T = T == ee ? qt : T, W = W == ee ? qt : W;
        var j = T == qt, z = W == qt, te = T == W;
        if (te && Xr(e)) {
          if (!Xr(t))
            return !1;
          m = !0, j = !1;
        }
        if (te && !j)
          return _ || (_ = new gr()), m || Pi(e) ? Lu(e, t, i, a, l, _) : Yd(e, t, T, i, a, l, _);
        if (!(i & tt)) {
          var _e = j && bt.call(e, "__wrapped__"), Ae = z && bt.call(t, "__wrapped__");
          if (_e || Ae) {
            var Ye = _e ? e.value() : e, Te = Ae ? t.value() : t;
            return _ || (_ = new gr()), l(Ye, Te, i, a, _);
          }
        }
        return te ? (_ || (_ = new gr()), zd(e, t, i, a, l, _)) : !1;
      }
      function yd(e) {
        return jt(e) && gn(e) == an;
      }
      function aa(e, t, i, a) {
        var l = i.length, _ = l, m = !a;
        if (e == null)
          return !_;
        for (e = Ot(e); l--; ) {
          var E = i[l];
          if (m && E[2] ? E[1] !== e[E[0]] : !(E[0] in e))
            return !1;
        }
        for (; ++l < _; ) {
          E = i[l];
          var T = E[0], W = e[T], j = E[1];
          if (m && E[2]) {
            if (W === n && !(T in e))
              return !1;
          } else {
            var z = new gr();
            if (a)
              var te = a(W, j, T, e, t, z);
            if (!(te === n ? co(j, W, tt | We, a, z) : te))
              return !1;
          }
        }
        return !0;
      }
      function tu(e) {
        if (!Ft(e) || e0(e))
          return !1;
        var t = Br(e) ? yh : k;
        return t.test(ui(e));
      }
      function xd(e) {
        return jt(e) && yn(e) == Yt;
      }
      function bd(e) {
        return jt(e) && gn(e) == Bt;
      }
      function md(e) {
        return jt(e) && yf(e.length) && !!ct[yn(e)];
      }
      function nu(e) {
        return typeof e == "function" ? e : e == null ? Ln : typeof e == "object" ? De(e) ? ou(e[0], e[1]) : iu(e) : Sc(e);
      }
      function sa(e) {
        if (!po(e))
          return Sh(e);
        var t = [];
        for (var i in Ot(e))
          bt.call(e, i) && i != "constructor" && t.push(i);
        return t;
      }
      function wd(e) {
        if (!Ft(e))
          return i0(e);
        var t = po(e), i = [];
        for (var a in e)
          a == "constructor" && (t || !bt.call(e, a)) || i.push(a);
        return i;
      }
      function ua(e, t) {
        return e < t;
      }
      function ru(e, t) {
        var i = -1, a = Cn(e) ? $(e.length) : [];
        return qr(e, function(l, _, m) {
          a[++i] = t(l, _, m);
        }), a;
      }
      function iu(e) {
        var t = Sa(e);
        return t.length == 1 && t[0][2] ? Du(t[0][0], t[0][1]) : function(i) {
          return i === e || aa(i, e, t);
        };
      }
      function ou(e, t) {
        return Aa(e) && Fu(t) ? Du(Pr(e), t) : function(i) {
          var a = Na(i, e);
          return a === n && a === t ? Fa(i, e) : co(t, a, tt | We);
        };
      }
      function tf(e, t, i, a, l) {
        e !== t && ra(t, function(_, m) {
          if (l || (l = new gr()), Ft(_))
            Ed(e, t, m, i, tf, a, l);
          else {
            var E = a ? a(Oa(e, m), _, m + "", e, t, l) : n;
            E === n && (E = _), ta(e, m, E);
          }
        }, Un);
      }
      function Ed(e, t, i, a, l, _, m) {
        var E = Oa(e, i), T = Oa(t, i), W = m.get(T);
        if (W) {
          ta(e, i, W);
          return;
        }
        var j = _ ? _(E, T, i + "", e, t, m) : n, z = j === n;
        if (z) {
          var te = De(T), _e = !te && Xr(T), Ae = !te && !_e && Pi(T);
          j = T, te || _e || Ae ? De(E) ? j = E : Ht(E) ? j = Pn(E) : _e ? (z = !1, j = _u(T, !0)) : Ae ? (z = !1, j = yu(T, !0)) : j = [] : vo(T) || ci(T) ? (j = E, ci(E) ? j = pc(E) : (!Ft(E) || Br(E)) && (j = Nu(T))) : z = !1;
        }
        z && (m.set(T, j), l(j, T, a, _, m), m.delete(T)), ta(e, i, j);
      }
      function fu(e, t) {
        var i = e.length;
        if (i)
          return t += t < 0 ? i : 0, Dr(t, i) ? e[t] : n;
      }
      function au(e, t, i) {
        t.length ? t = Tt(t, function(_) {
          return De(_) ? function(m) {
            return ai(m, _.length === 1 ? _[0] : _);
          } : _;
        }) : t = [Ln];
        var a = -1;
        t = Tt(t, Wn(Re()));
        var l = ru(e, function(_, m, E) {
          var T = Tt(t, function(W) {
            return W(_);
          });
          return { criteria: T, index: ++a, value: _ };
        });
        return Jl(l, function(_, m) {
          return Nd(_, m, i);
        });
      }
      function Sd(e, t) {
        return su(e, t, function(i, a) {
          return Fa(e, a);
        });
      }
      function su(e, t, i) {
        for (var a = -1, l = t.length, _ = {}; ++a < l; ) {
          var m = t[a], E = ai(e, m);
          i(E, m) && lo(_, Jr(m, e), E);
        }
        return _;
      }
      function Rd(e) {
        return function(t) {
          return ai(t, e);
        };
      }
      function ca(e, t, i, a) {
        var l = a ? Vl : xi, _ = -1, m = t.length, E = e;
        for (e === t && (t = Pn(t)), i && (E = Tt(e, Wn(i))); ++_ < m; )
          for (var T = 0, W = t[_], j = i ? i(W) : W; (T = l(E, j, T, a)) > -1; )
            E !== e && zo.call(E, T, 1), zo.call(e, T, 1);
        return e;
      }
      function uu(e, t) {
        for (var i = e ? t.length : 0, a = i - 1; i--; ) {
          var l = t[i];
          if (i == a || l !== _) {
            var _ = l;
            Dr(l) ? zo.call(e, l, 1) : pa(e, l);
          }
        }
        return e;
      }
      function la(e, t) {
        return e + qo(Ks() * (t - e + 1));
      }
      function Ad(e, t, i, a) {
        for (var l = -1, _ = tn(Go((t - e) / (i || 1)), 0), m = $(_); _--; )
          m[a ? _ : ++l] = e, e += i;
        return m;
      }
      function ha(e, t) {
        var i = "";
        if (!e || t < 1 || t > It)
          return i;
        do
          t % 2 && (i += e), t = qo(t / 2), t && (e += e);
        while (t);
        return i;
      }
      function He(e, t) {
        return Ia(Bu(e, t, Ln), e + "");
      }
      function Td(e) {
        return Hs(Ci(e));
      }
      function Od(e, t) {
        var i = Ci(e);
        return hf(i, fi(t, 0, i.length));
      }
      function lo(e, t, i, a) {
        if (!Ft(e))
          return e;
        t = Jr(t, e);
        for (var l = -1, _ = t.length, m = _ - 1, E = e; E != null && ++l < _; ) {
          var T = Pr(t[l]), W = i;
          if (T === "__proto__" || T === "constructor" || T === "prototype")
            return e;
          if (l != m) {
            var j = E[T];
            W = a ? a(j, T, E) : n, W === n && (W = Ft(j) ? j : Dr(t[l + 1]) ? [] : {});
          }
          ao(E, T, W), E = E[T];
        }
        return e;
      }
      var cu = Vo ? function(e, t) {
        return Vo.set(e, t), e;
      } : Ln, Id = Ho ? function(e, t) {
        return Ho(e, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Ba(t),
          writable: !0
        });
      } : Ln;
      function Pd(e) {
        return hf(Ci(e));
      }
      function rr(e, t, i) {
        var a = -1, l = e.length;
        t < 0 && (t = -t > l ? 0 : l + t), i = i > l ? l : i, i < 0 && (i += l), l = t > i ? 0 : i - t >>> 0, t >>>= 0;
        for (var _ = $(l); ++a < l; )
          _[a] = e[a + t];
        return _;
      }
      function Cd(e, t) {
        var i;
        return qr(e, function(a, l, _) {
          return i = t(a, l, _), !i;
        }), !!i;
      }
      function nf(e, t, i) {
        var a = 0, l = e == null ? a : e.length;
        if (typeof t == "number" && t === t && l <= Ee) {
          for (; a < l; ) {
            var _ = a + l >>> 1, m = e[_];
            m !== null && !kn(m) && (i ? m <= t : m < t) ? a = _ + 1 : l = _;
          }
          return l;
        }
        return da(e, t, Ln, i);
      }
      function da(e, t, i, a) {
        var l = 0, _ = e == null ? 0 : e.length;
        if (_ === 0)
          return 0;
        t = i(t);
        for (var m = t !== t, E = t === null, T = kn(t), W = t === n; l < _; ) {
          var j = qo((l + _) / 2), z = i(e[j]), te = z !== n, _e = z === null, Ae = z === z, Ye = kn(z);
          if (m)
            var Te = a || Ae;
          else W ? Te = Ae && (a || te) : E ? Te = Ae && te && (a || !_e) : T ? Te = Ae && te && !_e && (a || !Ye) : _e || Ye ? Te = !1 : Te = a ? z <= t : z < t;
          Te ? l = j + 1 : _ = j;
        }
        return pn(_, J);
      }
      function lu(e, t) {
        for (var i = -1, a = e.length, l = 0, _ = []; ++i < a; ) {
          var m = e[i], E = t ? t(m) : m;
          if (!i || !vr(E, T)) {
            var T = E;
            _[l++] = m === 0 ? 0 : m;
          }
        }
        return _;
      }
      function hu(e) {
        return typeof e == "number" ? e : kn(e) ? fn : +e;
      }
      function jn(e) {
        if (typeof e == "string")
          return e;
        if (De(e))
          return Tt(e, jn) + "";
        if (kn(e))
          return Ys ? Ys.call(e) : "";
        var t = e + "";
        return t == "0" && 1 / e == -de ? "-0" : t;
      }
      function Vr(e, t, i) {
        var a = -1, l = ni, _ = e.length, m = !0, E = [], T = E;
        if (i)
          m = !1, l = eo;
        else if (_ >= v) {
          var W = t ? null : kd(e);
          if (W)
            return Fo(W);
          m = !1, l = to, T = new oi();
        } else
          T = t ? [] : E;
        e:
          for (; ++a < _; ) {
            var j = e[a], z = t ? t(j) : j;
            if (j = i || j !== 0 ? j : 0, m && z === z) {
              for (var te = T.length; te--; )
                if (T[te] === z)
                  continue e;
              t && T.push(z), E.push(j);
            } else l(T, z, i) || (T !== E && T.push(z), E.push(j));
          }
        return E;
      }
      function pa(e, t) {
        return t = Jr(t, e), e = Wu(e, t), e == null || delete e[Pr(ir(t))];
      }
      function du(e, t, i, a) {
        return lo(e, t, i(ai(e, t)), a);
      }
      function rf(e, t, i, a) {
        for (var l = e.length, _ = a ? l : -1; (a ? _-- : ++_ < l) && t(e[_], _, e); )
          ;
        return i ? rr(e, a ? 0 : _, a ? _ + 1 : l) : rr(e, a ? _ + 1 : 0, a ? l : _);
      }
      function pu(e, t) {
        var i = e;
        return i instanceof it && (i = i.value()), yi(t, function(a, l) {
          return l.func.apply(l.thisArg, Tr([a], l.args));
        }, i);
      }
      function ga(e, t, i) {
        var a = e.length;
        if (a < 2)
          return a ? Vr(e[0]) : [];
        for (var l = -1, _ = $(a); ++l < a; )
          for (var m = e[l], E = -1; ++E < a; )
            E != l && (_[l] = so(_[l] || m, e[E], t, i));
        return Vr(un(_, 1), t, i);
      }
      function gu(e, t, i) {
        for (var a = -1, l = e.length, _ = t.length, m = {}; ++a < l; ) {
          var E = a < _ ? t[a] : n;
          i(m, e[a], E);
        }
        return m;
      }
      function va(e) {
        return Ht(e) ? e : [];
      }
      function _a(e) {
        return typeof e == "function" ? e : Ln;
      }
      function Jr(e, t) {
        return De(e) ? e : Aa(e, t) ? [e] : Yu(vt(e));
      }
      var Ud = He;
      function Zr(e, t, i) {
        var a = e.length;
        return i = i === n ? a : i, !t && i >= a ? e : rr(e, t, i);
      }
      var vu = xh || function(e) {
        return Xt.clearTimeout(e);
      };
      function _u(e, t) {
        if (t)
          return e.slice();
        var i = e.length, a = Ds ? Ds(i) : new e.constructor(i);
        return e.copy(a), a;
      }
      function ya(e) {
        var t = new e.constructor(e.byteLength);
        return new Ko(t).set(new Ko(e)), t;
      }
      function Ld(e, t) {
        var i = t ? ya(e.buffer) : e.buffer;
        return new e.constructor(i, e.byteOffset, e.byteLength);
      }
      function Md(e) {
        var t = new e.constructor(e.source, V.exec(e));
        return t.lastIndex = e.lastIndex, t;
      }
      function $d(e) {
        return fo ? Ot(fo.call(e)) : {};
      }
      function yu(e, t) {
        var i = t ? ya(e.buffer) : e.buffer;
        return new e.constructor(i, e.byteOffset, e.length);
      }
      function xu(e, t) {
        if (e !== t) {
          var i = e !== n, a = e === null, l = e === e, _ = kn(e), m = t !== n, E = t === null, T = t === t, W = kn(t);
          if (!E && !W && !_ && e > t || _ && m && T && !E && !W || a && m && T || !i && T || !l)
            return 1;
          if (!a && !_ && !W && e < t || W && i && l && !a && !_ || E && i && l || !m && l || !T)
            return -1;
        }
        return 0;
      }
      function Nd(e, t, i) {
        for (var a = -1, l = e.criteria, _ = t.criteria, m = l.length, E = i.length; ++a < m; ) {
          var T = xu(l[a], _[a]);
          if (T) {
            if (a >= E)
              return T;
            var W = i[a];
            return T * (W == "desc" ? -1 : 1);
          }
        }
        return e.index - t.index;
      }
      function bu(e, t, i, a) {
        for (var l = -1, _ = e.length, m = i.length, E = -1, T = t.length, W = tn(_ - m, 0), j = $(T + W), z = !a; ++E < T; )
          j[E] = t[E];
        for (; ++l < m; )
          (z || l < _) && (j[i[l]] = e[l]);
        for (; W--; )
          j[E++] = e[l++];
        return j;
      }
      function mu(e, t, i, a) {
        for (var l = -1, _ = e.length, m = -1, E = i.length, T = -1, W = t.length, j = tn(_ - E, 0), z = $(j + W), te = !a; ++l < j; )
          z[l] = e[l];
        for (var _e = l; ++T < W; )
          z[_e + T] = t[T];
        for (; ++m < E; )
          (te || l < _) && (z[_e + i[m]] = e[l++]);
        return z;
      }
      function Pn(e, t) {
        var i = -1, a = e.length;
        for (t || (t = $(a)); ++i < a; )
          t[i] = e[i];
        return t;
      }
      function Ir(e, t, i, a) {
        var l = !i;
        i || (i = {});
        for (var _ = -1, m = t.length; ++_ < m; ) {
          var E = t[_], T = a ? a(i[E], e[E], E, i, e) : n;
          T === n && (T = e[E]), l ? $r(i, E, T) : ao(i, E, T);
        }
        return i;
      }
      function Fd(e, t) {
        return Ir(e, Ra(e), t);
      }
      function Dd(e, t) {
        return Ir(e, Mu(e), t);
      }
      function of(e, t) {
        return function(i, a) {
          var l = De(i) ? Pt : fd, _ = t ? t() : {};
          return l(i, e, Re(a, 2), _);
        };
      }
      function Ti(e) {
        return He(function(t, i) {
          var a = -1, l = i.length, _ = l > 1 ? i[l - 1] : n, m = l > 2 ? i[2] : n;
          for (_ = e.length > 3 && typeof _ == "function" ? (l--, _) : n, m && xn(i[0], i[1], m) && (_ = l < 3 ? n : _, l = 1), t = Ot(t); ++a < l; ) {
            var E = i[a];
            E && e(t, E, a, _);
          }
          return t;
        });
      }
      function wu(e, t) {
        return function(i, a) {
          if (i == null)
            return i;
          if (!Cn(i))
            return e(i, a);
          for (var l = i.length, _ = t ? l : -1, m = Ot(i); (t ? _-- : ++_ < l) && a(m[_], _, m) !== !1; )
            ;
          return i;
        };
      }
      function Eu(e) {
        return function(t, i, a) {
          for (var l = -1, _ = Ot(t), m = a(t), E = m.length; E--; ) {
            var T = m[e ? E : ++l];
            if (i(_[T], T, _) === !1)
              break;
          }
          return t;
        };
      }
      function Bd(e, t, i) {
        var a = t & Ge, l = ho(e);
        function _() {
          var m = this && this !== Xt && this instanceof _ ? l : e;
          return m.apply(a ? i : this, arguments);
        }
        return _;
      }
      function Su(e) {
        return function(t) {
          t = vt(t);
          var i = bi(t) ? pr(t) : n, a = i ? i[0] : t.charAt(0), l = i ? Zr(i, 1).join("") : t.slice(1);
          return a[e]() + l;
        };
      }
      function Oi(e) {
        return function(t) {
          return yi(wc(mc(t).replace(Co, "")), e, "");
        };
      }
      function ho(e) {
        return function() {
          var t = arguments;
          switch (t.length) {
            case 0:
              return new e();
            case 1:
              return new e(t[0]);
            case 2:
              return new e(t[0], t[1]);
            case 3:
              return new e(t[0], t[1], t[2]);
            case 4:
              return new e(t[0], t[1], t[2], t[3]);
            case 5:
              return new e(t[0], t[1], t[2], t[3], t[4]);
            case 6:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
            case 7:
              return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
          }
          var i = Ai(e.prototype), a = e.apply(i, t);
          return Ft(a) ? a : i;
        };
      }
      function Wd(e, t, i) {
        var a = ho(e);
        function l() {
          for (var _ = arguments.length, m = $(_), E = _, T = Ii(l); E--; )
            m[E] = arguments[E];
          var W = _ < 3 && m[0] !== T && m[_ - 1] !== T ? [] : Hr(m, T);
          if (_ -= W.length, _ < i)
            return Iu(
              e,
              t,
              ff,
              l.placeholder,
              n,
              m,
              W,
              n,
              n,
              i - _
            );
          var j = this && this !== Xt && this instanceof l ? a : e;
          return Je(j, this, m);
        }
        return l;
      }
      function Ru(e) {
        return function(t, i, a) {
          var l = Ot(t);
          if (!Cn(t)) {
            var _ = Re(i, 3);
            t = on(t), i = function(E) {
              return _(l[E], E, l);
            };
          }
          var m = e(t, i, a);
          return m > -1 ? l[_ ? t[m] : m] : n;
        };
      }
      function Au(e) {
        return Fr(function(t) {
          var i = t.length, a = i, l = tr.prototype.thru;
          for (e && t.reverse(); a--; ) {
            var _ = t[a];
            if (typeof _ != "function")
              throw new er(I);
            if (l && !m && cf(_) == "wrapper")
              var m = new tr([], !0);
          }
          for (a = m ? a : i; ++a < i; ) {
            _ = t[a];
            var E = cf(_), T = E == "wrapper" ? Ea(_) : n;
            T && Ta(T[0]) && T[1] == (Ut | yt | nt | nn) && !T[4].length && T[9] == 1 ? m = m[cf(T[0])].apply(m, T[3]) : m = _.length == 1 && Ta(_) ? m[E]() : m.thru(_);
          }
          return function() {
            var W = arguments, j = W[0];
            if (m && W.length == 1 && De(j))
              return m.plant(j).value();
            for (var z = 0, te = i ? t[z].apply(this, W) : j; ++z < i; )
              te = t[z].call(this, te);
            return te;
          };
        });
      }
      function ff(e, t, i, a, l, _, m, E, T, W) {
        var j = t & Ut, z = t & Ge, te = t & mt, _e = t & (yt | ft), Ae = t & Sn, Ye = te ? n : ho(e);
        function Te() {
          for (var et = arguments.length, ot = $(et), Kn = et; Kn--; )
            ot[Kn] = arguments[Kn];
          if (_e)
            var bn = Ii(Te), Yn = Xl(ot, bn);
          if (a && (ot = bu(ot, a, l, _e)), _ && (ot = mu(ot, _, m, _e)), et -= Yn, _e && et < W) {
            var Gt = Hr(ot, bn);
            return Iu(
              e,
              t,
              ff,
              Te.placeholder,
              i,
              ot,
              Gt,
              E,
              T,
              W - et
            );
          }
          var _r = z ? i : this, jr = te ? _r[e] : e;
          return et = ot.length, E ? ot = f0(ot, E) : Ae && et > 1 && ot.reverse(), j && T < et && (ot.length = T), this && this !== Xt && this instanceof Te && (jr = Ye || ho(jr)), jr.apply(_r, ot);
        }
        return Te;
      }
      function Tu(e, t) {
        return function(i, a) {
          return pd(i, e, t(a), {});
        };
      }
      function af(e, t) {
        return function(i, a) {
          var l;
          if (i === n && a === n)
            return t;
          if (i !== n && (l = i), a !== n) {
            if (l === n)
              return a;
            typeof i == "string" || typeof a == "string" ? (i = jn(i), a = jn(a)) : (i = hu(i), a = hu(a)), l = e(i, a);
          }
          return l;
        };
      }
      function xa(e) {
        return Fr(function(t) {
          return t = Tt(t, Wn(Re())), He(function(i) {
            var a = this;
            return e(t, function(l) {
              return Je(l, a, i);
            });
          });
        });
      }
      function sf(e, t) {
        t = t === n ? " " : jn(t);
        var i = t.length;
        if (i < 2)
          return i ? ha(t, e) : t;
        var a = ha(t, Go(e / mi(t)));
        return bi(t) ? Zr(pr(a), 0, e).join("") : a.slice(0, e);
      }
      function jd(e, t, i, a) {
        var l = t & Ge, _ = ho(e);
        function m() {
          for (var E = -1, T = arguments.length, W = -1, j = a.length, z = $(j + T), te = this && this !== Xt && this instanceof m ? _ : e; ++W < j; )
            z[W] = a[W];
          for (; T--; )
            z[W++] = arguments[++E];
          return Je(te, l ? i : this, z);
        }
        return m;
      }
      function Ou(e) {
        return function(t, i, a) {
          return a && typeof a != "number" && xn(t, i, a) && (i = a = n), t = Wr(t), i === n ? (i = t, t = 0) : i = Wr(i), a = a === n ? t < i ? 1 : -1 : Wr(a), Ad(t, i, a, e);
        };
      }
      function uf(e) {
        return function(t, i) {
          return typeof t == "string" && typeof i == "string" || (t = or(t), i = or(i)), e(t, i);
        };
      }
      function Iu(e, t, i, a, l, _, m, E, T, W) {
        var j = t & yt, z = j ? m : n, te = j ? n : m, _e = j ? _ : n, Ae = j ? n : _;
        t |= j ? nt : ht, t &= ~(j ? ht : nt), t & Fe || (t &= ~(Ge | mt));
        var Ye = [
          e,
          t,
          l,
          _e,
          z,
          Ae,
          te,
          E,
          T,
          W
        ], Te = i.apply(n, Ye);
        return Ta(e) && ju(Te, Ye), Te.placeholder = a, ku(Te, e, t);
      }
      function ba(e) {
        var t = en[e];
        return function(i, a) {
          if (i = or(i), a = a == null ? 0 : pn(ke(a), 292), a && ks(i)) {
            var l = (vt(i) + "e").split("e"), _ = t(l[0] + "e" + (+l[1] + a));
            return l = (vt(_) + "e").split("e"), +(l[0] + "e" + (+l[1] - a));
          }
          return t(i);
        };
      }
      var kd = Si && 1 / Fo(new Si([, -0]))[1] == de ? function(e) {
        return new Si(e);
      } : ka;
      function Pu(e) {
        return function(t) {
          var i = gn(t);
          return i == an ? Jf(t) : i == Bt ? oh(t) : Zl(t, e(t));
        };
      }
      function Nr(e, t, i, a, l, _, m, E) {
        var T = t & mt;
        if (!T && typeof e != "function")
          throw new er(I);
        var W = a ? a.length : 0;
        if (W || (t &= ~(nt | ht), a = l = n), m = m === n ? m : tn(ke(m), 0), E = E === n ? E : ke(E), W -= l ? l.length : 0, t & ht) {
          var j = a, z = l;
          a = l = n;
        }
        var te = T ? n : Ea(e), _e = [
          e,
          t,
          i,
          a,
          l,
          j,
          z,
          _,
          m,
          E
        ];
        if (te && r0(_e, te), e = _e[0], t = _e[1], i = _e[2], a = _e[3], l = _e[4], E = _e[9] = _e[9] === n ? T ? 0 : e.length : tn(_e[9] - W, 0), !E && t & (yt | ft) && (t &= ~(yt | ft)), !t || t == Ge)
          var Ae = Bd(e, t, i);
        else t == yt || t == ft ? Ae = Wd(e, t, E) : (t == nt || t == (Ge | nt)) && !l.length ? Ae = jd(e, t, i, a) : Ae = ff.apply(n, _e);
        var Ye = te ? cu : ju;
        return ku(Ye(Ae, _e), e, t);
      }
      function Cu(e, t, i, a) {
        return e === n || vr(e, Ei[i]) && !bt.call(a, i) ? t : e;
      }
      function Uu(e, t, i, a, l, _) {
        return Ft(e) && Ft(t) && (_.set(t, e), tf(e, t, n, Uu, _), _.delete(t)), e;
      }
      function Kd(e) {
        return vo(e) ? n : e;
      }
      function Lu(e, t, i, a, l, _) {
        var m = i & tt, E = e.length, T = t.length;
        if (E != T && !(m && T > E))
          return !1;
        var W = _.get(e), j = _.get(t);
        if (W && j)
          return W == t && j == e;
        var z = -1, te = !0, _e = i & We ? new oi() : n;
        for (_.set(e, t), _.set(t, e); ++z < E; ) {
          var Ae = e[z], Ye = t[z];
          if (a)
            var Te = m ? a(Ye, Ae, z, t, e, _) : a(Ae, Ye, z, e, t, _);
          if (Te !== n) {
            if (Te)
              continue;
            te = !1;
            break;
          }
          if (_e) {
            if (!Yf(t, function(et, ot) {
              if (!to(_e, ot) && (Ae === et || l(Ae, et, i, a, _)))
                return _e.push(ot);
            })) {
              te = !1;
              break;
            }
          } else if (!(Ae === Ye || l(Ae, Ye, i, a, _))) {
            te = !1;
            break;
          }
        }
        return _.delete(e), _.delete(t), te;
      }
      function Yd(e, t, i, a, l, _, m) {
        switch (i) {
          case Tn:
            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
              return !1;
            e = e.buffer, t = t.buffer;
          case rn:
            return !(e.byteLength != t.byteLength || !_(new Ko(e), new Ko(t)));
          case Xe:
          case Ke:
          case An:
            return vr(+e, +t);
          case sr:
            return e.name == t.name && e.message == t.message;
          case Yt:
          case hn:
            return e == t + "";
          case an:
            var E = Jf;
          case Bt:
            var T = a & tt;
            if (E || (E = Fo), e.size != t.size && !T)
              return !1;
            var W = m.get(e);
            if (W)
              return W == t;
            a |= We, m.set(e, t);
            var j = Lu(E(e), E(t), a, l, _, m);
            return m.delete(e), j;
          case Nn:
            if (fo)
              return fo.call(e) == fo.call(t);
        }
        return !1;
      }
      function zd(e, t, i, a, l, _) {
        var m = i & tt, E = ma(e), T = E.length, W = ma(t), j = W.length;
        if (T != j && !m)
          return !1;
        for (var z = T; z--; ) {
          var te = E[z];
          if (!(m ? te in t : bt.call(t, te)))
            return !1;
        }
        var _e = _.get(e), Ae = _.get(t);
        if (_e && Ae)
          return _e == t && Ae == e;
        var Ye = !0;
        _.set(e, t), _.set(t, e);
        for (var Te = m; ++z < T; ) {
          te = E[z];
          var et = e[te], ot = t[te];
          if (a)
            var Kn = m ? a(ot, et, te, t, e, _) : a(et, ot, te, e, t, _);
          if (!(Kn === n ? et === ot || l(et, ot, i, a, _) : Kn)) {
            Ye = !1;
            break;
          }
          Te || (Te = te == "constructor");
        }
        if (Ye && !Te) {
          var bn = e.constructor, Yn = t.constructor;
          bn != Yn && "constructor" in e && "constructor" in t && !(typeof bn == "function" && bn instanceof bn && typeof Yn == "function" && Yn instanceof Yn) && (Ye = !1);
        }
        return _.delete(e), _.delete(t), Ye;
      }
      function Fr(e) {
        return Ia(Bu(e, n, qu), e + "");
      }
      function ma(e) {
        return Qs(e, on, Ra);
      }
      function wa(e) {
        return Qs(e, Un, Mu);
      }
      var Ea = Vo ? function(e) {
        return Vo.get(e);
      } : ka;
      function cf(e) {
        for (var t = e.name + "", i = Ri[t], a = bt.call(Ri, t) ? i.length : 0; a--; ) {
          var l = i[a], _ = l.func;
          if (_ == null || _ == e)
            return l.name;
        }
        return t;
      }
      function Ii(e) {
        var t = bt.call(g, "placeholder") ? g : e;
        return t.placeholder;
      }
      function Re() {
        var e = g.iteratee || Wa;
        return e = e === Wa ? nu : e, arguments.length ? e(arguments[0], arguments[1]) : e;
      }
      function lf(e, t) {
        var i = e.__data__;
        return Qd(t) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
      }
      function Sa(e) {
        for (var t = on(e), i = t.length; i--; ) {
          var a = t[i], l = e[a];
          t[i] = [a, l, Fu(l)];
        }
        return t;
      }
      function si(e, t) {
        var i = nh(e, t);
        return tu(i) ? i : n;
      }
      function Hd(e) {
        var t = bt.call(e, ri), i = e[ri];
        try {
          e[ri] = n;
          var a = !0;
        } catch {
        }
        var l = jo.call(e);
        return a && (t ? e[ri] = i : delete e[ri]), l;
      }
      var Ra = Xf ? function(e) {
        return e == null ? [] : (e = Ot(e), Qn(Xf(e), function(t) {
          return Ws.call(e, t);
        }));
      } : Ka, Mu = Xf ? function(e) {
        for (var t = []; e; )
          Tr(t, Ra(e)), e = Yo(e);
        return t;
      } : Ka, gn = yn;
      (Qf && gn(new Qf(new ArrayBuffer(1))) != Tn || ro && gn(new ro()) != an || ea && gn(ea.resolve()) != mr || Si && gn(new Si()) != Bt || io && gn(new io()) != dn) && (gn = function(e) {
        var t = yn(e), i = t == qt ? e.constructor : n, a = i ? ui(i) : "";
        if (a)
          switch (a) {
            case Oh:
              return Tn;
            case Ih:
              return an;
            case Ph:
              return mr;
            case Ch:
              return Bt;
            case Uh:
              return dn;
          }
        return t;
      });
      function Gd(e, t, i) {
        for (var a = -1, l = i.length; ++a < l; ) {
          var _ = i[a], m = _.size;
          switch (_.type) {
            case "drop":
              e += m;
              break;
            case "dropRight":
              t -= m;
              break;
            case "take":
              t = pn(t, e + m);
              break;
            case "takeRight":
              e = tn(e, t - m);
              break;
          }
        }
        return { start: e, end: t };
      }
      function qd(e) {
        var t = e.match(f);
        return t ? t[1].split(y) : [];
      }
      function $u(e, t, i) {
        t = Jr(t, e);
        for (var a = -1, l = t.length, _ = !1; ++a < l; ) {
          var m = Pr(t[a]);
          if (!(_ = e != null && i(e, m)))
            break;
          e = e[m];
        }
        return _ || ++a != l ? _ : (l = e == null ? 0 : e.length, !!l && yf(l) && Dr(m, l) && (De(e) || ci(e)));
      }
      function Vd(e) {
        var t = e.length, i = new e.constructor(t);
        return t && typeof e[0] == "string" && bt.call(e, "index") && (i.index = e.index, i.input = e.input), i;
      }
      function Nu(e) {
        return typeof e.constructor == "function" && !po(e) ? Ai(Yo(e)) : {};
      }
      function Jd(e, t, i) {
        var a = e.constructor;
        switch (t) {
          case rn:
            return ya(e);
          case Xe:
          case Ke:
            return new a(+e);
          case Tn:
            return Ld(e, i);
          case cr:
          case wr:
          case vn:
          case lr:
          case Vn:
          case Fn:
          case Jt:
          case On:
          case Jn:
            return yu(e, i);
          case an:
            return new a();
          case An:
          case hn:
            return new a(e);
          case Yt:
            return Md(e);
          case Bt:
            return new a();
          case Nn:
            return $d(e);
        }
      }
      function Zd(e, t) {
        var i = t.length;
        if (!i)
          return e;
        var a = i - 1;
        return t[a] = (i > 1 ? "& " : "") + t[a], t = t.join(i > 2 ? ", " : " "), e.replace(d, `{
/* [wrapped with ` + t + `] */
`);
      }
      function Xd(e) {
        return De(e) || ci(e) || !!(js && e && e[js]);
      }
      function Dr(e, t) {
        var i = typeof e;
        return t = t ?? It, !!t && (i == "number" || i != "symbol" && oe.test(e)) && e > -1 && e % 1 == 0 && e < t;
      }
      function xn(e, t, i) {
        if (!Ft(i))
          return !1;
        var a = typeof t;
        return (a == "number" ? Cn(i) && Dr(t, i.length) : a == "string" && t in i) ? vr(i[t], e) : !1;
      }
      function Aa(e, t) {
        if (De(e))
          return !1;
        var i = typeof e;
        return i == "number" || i == "symbol" || i == "boolean" || e == null || kn(e) ? !0 : Ur.test(e) || !Rr.test(e) || t != null && e in Ot(t);
      }
      function Qd(e) {
        var t = typeof e;
        return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
      }
      function Ta(e) {
        var t = cf(e), i = g[t];
        if (typeof i != "function" || !(t in it.prototype))
          return !1;
        if (e === i)
          return !0;
        var a = Ea(i);
        return !!a && e === a[0];
      }
      function e0(e) {
        return !!Fs && Fs in e;
      }
      var t0 = Bo ? Br : Ya;
      function po(e) {
        var t = e && e.constructor, i = typeof t == "function" && t.prototype || Ei;
        return e === i;
      }
      function Fu(e) {
        return e === e && !Ft(e);
      }
      function Du(e, t) {
        return function(i) {
          return i == null ? !1 : i[e] === t && (t !== n || e in Ot(i));
        };
      }
      function n0(e) {
        var t = vf(e, function(a) {
          return i.size === Z && i.clear(), a;
        }), i = t.cache;
        return t;
      }
      function r0(e, t) {
        var i = e[1], a = t[1], l = i | a, _ = l < (Ge | mt | Ut), m = a == Ut && i == yt || a == Ut && i == nn && e[7].length <= t[8] || a == (Ut | nn) && t[7].length <= t[8] && i == yt;
        if (!(_ || m))
          return e;
        a & Ge && (e[2] = t[2], l |= i & Ge ? 0 : Fe);
        var E = t[3];
        if (E) {
          var T = e[3];
          e[3] = T ? bu(T, E, t[4]) : E, e[4] = T ? Hr(e[3], he) : t[4];
        }
        return E = t[5], E && (T = e[5], e[5] = T ? mu(T, E, t[6]) : E, e[6] = T ? Hr(e[5], he) : t[6]), E = t[7], E && (e[7] = E), a & Ut && (e[8] = e[8] == null ? t[8] : pn(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = l, e;
      }
      function i0(e) {
        var t = [];
        if (e != null)
          for (var i in Ot(e))
            t.push(i);
        return t;
      }
      function o0(e) {
        return jo.call(e);
      }
      function Bu(e, t, i) {
        return t = tn(t === n ? e.length - 1 : t, 0), function() {
          for (var a = arguments, l = -1, _ = tn(a.length - t, 0), m = $(_); ++l < _; )
            m[l] = a[t + l];
          l = -1;
          for (var E = $(t + 1); ++l < t; )
            E[l] = a[l];
          return E[t] = i(m), Je(e, this, E);
        };
      }
      function Wu(e, t) {
        return t.length < 2 ? e : ai(e, rr(t, 0, -1));
      }
      function f0(e, t) {
        for (var i = e.length, a = pn(t.length, i), l = Pn(e); a--; ) {
          var _ = t[a];
          e[a] = Dr(_, i) ? l[_] : n;
        }
        return e;
      }
      function Oa(e, t) {
        if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
          return e[t];
      }
      var ju = Ku(cu), go = mh || function(e, t) {
        return Xt.setTimeout(e, t);
      }, Ia = Ku(Id);
      function ku(e, t, i) {
        var a = t + "";
        return Ia(e, Zd(a, a0(qd(a), i)));
      }
      function Ku(e) {
        var t = 0, i = 0;
        return function() {
          var a = Rh(), l = kt - (a - i);
          if (i = a, l > 0) {
            if (++t >= $n)
              return arguments[0];
          } else
            t = 0;
          return e.apply(n, arguments);
        };
      }
      function hf(e, t) {
        var i = -1, a = e.length, l = a - 1;
        for (t = t === n ? a : t; ++i < t; ) {
          var _ = la(i, l), m = e[_];
          e[_] = e[i], e[i] = m;
        }
        return e.length = t, e;
      }
      var Yu = n0(function(e) {
        var t = [];
        return e.charCodeAt(0) === 46 && t.push(""), e.replace(dr, function(i, a, l, _) {
          t.push(l ? _.replace(S, "$1") : a || i);
        }), t;
      });
      function Pr(e) {
        if (typeof e == "string" || kn(e))
          return e;
        var t = e + "";
        return t == "0" && 1 / e == -de ? "-0" : t;
      }
      function ui(e) {
        if (e != null) {
          try {
            return Wo.call(e);
          } catch {
          }
          try {
            return e + "";
          } catch {
          }
        }
        return "";
      }
      function a0(e, t) {
        return at(Oe, function(i) {
          var a = "_." + i[0];
          t & i[1] && !ni(e, a) && e.push(a);
        }), e.sort();
      }
      function zu(e) {
        if (e instanceof it)
          return e.clone();
        var t = new tr(e.__wrapped__, e.__chain__);
        return t.__actions__ = Pn(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
      }
      function s0(e, t, i) {
        (i ? xn(e, t, i) : t === n) ? t = 1 : t = tn(ke(t), 0);
        var a = e == null ? 0 : e.length;
        if (!a || t < 1)
          return [];
        for (var l = 0, _ = 0, m = $(Go(a / t)); l < a; )
          m[_++] = rr(e, l, l += t);
        return m;
      }
      function u0(e) {
        for (var t = -1, i = e == null ? 0 : e.length, a = 0, l = []; ++t < i; ) {
          var _ = e[t];
          _ && (l[a++] = _);
        }
        return l;
      }
      function c0() {
        var e = arguments.length;
        if (!e)
          return [];
        for (var t = $(e - 1), i = arguments[0], a = e; a--; )
          t[a - 1] = arguments[a];
        return Tr(De(i) ? Pn(i) : [i], un(t, 1));
      }
      var l0 = He(function(e, t) {
        return Ht(e) ? so(e, un(t, 1, Ht, !0)) : [];
      }), h0 = He(function(e, t) {
        var i = ir(t);
        return Ht(i) && (i = n), Ht(e) ? so(e, un(t, 1, Ht, !0), Re(i, 2)) : [];
      }), d0 = He(function(e, t) {
        var i = ir(t);
        return Ht(i) && (i = n), Ht(e) ? so(e, un(t, 1, Ht, !0), n, i) : [];
      });
      function p0(e, t, i) {
        var a = e == null ? 0 : e.length;
        return a ? (t = i || t === n ? 1 : ke(t), rr(e, t < 0 ? 0 : t, a)) : [];
      }
      function g0(e, t, i) {
        var a = e == null ? 0 : e.length;
        return a ? (t = i || t === n ? 1 : ke(t), t = a - t, rr(e, 0, t < 0 ? 0 : t)) : [];
      }
      function v0(e, t) {
        return e && e.length ? rf(e, Re(t, 3), !0, !0) : [];
      }
      function _0(e, t) {
        return e && e.length ? rf(e, Re(t, 3), !0) : [];
      }
      function y0(e, t, i, a) {
        var l = e == null ? 0 : e.length;
        return l ? (i && typeof i != "number" && xn(e, t, i) && (i = 0, a = l), cd(e, t, i, a)) : [];
      }
      function Hu(e, t, i) {
        var a = e == null ? 0 : e.length;
        if (!a)
          return -1;
        var l = i == null ? 0 : ke(i);
        return l < 0 && (l = tn(a + l, 0)), No(e, Re(t, 3), l);
      }
      function Gu(e, t, i) {
        var a = e == null ? 0 : e.length;
        if (!a)
          return -1;
        var l = a - 1;
        return i !== n && (l = ke(i), l = i < 0 ? tn(a + l, 0) : pn(l, a - 1)), No(e, Re(t, 3), l, !0);
      }
      function qu(e) {
        var t = e == null ? 0 : e.length;
        return t ? un(e, 1) : [];
      }
      function x0(e) {
        var t = e == null ? 0 : e.length;
        return t ? un(e, de) : [];
      }
      function b0(e, t) {
        var i = e == null ? 0 : e.length;
        return i ? (t = t === n ? 1 : ke(t), un(e, t)) : [];
      }
      function m0(e) {
        for (var t = -1, i = e == null ? 0 : e.length, a = {}; ++t < i; ) {
          var l = e[t];
          a[l[0]] = l[1];
        }
        return a;
      }
      function Vu(e) {
        return e && e.length ? e[0] : n;
      }
      function w0(e, t, i) {
        var a = e == null ? 0 : e.length;
        if (!a)
          return -1;
        var l = i == null ? 0 : ke(i);
        return l < 0 && (l = tn(a + l, 0)), xi(e, t, l);
      }
      function E0(e) {
        var t = e == null ? 0 : e.length;
        return t ? rr(e, 0, -1) : [];
      }
      var S0 = He(function(e) {
        var t = Tt(e, va);
        return t.length && t[0] === e[0] ? fa(t) : [];
      }), R0 = He(function(e) {
        var t = ir(e), i = Tt(e, va);
        return t === ir(i) ? t = n : i.pop(), i.length && i[0] === e[0] ? fa(i, Re(t, 2)) : [];
      }), A0 = He(function(e) {
        var t = ir(e), i = Tt(e, va);
        return t = typeof t == "function" ? t : n, t && i.pop(), i.length && i[0] === e[0] ? fa(i, n, t) : [];
      });
      function T0(e, t) {
        return e == null ? "" : Eh.call(e, t);
      }
      function ir(e) {
        var t = e == null ? 0 : e.length;
        return t ? e[t - 1] : n;
      }
      function O0(e, t, i) {
        var a = e == null ? 0 : e.length;
        if (!a)
          return -1;
        var l = a;
        return i !== n && (l = ke(i), l = l < 0 ? tn(a + l, 0) : pn(l, a - 1)), t === t ? ah(e, t, l) : No(e, Is, l, !0);
      }
      function I0(e, t) {
        return e && e.length ? fu(e, ke(t)) : n;
      }
      var P0 = He(Ju);
      function Ju(e, t) {
        return e && e.length && t && t.length ? ca(e, t) : e;
      }
      function C0(e, t, i) {
        return e && e.length && t && t.length ? ca(e, t, Re(i, 2)) : e;
      }
      function U0(e, t, i) {
        return e && e.length && t && t.length ? ca(e, t, n, i) : e;
      }
      var L0 = Fr(function(e, t) {
        var i = e == null ? 0 : e.length, a = na(e, t);
        return uu(e, Tt(t, function(l) {
          return Dr(l, i) ? +l : l;
        }).sort(xu)), a;
      });
      function M0(e, t) {
        var i = [];
        if (!(e && e.length))
          return i;
        var a = -1, l = [], _ = e.length;
        for (t = Re(t, 3); ++a < _; ) {
          var m = e[a];
          t(m, a, e) && (i.push(m), l.push(a));
        }
        return uu(e, l), i;
      }
      function Pa(e) {
        return e == null ? e : Th.call(e);
      }
      function $0(e, t, i) {
        var a = e == null ? 0 : e.length;
        return a ? (i && typeof i != "number" && xn(e, t, i) ? (t = 0, i = a) : (t = t == null ? 0 : ke(t), i = i === n ? a : ke(i)), rr(e, t, i)) : [];
      }
      function N0(e, t) {
        return nf(e, t);
      }
      function F0(e, t, i) {
        return da(e, t, Re(i, 2));
      }
      function D0(e, t) {
        var i = e == null ? 0 : e.length;
        if (i) {
          var a = nf(e, t);
          if (a < i && vr(e[a], t))
            return a;
        }
        return -1;
      }
      function B0(e, t) {
        return nf(e, t, !0);
      }
      function W0(e, t, i) {
        return da(e, t, Re(i, 2), !0);
      }
      function j0(e, t) {
        var i = e == null ? 0 : e.length;
        if (i) {
          var a = nf(e, t, !0) - 1;
          if (vr(e[a], t))
            return a;
        }
        return -1;
      }
      function k0(e) {
        return e && e.length ? lu(e) : [];
      }
      function K0(e, t) {
        return e && e.length ? lu(e, Re(t, 2)) : [];
      }
      function Y0(e) {
        var t = e == null ? 0 : e.length;
        return t ? rr(e, 1, t) : [];
      }
      function z0(e, t, i) {
        return e && e.length ? (t = i || t === n ? 1 : ke(t), rr(e, 0, t < 0 ? 0 : t)) : [];
      }
      function H0(e, t, i) {
        var a = e == null ? 0 : e.length;
        return a ? (t = i || t === n ? 1 : ke(t), t = a - t, rr(e, t < 0 ? 0 : t, a)) : [];
      }
      function G0(e, t) {
        return e && e.length ? rf(e, Re(t, 3), !1, !0) : [];
      }
      function q0(e, t) {
        return e && e.length ? rf(e, Re(t, 3)) : [];
      }
      var V0 = He(function(e) {
        return Vr(un(e, 1, Ht, !0));
      }), J0 = He(function(e) {
        var t = ir(e);
        return Ht(t) && (t = n), Vr(un(e, 1, Ht, !0), Re(t, 2));
      }), Z0 = He(function(e) {
        var t = ir(e);
        return t = typeof t == "function" ? t : n, Vr(un(e, 1, Ht, !0), n, t);
      });
      function X0(e) {
        return e && e.length ? Vr(e) : [];
      }
      function Q0(e, t) {
        return e && e.length ? Vr(e, Re(t, 2)) : [];
      }
      function ep(e, t) {
        return t = typeof t == "function" ? t : n, e && e.length ? Vr(e, n, t) : [];
      }
      function Ca(e) {
        if (!(e && e.length))
          return [];
        var t = 0;
        return e = Qn(e, function(i) {
          if (Ht(i))
            return t = tn(i.length, t), !0;
        }), qf(t, function(i) {
          return Tt(e, zf(i));
        });
      }
      function Zu(e, t) {
        if (!(e && e.length))
          return [];
        var i = Ca(e);
        return t == null ? i : Tt(i, function(a) {
          return Je(t, n, a);
        });
      }
      var tp = He(function(e, t) {
        return Ht(e) ? so(e, t) : [];
      }), np = He(function(e) {
        return ga(Qn(e, Ht));
      }), rp = He(function(e) {
        var t = ir(e);
        return Ht(t) && (t = n), ga(Qn(e, Ht), Re(t, 2));
      }), ip = He(function(e) {
        var t = ir(e);
        return t = typeof t == "function" ? t : n, ga(Qn(e, Ht), n, t);
      }), op = He(Ca);
      function fp(e, t) {
        return gu(e || [], t || [], ao);
      }
      function ap(e, t) {
        return gu(e || [], t || [], lo);
      }
      var sp = He(function(e) {
        var t = e.length, i = t > 1 ? e[t - 1] : n;
        return i = typeof i == "function" ? (e.pop(), i) : n, Zu(e, i);
      });
      function Xu(e) {
        var t = g(e);
        return t.__chain__ = !0, t;
      }
      function up(e, t) {
        return t(e), e;
      }
      function df(e, t) {
        return t(e);
      }
      var cp = Fr(function(e) {
        var t = e.length, i = t ? e[0] : 0, a = this.__wrapped__, l = function(_) {
          return na(_, e);
        };
        return t > 1 || this.__actions__.length || !(a instanceof it) || !Dr(i) ? this.thru(l) : (a = a.slice(i, +i + (t ? 1 : 0)), a.__actions__.push({
          func: df,
          args: [l],
          thisArg: n
        }), new tr(a, this.__chain__).thru(function(_) {
          return t && !_.length && _.push(n), _;
        }));
      });
      function lp() {
        return Xu(this);
      }
      function hp() {
        return new tr(this.value(), this.__chain__);
      }
      function dp() {
        this.__values__ === n && (this.__values__ = hc(this.value()));
        var e = this.__index__ >= this.__values__.length, t = e ? n : this.__values__[this.__index__++];
        return { done: e, value: t };
      }
      function pp() {
        return this;
      }
      function gp(e) {
        for (var t, i = this; i instanceof Zo; ) {
          var a = zu(i);
          a.__index__ = 0, a.__values__ = n, t ? l.__wrapped__ = a : t = a;
          var l = a;
          i = i.__wrapped__;
        }
        return l.__wrapped__ = e, t;
      }
      function vp() {
        var e = this.__wrapped__;
        if (e instanceof it) {
          var t = e;
          return this.__actions__.length && (t = new it(this)), t = t.reverse(), t.__actions__.push({
            func: df,
            args: [Pa],
            thisArg: n
          }), new tr(t, this.__chain__);
        }
        return this.thru(Pa);
      }
      function _p() {
        return pu(this.__wrapped__, this.__actions__);
      }
      var yp = of(function(e, t, i) {
        bt.call(e, i) ? ++e[i] : $r(e, i, 1);
      });
      function xp(e, t, i) {
        var a = De(e) ? ti : ud;
        return i && xn(e, t, i) && (t = n), a(e, Re(t, 3));
      }
      function bp(e, t) {
        var i = De(e) ? Qn : Zs;
        return i(e, Re(t, 3));
      }
      var mp = Ru(Hu), wp = Ru(Gu);
      function Ep(e, t) {
        return un(pf(e, t), 1);
      }
      function Sp(e, t) {
        return un(pf(e, t), de);
      }
      function Rp(e, t, i) {
        return i = i === n ? 1 : ke(i), un(pf(e, t), i);
      }
      function Qu(e, t) {
        var i = De(e) ? at : qr;
        return i(e, Re(t, 3));
      }
      function ec(e, t) {
        var i = De(e) ? Qt : Js;
        return i(e, Re(t, 3));
      }
      var Ap = of(function(e, t, i) {
        bt.call(e, i) ? e[i].push(t) : $r(e, i, [t]);
      });
      function Tp(e, t, i, a) {
        e = Cn(e) ? e : Ci(e), i = i && !a ? ke(i) : 0;
        var l = e.length;
        return i < 0 && (i = tn(l + i, 0)), xf(e) ? i <= l && e.indexOf(t, i) > -1 : !!l && xi(e, t, i) > -1;
      }
      var Op = He(function(e, t, i) {
        var a = -1, l = typeof t == "function", _ = Cn(e) ? $(e.length) : [];
        return qr(e, function(m) {
          _[++a] = l ? Je(t, m, i) : uo(m, t, i);
        }), _;
      }), Ip = of(function(e, t, i) {
        $r(e, i, t);
      });
      function pf(e, t) {
        var i = De(e) ? Tt : ru;
        return i(e, Re(t, 3));
      }
      function Pp(e, t, i, a) {
        return e == null ? [] : (De(t) || (t = t == null ? [] : [t]), i = a ? n : i, De(i) || (i = i == null ? [] : [i]), au(e, t, i));
      }
      var Cp = of(function(e, t, i) {
        e[i ? 0 : 1].push(t);
      }, function() {
        return [[], []];
      });
      function Up(e, t, i) {
        var a = De(e) ? yi : Cs, l = arguments.length < 3;
        return a(e, Re(t, 4), i, l, qr);
      }
      function Lp(e, t, i) {
        var a = De(e) ? Kf : Cs, l = arguments.length < 3;
        return a(e, Re(t, 4), i, l, Js);
      }
      function Mp(e, t) {
        var i = De(e) ? Qn : Zs;
        return i(e, _f(Re(t, 3)));
      }
      function $p(e) {
        var t = De(e) ? Hs : Td;
        return t(e);
      }
      function Np(e, t, i) {
        (i ? xn(e, t, i) : t === n) ? t = 1 : t = ke(t);
        var a = De(e) ? id : Od;
        return a(e, t);
      }
      function Fp(e) {
        var t = De(e) ? od : Pd;
        return t(e);
      }
      function Dp(e) {
        if (e == null)
          return 0;
        if (Cn(e))
          return xf(e) ? mi(e) : e.length;
        var t = gn(e);
        return t == an || t == Bt ? e.size : sa(e).length;
      }
      function Bp(e, t, i) {
        var a = De(e) ? Yf : Cd;
        return i && xn(e, t, i) && (t = n), a(e, Re(t, 3));
      }
      var Wp = He(function(e, t) {
        if (e == null)
          return [];
        var i = t.length;
        return i > 1 && xn(e, t[0], t[1]) ? t = [] : i > 2 && xn(t[0], t[1], t[2]) && (t = [t[0]]), au(e, un(t, 1), []);
      }), gf = bh || function() {
        return Xt.Date.now();
      };
      function jp(e, t) {
        if (typeof t != "function")
          throw new er(I);
        return e = ke(e), function() {
          if (--e < 1)
            return t.apply(this, arguments);
        };
      }
      function tc(e, t, i) {
        return t = i ? n : t, t = e && t == null ? e.length : t, Nr(e, Ut, n, n, n, n, t);
      }
      function nc(e, t) {
        var i;
        if (typeof t != "function")
          throw new er(I);
        return e = ke(e), function() {
          return --e > 0 && (i = t.apply(this, arguments)), e <= 1 && (t = n), i;
        };
      }
      var Ua = He(function(e, t, i) {
        var a = Ge;
        if (i.length) {
          var l = Hr(i, Ii(Ua));
          a |= nt;
        }
        return Nr(e, a, t, i, l);
      }), rc = He(function(e, t, i) {
        var a = Ge | mt;
        if (i.length) {
          var l = Hr(i, Ii(rc));
          a |= nt;
        }
        return Nr(t, a, e, i, l);
      });
      function ic(e, t, i) {
        t = i ? n : t;
        var a = Nr(e, yt, n, n, n, n, n, t);
        return a.placeholder = ic.placeholder, a;
      }
      function oc(e, t, i) {
        t = i ? n : t;
        var a = Nr(e, ft, n, n, n, n, n, t);
        return a.placeholder = oc.placeholder, a;
      }
      function fc(e, t, i) {
        var a, l, _, m, E, T, W = 0, j = !1, z = !1, te = !0;
        if (typeof e != "function")
          throw new er(I);
        t = or(t) || 0, Ft(i) && (j = !!i.leading, z = "maxWait" in i, _ = z ? tn(or(i.maxWait) || 0, t) : _, te = "trailing" in i ? !!i.trailing : te);
        function _e(Gt) {
          var _r = a, jr = l;
          return a = l = n, W = Gt, m = e.apply(jr, _r), m;
        }
        function Ae(Gt) {
          return W = Gt, E = go(et, t), j ? _e(Gt) : m;
        }
        function Ye(Gt) {
          var _r = Gt - T, jr = Gt - W, Rc = t - _r;
          return z ? pn(Rc, _ - jr) : Rc;
        }
        function Te(Gt) {
          var _r = Gt - T, jr = Gt - W;
          return T === n || _r >= t || _r < 0 || z && jr >= _;
        }
        function et() {
          var Gt = gf();
          if (Te(Gt))
            return ot(Gt);
          E = go(et, Ye(Gt));
        }
        function ot(Gt) {
          return E = n, te && a ? _e(Gt) : (a = l = n, m);
        }
        function Kn() {
          E !== n && vu(E), W = 0, a = T = l = E = n;
        }
        function bn() {
          return E === n ? m : ot(gf());
        }
        function Yn() {
          var Gt = gf(), _r = Te(Gt);
          if (a = arguments, l = this, T = Gt, _r) {
            if (E === n)
              return Ae(T);
            if (z)
              return vu(E), E = go(et, t), _e(T);
          }
          return E === n && (E = go(et, t)), m;
        }
        return Yn.cancel = Kn, Yn.flush = bn, Yn;
      }
      var kp = He(function(e, t) {
        return Vs(e, 1, t);
      }), Kp = He(function(e, t, i) {
        return Vs(e, or(t) || 0, i);
      });
      function Yp(e) {
        return Nr(e, Sn);
      }
      function vf(e, t) {
        if (typeof e != "function" || t != null && typeof t != "function")
          throw new er(I);
        var i = function() {
          var a = arguments, l = t ? t.apply(this, a) : a[0], _ = i.cache;
          if (_.has(l))
            return _.get(l);
          var m = e.apply(this, a);
          return i.cache = _.set(l, m) || _, m;
        };
        return i.cache = new (vf.Cache || Mr)(), i;
      }
      vf.Cache = Mr;
      function _f(e) {
        if (typeof e != "function")
          throw new er(I);
        return function() {
          var t = arguments;
          switch (t.length) {
            case 0:
              return !e.call(this);
            case 1:
              return !e.call(this, t[0]);
            case 2:
              return !e.call(this, t[0], t[1]);
            case 3:
              return !e.call(this, t[0], t[1], t[2]);
          }
          return !e.apply(this, t);
        };
      }
      function zp(e) {
        return nc(2, e);
      }
      var Hp = Ud(function(e, t) {
        t = t.length == 1 && De(t[0]) ? Tt(t[0], Wn(Re())) : Tt(un(t, 1), Wn(Re()));
        var i = t.length;
        return He(function(a) {
          for (var l = -1, _ = pn(a.length, i); ++l < _; )
            a[l] = t[l].call(this, a[l]);
          return Je(e, this, a);
        });
      }), La = He(function(e, t) {
        var i = Hr(t, Ii(La));
        return Nr(e, nt, n, t, i);
      }), ac = He(function(e, t) {
        var i = Hr(t, Ii(ac));
        return Nr(e, ht, n, t, i);
      }), Gp = Fr(function(e, t) {
        return Nr(e, nn, n, n, n, t);
      });
      function qp(e, t) {
        if (typeof e != "function")
          throw new er(I);
        return t = t === n ? t : ke(t), He(e, t);
      }
      function Vp(e, t) {
        if (typeof e != "function")
          throw new er(I);
        return t = t == null ? 0 : tn(ke(t), 0), He(function(i) {
          var a = i[t], l = Zr(i, 0, t);
          return a && Tr(l, a), Je(e, this, l);
        });
      }
      function Jp(e, t, i) {
        var a = !0, l = !0;
        if (typeof e != "function")
          throw new er(I);
        return Ft(i) && (a = "leading" in i ? !!i.leading : a, l = "trailing" in i ? !!i.trailing : l), fc(e, t, {
          leading: a,
          maxWait: t,
          trailing: l
        });
      }
      function Zp(e) {
        return tc(e, 1);
      }
      function Xp(e, t) {
        return La(_a(t), e);
      }
      function Qp() {
        if (!arguments.length)
          return [];
        var e = arguments[0];
        return De(e) ? e : [e];
      }
      function eg(e) {
        return nr(e, be);
      }
      function tg(e, t) {
        return t = typeof t == "function" ? t : n, nr(e, be, t);
      }
      function ng(e) {
        return nr(e, me | be);
      }
      function rg(e, t) {
        return t = typeof t == "function" ? t : n, nr(e, me | be, t);
      }
      function ig(e, t) {
        return t == null || qs(e, t, on(t));
      }
      function vr(e, t) {
        return e === t || e !== e && t !== t;
      }
      var og = uf(oa), fg = uf(function(e, t) {
        return e >= t;
      }), ci = eu(/* @__PURE__ */ function() {
        return arguments;
      }()) ? eu : function(e) {
        return jt(e) && bt.call(e, "callee") && !Ws.call(e, "callee");
      }, De = $.isArray, ag = we ? Wn(we) : gd;
      function Cn(e) {
        return e != null && yf(e.length) && !Br(e);
      }
      function Ht(e) {
        return jt(e) && Cn(e);
      }
      function sg(e) {
        return e === !0 || e === !1 || jt(e) && yn(e) == Xe;
      }
      var Xr = wh || Ya, ug = le ? Wn(le) : vd;
      function cg(e) {
        return jt(e) && e.nodeType === 1 && !vo(e);
      }
      function lg(e) {
        if (e == null)
          return !0;
        if (Cn(e) && (De(e) || typeof e == "string" || typeof e.splice == "function" || Xr(e) || Pi(e) || ci(e)))
          return !e.length;
        var t = gn(e);
        if (t == an || t == Bt)
          return !e.size;
        if (po(e))
          return !sa(e).length;
        for (var i in e)
          if (bt.call(e, i))
            return !1;
        return !0;
      }
      function hg(e, t) {
        return co(e, t);
      }
      function dg(e, t, i) {
        i = typeof i == "function" ? i : n;
        var a = i ? i(e, t) : n;
        return a === n ? co(e, t, n, i) : !!a;
      }
      function Ma(e) {
        if (!jt(e))
          return !1;
        var t = yn(e);
        return t == sr || t == St || typeof e.message == "string" && typeof e.name == "string" && !vo(e);
      }
      function pg(e) {
        return typeof e == "number" && ks(e);
      }
      function Br(e) {
        if (!Ft(e))
          return !1;
        var t = yn(e);
        return t == Rn || t == Hn || t == st || t == sn;
      }
      function sc(e) {
        return typeof e == "number" && e == ke(e);
      }
      function yf(e) {
        return typeof e == "number" && e > -1 && e % 1 == 0 && e <= It;
      }
      function Ft(e) {
        var t = typeof e;
        return e != null && (t == "object" || t == "function");
      }
      function jt(e) {
        return e != null && typeof e == "object";
      }
      var uc = Ce ? Wn(Ce) : yd;
      function gg(e, t) {
        return e === t || aa(e, t, Sa(t));
      }
      function vg(e, t, i) {
        return i = typeof i == "function" ? i : n, aa(e, t, Sa(t), i);
      }
      function _g(e) {
        return cc(e) && e != +e;
      }
      function yg(e) {
        if (t0(e))
          throw new Ne(R);
        return tu(e);
      }
      function xg(e) {
        return e === null;
      }
      function bg(e) {
        return e == null;
      }
      function cc(e) {
        return typeof e == "number" || jt(e) && yn(e) == An;
      }
      function vo(e) {
        if (!jt(e) || yn(e) != qt)
          return !1;
        var t = Yo(e);
        if (t === null)
          return !0;
        var i = bt.call(t, "constructor") && t.constructor;
        return typeof i == "function" && i instanceof i && Wo.call(i) == vh;
      }
      var $a = Qe ? Wn(Qe) : xd;
      function mg(e) {
        return sc(e) && e >= -It && e <= It;
      }
      var lc = gt ? Wn(gt) : bd;
      function xf(e) {
        return typeof e == "string" || !De(e) && jt(e) && yn(e) == hn;
      }
      function kn(e) {
        return typeof e == "symbol" || jt(e) && yn(e) == Nn;
      }
      var Pi = At ? Wn(At) : md;
      function wg(e) {
        return e === n;
      }
      function Eg(e) {
        return jt(e) && gn(e) == dn;
      }
      function Sg(e) {
        return jt(e) && yn(e) == qn;
      }
      var Rg = uf(ua), Ag = uf(function(e, t) {
        return e <= t;
      });
      function hc(e) {
        if (!e)
          return [];
        if (Cn(e))
          return xf(e) ? pr(e) : Pn(e);
        if (no && e[no])
          return ih(e[no]());
        var t = gn(e), i = t == an ? Jf : t == Bt ? Fo : Ci;
        return i(e);
      }
      function Wr(e) {
        if (!e)
          return e === 0 ? e : 0;
        if (e = or(e), e === de || e === -de) {
          var t = e < 0 ? -1 : 1;
          return t * ln;
        }
        return e === e ? e : 0;
      }
      function ke(e) {
        var t = Wr(e), i = t % 1;
        return t === t ? i ? t - i : t : 0;
      }
      function dc(e) {
        return e ? fi(ke(e), 0, O) : 0;
      }
      function or(e) {
        if (typeof e == "number")
          return e;
        if (kn(e))
          return fn;
        if (Ft(e)) {
          var t = typeof e.valueOf == "function" ? e.valueOf() : e;
          e = Ft(t) ? t + "" : t;
        }
        if (typeof e != "string")
          return e === 0 ? e : +e;
        e = Us(e);
        var i = ie.test(e);
        return i || ae.test(e) ? jf(e.slice(2), i ? 2 : 8) : Y.test(e) ? fn : +e;
      }
      function pc(e) {
        return Ir(e, Un(e));
      }
      function Tg(e) {
        return e ? fi(ke(e), -It, It) : e === 0 ? e : 0;
      }
      function vt(e) {
        return e == null ? "" : jn(e);
      }
      var Og = Ti(function(e, t) {
        if (po(t) || Cn(t)) {
          Ir(t, on(t), e);
          return;
        }
        for (var i in t)
          bt.call(t, i) && ao(e, i, t[i]);
      }), gc = Ti(function(e, t) {
        Ir(t, Un(t), e);
      }), bf = Ti(function(e, t, i, a) {
        Ir(t, Un(t), e, a);
      }), Ig = Ti(function(e, t, i, a) {
        Ir(t, on(t), e, a);
      }), Pg = Fr(na);
      function Cg(e, t) {
        var i = Ai(e);
        return t == null ? i : Gs(i, t);
      }
      var Ug = He(function(e, t) {
        e = Ot(e);
        var i = -1, a = t.length, l = a > 2 ? t[2] : n;
        for (l && xn(t[0], t[1], l) && (a = 1); ++i < a; )
          for (var _ = t[i], m = Un(_), E = -1, T = m.length; ++E < T; ) {
            var W = m[E], j = e[W];
            (j === n || vr(j, Ei[W]) && !bt.call(e, W)) && (e[W] = _[W]);
          }
        return e;
      }), Lg = He(function(e) {
        return e.push(n, Uu), Je(vc, n, e);
      });
      function Mg(e, t) {
        return Os(e, Re(t, 3), Or);
      }
      function $g(e, t) {
        return Os(e, Re(t, 3), ia);
      }
      function Ng(e, t) {
        return e == null ? e : ra(e, Re(t, 3), Un);
      }
      function Fg(e, t) {
        return e == null ? e : Xs(e, Re(t, 3), Un);
      }
      function Dg(e, t) {
        return e && Or(e, Re(t, 3));
      }
      function Bg(e, t) {
        return e && ia(e, Re(t, 3));
      }
      function Wg(e) {
        return e == null ? [] : ef(e, on(e));
      }
      function jg(e) {
        return e == null ? [] : ef(e, Un(e));
      }
      function Na(e, t, i) {
        var a = e == null ? n : ai(e, t);
        return a === n ? i : a;
      }
      function kg(e, t) {
        return e != null && $u(e, t, ld);
      }
      function Fa(e, t) {
        return e != null && $u(e, t, hd);
      }
      var Kg = Tu(function(e, t, i) {
        t != null && typeof t.toString != "function" && (t = jo.call(t)), e[t] = i;
      }, Ba(Ln)), Yg = Tu(function(e, t, i) {
        t != null && typeof t.toString != "function" && (t = jo.call(t)), bt.call(e, t) ? e[t].push(i) : e[t] = [i];
      }, Re), zg = He(uo);
      function on(e) {
        return Cn(e) ? zs(e) : sa(e);
      }
      function Un(e) {
        return Cn(e) ? zs(e, !0) : wd(e);
      }
      function Hg(e, t) {
        var i = {};
        return t = Re(t, 3), Or(e, function(a, l, _) {
          $r(i, t(a, l, _), a);
        }), i;
      }
      function Gg(e, t) {
        var i = {};
        return t = Re(t, 3), Or(e, function(a, l, _) {
          $r(i, l, t(a, l, _));
        }), i;
      }
      var qg = Ti(function(e, t, i) {
        tf(e, t, i);
      }), vc = Ti(function(e, t, i, a) {
        tf(e, t, i, a);
      }), Vg = Fr(function(e, t) {
        var i = {};
        if (e == null)
          return i;
        var a = !1;
        t = Tt(t, function(_) {
          return _ = Jr(_, e), a || (a = _.length > 1), _;
        }), Ir(e, wa(e), i), a && (i = nr(i, me | Me | be, Kd));
        for (var l = t.length; l--; )
          pa(i, t[l]);
        return i;
      });
      function Jg(e, t) {
        return _c(e, _f(Re(t)));
      }
      var Zg = Fr(function(e, t) {
        return e == null ? {} : Sd(e, t);
      });
      function _c(e, t) {
        if (e == null)
          return {};
        var i = Tt(wa(e), function(a) {
          return [a];
        });
        return t = Re(t), su(e, i, function(a, l) {
          return t(a, l[0]);
        });
      }
      function Xg(e, t, i) {
        t = Jr(t, e);
        var a = -1, l = t.length;
        for (l || (l = 1, e = n); ++a < l; ) {
          var _ = e == null ? n : e[Pr(t[a])];
          _ === n && (a = l, _ = i), e = Br(_) ? _.call(e) : _;
        }
        return e;
      }
      function Qg(e, t, i) {
        return e == null ? e : lo(e, t, i);
      }
      function ev(e, t, i, a) {
        return a = typeof a == "function" ? a : n, e == null ? e : lo(e, t, i, a);
      }
      var yc = Pu(on), xc = Pu(Un);
      function tv(e, t, i) {
        var a = De(e), l = a || Xr(e) || Pi(e);
        if (t = Re(t, 4), i == null) {
          var _ = e && e.constructor;
          l ? i = a ? new _() : [] : Ft(e) ? i = Br(_) ? Ai(Yo(e)) : {} : i = {};
        }
        return (l ? at : Or)(e, function(m, E, T) {
          return t(i, m, E, T);
        }), i;
      }
      function nv(e, t) {
        return e == null ? !0 : pa(e, t);
      }
      function rv(e, t, i) {
        return e == null ? e : du(e, t, _a(i));
      }
      function iv(e, t, i, a) {
        return a = typeof a == "function" ? a : n, e == null ? e : du(e, t, _a(i), a);
      }
      function Ci(e) {
        return e == null ? [] : Vf(e, on(e));
      }
      function ov(e) {
        return e == null ? [] : Vf(e, Un(e));
      }
      function fv(e, t, i) {
        return i === n && (i = t, t = n), i !== n && (i = or(i), i = i === i ? i : 0), t !== n && (t = or(t), t = t === t ? t : 0), fi(or(e), t, i);
      }
      function av(e, t, i) {
        return t = Wr(t), i === n ? (i = t, t = 0) : i = Wr(i), e = or(e), dd(e, t, i);
      }
      function sv(e, t, i) {
        if (i && typeof i != "boolean" && xn(e, t, i) && (t = i = n), i === n && (typeof t == "boolean" ? (i = t, t = n) : typeof e == "boolean" && (i = e, e = n)), e === n && t === n ? (e = 0, t = 1) : (e = Wr(e), t === n ? (t = e, e = 0) : t = Wr(t)), e > t) {
          var a = e;
          e = t, t = a;
        }
        if (i || e % 1 || t % 1) {
          var l = Ks();
          return pn(e + l * (t - e + Qi("1e-" + ((l + "").length - 1))), t);
        }
        return la(e, t);
      }
      var uv = Oi(function(e, t, i) {
        return t = t.toLowerCase(), e + (i ? bc(t) : t);
      });
      function bc(e) {
        return Da(vt(e).toLowerCase());
      }
      function mc(e) {
        return e = vt(e), e && e.replace(se, Ql).replace(Uo, "");
      }
      function cv(e, t, i) {
        e = vt(e), t = jn(t);
        var a = e.length;
        i = i === n ? a : fi(ke(i), 0, a);
        var l = i;
        return i -= t.length, i >= 0 && e.slice(i, l) == t;
      }
      function lv(e) {
        return e = vt(e), e && Zt.test(e) ? e.replace(Zn, eh) : e;
      }
      function hv(e) {
        return e = vt(e), e && Ar.test(e) ? e.replace($t, "\\$&") : e;
      }
      var dv = Oi(function(e, t, i) {
        return e + (i ? "-" : "") + t.toLowerCase();
      }), pv = Oi(function(e, t, i) {
        return e + (i ? " " : "") + t.toLowerCase();
      }), gv = Su("toLowerCase");
      function vv(e, t, i) {
        e = vt(e), t = ke(t);
        var a = t ? mi(e) : 0;
        if (!t || a >= t)
          return e;
        var l = (t - a) / 2;
        return sf(qo(l), i) + e + sf(Go(l), i);
      }
      function _v(e, t, i) {
        e = vt(e), t = ke(t);
        var a = t ? mi(e) : 0;
        return t && a < t ? e + sf(t - a, i) : e;
      }
      function yv(e, t, i) {
        e = vt(e), t = ke(t);
        var a = t ? mi(e) : 0;
        return t && a < t ? sf(t - a, i) + e : e;
      }
      function xv(e, t, i) {
        return i || t == null ? t = 0 : t && (t = +t), Ah(vt(e).replace(u, ""), t || 0);
      }
      function bv(e, t, i) {
        return (i ? xn(e, t, i) : t === n) ? t = 1 : t = ke(t), ha(vt(e), t);
      }
      function mv() {
        var e = arguments, t = vt(e[0]);
        return e.length < 3 ? t : t.replace(e[1], e[2]);
      }
      var wv = Oi(function(e, t, i) {
        return e + (i ? "_" : "") + t.toLowerCase();
      });
      function Ev(e, t, i) {
        return i && typeof i != "number" && xn(e, t, i) && (t = i = n), i = i === n ? O : i >>> 0, i ? (e = vt(e), e && (typeof t == "string" || t != null && !$a(t)) && (t = jn(t), !t && bi(e)) ? Zr(pr(e), 0, i) : e.split(t, i)) : [];
      }
      var Sv = Oi(function(e, t, i) {
        return e + (i ? " " : "") + Da(t);
      });
      function Rv(e, t, i) {
        return e = vt(e), i = i == null ? 0 : fi(ke(i), 0, e.length), t = jn(t), e.slice(i, i + t.length) == t;
      }
      function Av(e, t, i) {
        var a = g.templateSettings;
        i && xn(e, t, i) && (t = n), e = vt(e), t = bf({}, t, a, Cu);
        var l = bf({}, t.imports, a.imports, Cu), _ = on(l), m = Vf(l, _), E, T, W = 0, j = t.interpolate || pe, z = "__p += '", te = Zf(
          (t.escape || pe).source + "|" + j.source + "|" + (j === Sr ? M : pe).source + "|" + (t.evaluate || pe).source + "|$",
          "g"
        ), _e = "//# sourceURL=" + (bt.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Wf + "]") + `
`;
        e.replace(te, function(Te, et, ot, Kn, bn, Yn) {
          return ot || (ot = Kn), z += e.slice(W, Yn).replace(xe, th), et && (E = !0, z += `' +
__e(` + et + `) +
'`), bn && (T = !0, z += `';
` + bn + `;
__p += '`), ot && (z += `' +
((__t = (` + ot + `)) == null ? '' : __t) +
'`), W = Yn + Te.length, Te;
        }), z += `';
`;
        var Ae = bt.call(t, "variable") && t.variable;
        if (!Ae)
          z = `with (obj) {
` + z + `
}
`;
        else if (x.test(Ae))
          throw new Ne(L);
        z = (T ? z.replace(hr, "") : z).replace(In, "$1").replace(Er, "$1;"), z = "function(" + (Ae || "obj") + `) {
` + (Ae ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (E ? ", __e = _.escape" : "") + (T ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + z + `return __p
}`;
        var Ye = Ec(function() {
          return lt(_, _e + "return " + z).apply(n, m);
        });
        if (Ye.source = z, Ma(Ye))
          throw Ye;
        return Ye;
      }
      function Tv(e) {
        return vt(e).toLowerCase();
      }
      function Ov(e) {
        return vt(e).toUpperCase();
      }
      function Iv(e, t, i) {
        if (e = vt(e), e && (i || t === n))
          return Us(e);
        if (!e || !(t = jn(t)))
          return e;
        var a = pr(e), l = pr(t), _ = Ls(a, l), m = Ms(a, l) + 1;
        return Zr(a, _, m).join("");
      }
      function Pv(e, t, i) {
        if (e = vt(e), e && (i || t === n))
          return e.slice(0, Ns(e) + 1);
        if (!e || !(t = jn(t)))
          return e;
        var a = pr(e), l = Ms(a, pr(t)) + 1;
        return Zr(a, 0, l).join("");
      }
      function Cv(e, t, i) {
        if (e = vt(e), e && (i || t === n))
          return e.replace(u, "");
        if (!e || !(t = jn(t)))
          return e;
        var a = pr(e), l = Ls(a, pr(t));
        return Zr(a, l).join("");
      }
      function Uv(e, t) {
        var i = Mn, a = zn;
        if (Ft(t)) {
          var l = "separator" in t ? t.separator : l;
          i = "length" in t ? ke(t.length) : i, a = "omission" in t ? jn(t.omission) : a;
        }
        e = vt(e);
        var _ = e.length;
        if (bi(e)) {
          var m = pr(e);
          _ = m.length;
        }
        if (i >= _)
          return e;
        var E = i - mi(a);
        if (E < 1)
          return a;
        var T = m ? Zr(m, 0, E).join("") : e.slice(0, E);
        if (l === n)
          return T + a;
        if (m && (E += T.length - E), $a(l)) {
          if (e.slice(E).search(l)) {
            var W, j = T;
            for (l.global || (l = Zf(l.source, vt(V.exec(l)) + "g")), l.lastIndex = 0; W = l.exec(j); )
              var z = W.index;
            T = T.slice(0, z === n ? E : z);
          }
        } else if (e.indexOf(jn(l), E) != E) {
          var te = T.lastIndexOf(l);
          te > -1 && (T = T.slice(0, te));
        }
        return T + a;
      }
      function Lv(e) {
        return e = vt(e), e && Xn.test(e) ? e.replace(_n, sh) : e;
      }
      var Mv = Oi(function(e, t, i) {
        return e + (i ? " " : "") + t.toUpperCase();
      }), Da = Su("toUpperCase");
      function wc(e, t, i) {
        return e = vt(e), t = i ? n : t, t === n ? rh(e) ? lh(e) : ql(e) : e.match(t) || [];
      }
      var Ec = He(function(e, t) {
        try {
          return Je(e, n, t);
        } catch (i) {
          return Ma(i) ? i : new Ne(i);
        }
      }), $v = Fr(function(e, t) {
        return at(t, function(i) {
          i = Pr(i), $r(e, i, Ua(e[i], e));
        }), e;
      });
      function Nv(e) {
        var t = e == null ? 0 : e.length, i = Re();
        return e = t ? Tt(e, function(a) {
          if (typeof a[1] != "function")
            throw new er(I);
          return [i(a[0]), a[1]];
        }) : [], He(function(a) {
          for (var l = -1; ++l < t; ) {
            var _ = e[l];
            if (Je(_[0], this, a))
              return Je(_[1], this, a);
          }
        });
      }
      function Fv(e) {
        return sd(nr(e, me));
      }
      function Ba(e) {
        return function() {
          return e;
        };
      }
      function Dv(e, t) {
        return e == null || e !== e ? t : e;
      }
      var Bv = Au(), Wv = Au(!0);
      function Ln(e) {
        return e;
      }
      function Wa(e) {
        return nu(typeof e == "function" ? e : nr(e, me));
      }
      function jv(e) {
        return iu(nr(e, me));
      }
      function kv(e, t) {
        return ou(e, nr(t, me));
      }
      var Kv = He(function(e, t) {
        return function(i) {
          return uo(i, e, t);
        };
      }), Yv = He(function(e, t) {
        return function(i) {
          return uo(e, i, t);
        };
      });
      function ja(e, t, i) {
        var a = on(t), l = ef(t, a);
        i == null && !(Ft(t) && (l.length || !a.length)) && (i = t, t = e, e = this, l = ef(t, on(t)));
        var _ = !(Ft(i) && "chain" in i) || !!i.chain, m = Br(e);
        return at(l, function(E) {
          var T = t[E];
          e[E] = T, m && (e.prototype[E] = function() {
            var W = this.__chain__;
            if (_ || W) {
              var j = e(this.__wrapped__), z = j.__actions__ = Pn(this.__actions__);
              return z.push({ func: T, args: arguments, thisArg: e }), j.__chain__ = W, j;
            }
            return T.apply(e, Tr([this.value()], arguments));
          });
        }), e;
      }
      function zv() {
        return Xt._ === this && (Xt._ = _h), this;
      }
      function ka() {
      }
      function Hv(e) {
        return e = ke(e), He(function(t) {
          return fu(t, e);
        });
      }
      var Gv = xa(Tt), qv = xa(ti), Vv = xa(Yf);
      function Sc(e) {
        return Aa(e) ? zf(Pr(e)) : Rd(e);
      }
      function Jv(e) {
        return function(t) {
          return e == null ? n : ai(e, t);
        };
      }
      var Zv = Ou(), Xv = Ou(!0);
      function Ka() {
        return [];
      }
      function Ya() {
        return !1;
      }
      function Qv() {
        return {};
      }
      function e1() {
        return "";
      }
      function t1() {
        return !0;
      }
      function n1(e, t) {
        if (e = ke(e), e < 1 || e > It)
          return [];
        var i = O, a = pn(e, O);
        t = Re(t), e -= O;
        for (var l = qf(a, t); ++i < e; )
          t(i);
        return l;
      }
      function r1(e) {
        return De(e) ? Tt(e, Pr) : kn(e) ? [e] : Pn(Yu(vt(e)));
      }
      function i1(e) {
        var t = ++gh;
        return vt(e) + t;
      }
      var o1 = af(function(e, t) {
        return e + t;
      }, 0), f1 = ba("ceil"), a1 = af(function(e, t) {
        return e / t;
      }, 1), s1 = ba("floor");
      function u1(e) {
        return e && e.length ? Qo(e, Ln, oa) : n;
      }
      function c1(e, t) {
        return e && e.length ? Qo(e, Re(t, 2), oa) : n;
      }
      function l1(e) {
        return Ps(e, Ln);
      }
      function h1(e, t) {
        return Ps(e, Re(t, 2));
      }
      function d1(e) {
        return e && e.length ? Qo(e, Ln, ua) : n;
      }
      function p1(e, t) {
        return e && e.length ? Qo(e, Re(t, 2), ua) : n;
      }
      var g1 = af(function(e, t) {
        return e * t;
      }, 1), v1 = ba("round"), _1 = af(function(e, t) {
        return e - t;
      }, 0);
      function y1(e) {
        return e && e.length ? Gf(e, Ln) : 0;
      }
      function x1(e, t) {
        return e && e.length ? Gf(e, Re(t, 2)) : 0;
      }
      return g.after = jp, g.ary = tc, g.assign = Og, g.assignIn = gc, g.assignInWith = bf, g.assignWith = Ig, g.at = Pg, g.before = nc, g.bind = Ua, g.bindAll = $v, g.bindKey = rc, g.castArray = Qp, g.chain = Xu, g.chunk = s0, g.compact = u0, g.concat = c0, g.cond = Nv, g.conforms = Fv, g.constant = Ba, g.countBy = yp, g.create = Cg, g.curry = ic, g.curryRight = oc, g.debounce = fc, g.defaults = Ug, g.defaultsDeep = Lg, g.defer = kp, g.delay = Kp, g.difference = l0, g.differenceBy = h0, g.differenceWith = d0, g.drop = p0, g.dropRight = g0, g.dropRightWhile = v0, g.dropWhile = _0, g.fill = y0, g.filter = bp, g.flatMap = Ep, g.flatMapDeep = Sp, g.flatMapDepth = Rp, g.flatten = qu, g.flattenDeep = x0, g.flattenDepth = b0, g.flip = Yp, g.flow = Bv, g.flowRight = Wv, g.fromPairs = m0, g.functions = Wg, g.functionsIn = jg, g.groupBy = Ap, g.initial = E0, g.intersection = S0, g.intersectionBy = R0, g.intersectionWith = A0, g.invert = Kg, g.invertBy = Yg, g.invokeMap = Op, g.iteratee = Wa, g.keyBy = Ip, g.keys = on, g.keysIn = Un, g.map = pf, g.mapKeys = Hg, g.mapValues = Gg, g.matches = jv, g.matchesProperty = kv, g.memoize = vf, g.merge = qg, g.mergeWith = vc, g.method = Kv, g.methodOf = Yv, g.mixin = ja, g.negate = _f, g.nthArg = Hv, g.omit = Vg, g.omitBy = Jg, g.once = zp, g.orderBy = Pp, g.over = Gv, g.overArgs = Hp, g.overEvery = qv, g.overSome = Vv, g.partial = La, g.partialRight = ac, g.partition = Cp, g.pick = Zg, g.pickBy = _c, g.property = Sc, g.propertyOf = Jv, g.pull = P0, g.pullAll = Ju, g.pullAllBy = C0, g.pullAllWith = U0, g.pullAt = L0, g.range = Zv, g.rangeRight = Xv, g.rearg = Gp, g.reject = Mp, g.remove = M0, g.rest = qp, g.reverse = Pa, g.sampleSize = Np, g.set = Qg, g.setWith = ev, g.shuffle = Fp, g.slice = $0, g.sortBy = Wp, g.sortedUniq = k0, g.sortedUniqBy = K0, g.split = Ev, g.spread = Vp, g.tail = Y0, g.take = z0, g.takeRight = H0, g.takeRightWhile = G0, g.takeWhile = q0, g.tap = up, g.throttle = Jp, g.thru = df, g.toArray = hc, g.toPairs = yc, g.toPairsIn = xc, g.toPath = r1, g.toPlainObject = pc, g.transform = tv, g.unary = Zp, g.union = V0, g.unionBy = J0, g.unionWith = Z0, g.uniq = X0, g.uniqBy = Q0, g.uniqWith = ep, g.unset = nv, g.unzip = Ca, g.unzipWith = Zu, g.update = rv, g.updateWith = iv, g.values = Ci, g.valuesIn = ov, g.without = tp, g.words = wc, g.wrap = Xp, g.xor = np, g.xorBy = rp, g.xorWith = ip, g.zip = op, g.zipObject = fp, g.zipObjectDeep = ap, g.zipWith = sp, g.entries = yc, g.entriesIn = xc, g.extend = gc, g.extendWith = bf, ja(g, g), g.add = o1, g.attempt = Ec, g.camelCase = uv, g.capitalize = bc, g.ceil = f1, g.clamp = fv, g.clone = eg, g.cloneDeep = ng, g.cloneDeepWith = rg, g.cloneWith = tg, g.conformsTo = ig, g.deburr = mc, g.defaultTo = Dv, g.divide = a1, g.endsWith = cv, g.eq = vr, g.escape = lv, g.escapeRegExp = hv, g.every = xp, g.find = mp, g.findIndex = Hu, g.findKey = Mg, g.findLast = wp, g.findLastIndex = Gu, g.findLastKey = $g, g.floor = s1, g.forEach = Qu, g.forEachRight = ec, g.forIn = Ng, g.forInRight = Fg, g.forOwn = Dg, g.forOwnRight = Bg, g.get = Na, g.gt = og, g.gte = fg, g.has = kg, g.hasIn = Fa, g.head = Vu, g.identity = Ln, g.includes = Tp, g.indexOf = w0, g.inRange = av, g.invoke = zg, g.isArguments = ci, g.isArray = De, g.isArrayBuffer = ag, g.isArrayLike = Cn, g.isArrayLikeObject = Ht, g.isBoolean = sg, g.isBuffer = Xr, g.isDate = ug, g.isElement = cg, g.isEmpty = lg, g.isEqual = hg, g.isEqualWith = dg, g.isError = Ma, g.isFinite = pg, g.isFunction = Br, g.isInteger = sc, g.isLength = yf, g.isMap = uc, g.isMatch = gg, g.isMatchWith = vg, g.isNaN = _g, g.isNative = yg, g.isNil = bg, g.isNull = xg, g.isNumber = cc, g.isObject = Ft, g.isObjectLike = jt, g.isPlainObject = vo, g.isRegExp = $a, g.isSafeInteger = mg, g.isSet = lc, g.isString = xf, g.isSymbol = kn, g.isTypedArray = Pi, g.isUndefined = wg, g.isWeakMap = Eg, g.isWeakSet = Sg, g.join = T0, g.kebabCase = dv, g.last = ir, g.lastIndexOf = O0, g.lowerCase = pv, g.lowerFirst = gv, g.lt = Rg, g.lte = Ag, g.max = u1, g.maxBy = c1, g.mean = l1, g.meanBy = h1, g.min = d1, g.minBy = p1, g.stubArray = Ka, g.stubFalse = Ya, g.stubObject = Qv, g.stubString = e1, g.stubTrue = t1, g.multiply = g1, g.nth = I0, g.noConflict = zv, g.noop = ka, g.now = gf, g.pad = vv, g.padEnd = _v, g.padStart = yv, g.parseInt = xv, g.random = sv, g.reduce = Up, g.reduceRight = Lp, g.repeat = bv, g.replace = mv, g.result = Xg, g.round = v1, g.runInContext = A, g.sample = $p, g.size = Dp, g.snakeCase = wv, g.some = Bp, g.sortedIndex = N0, g.sortedIndexBy = F0, g.sortedIndexOf = D0, g.sortedLastIndex = B0, g.sortedLastIndexBy = W0, g.sortedLastIndexOf = j0, g.startCase = Sv, g.startsWith = Rv, g.subtract = _1, g.sum = y1, g.sumBy = x1, g.template = Av, g.times = n1, g.toFinite = Wr, g.toInteger = ke, g.toLength = dc, g.toLower = Tv, g.toNumber = or, g.toSafeInteger = Tg, g.toString = vt, g.toUpper = Ov, g.trim = Iv, g.trimEnd = Pv, g.trimStart = Cv, g.truncate = Uv, g.unescape = Lv, g.uniqueId = i1, g.upperCase = Mv, g.upperFirst = Da, g.each = Qu, g.eachRight = ec, g.first = Vu, ja(g, function() {
        var e = {};
        return Or(g, function(t, i) {
          bt.call(g.prototype, i) || (e[i] = t);
        }), e;
      }(), { chain: !1 }), g.VERSION = s, at(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
        g[e].placeholder = g;
      }), at(["drop", "take"], function(e, t) {
        it.prototype[e] = function(i) {
          i = i === n ? 1 : tn(ke(i), 0);
          var a = this.__filtered__ && !t ? new it(this) : this.clone();
          return a.__filtered__ ? a.__takeCount__ = pn(i, a.__takeCount__) : a.__views__.push({
            size: pn(i, O),
            type: e + (a.__dir__ < 0 ? "Right" : "")
          }), a;
        }, it.prototype[e + "Right"] = function(i) {
          return this.reverse()[e](i).reverse();
        };
      }), at(["filter", "map", "takeWhile"], function(e, t) {
        var i = t + 1, a = i == Kt || i == Mt;
        it.prototype[e] = function(l) {
          var _ = this.clone();
          return _.__iteratees__.push({
            iteratee: Re(l, 3),
            type: i
          }), _.__filtered__ = _.__filtered__ || a, _;
        };
      }), at(["head", "last"], function(e, t) {
        var i = "take" + (t ? "Right" : "");
        it.prototype[e] = function() {
          return this[i](1).value()[0];
        };
      }), at(["initial", "tail"], function(e, t) {
        var i = "drop" + (t ? "" : "Right");
        it.prototype[e] = function() {
          return this.__filtered__ ? new it(this) : this[i](1);
        };
      }), it.prototype.compact = function() {
        return this.filter(Ln);
      }, it.prototype.find = function(e) {
        return this.filter(e).head();
      }, it.prototype.findLast = function(e) {
        return this.reverse().find(e);
      }, it.prototype.invokeMap = He(function(e, t) {
        return typeof e == "function" ? new it(this) : this.map(function(i) {
          return uo(i, e, t);
        });
      }), it.prototype.reject = function(e) {
        return this.filter(_f(Re(e)));
      }, it.prototype.slice = function(e, t) {
        e = ke(e);
        var i = this;
        return i.__filtered__ && (e > 0 || t < 0) ? new it(i) : (e < 0 ? i = i.takeRight(-e) : e && (i = i.drop(e)), t !== n && (t = ke(t), i = t < 0 ? i.dropRight(-t) : i.take(t - e)), i);
      }, it.prototype.takeRightWhile = function(e) {
        return this.reverse().takeWhile(e).reverse();
      }, it.prototype.toArray = function() {
        return this.take(O);
      }, Or(it.prototype, function(e, t) {
        var i = /^(?:filter|find|map|reject)|While$/.test(t), a = /^(?:head|last)$/.test(t), l = g[a ? "take" + (t == "last" ? "Right" : "") : t], _ = a || /^find/.test(t);
        l && (g.prototype[t] = function() {
          var m = this.__wrapped__, E = a ? [1] : arguments, T = m instanceof it, W = E[0], j = T || De(m), z = function(et) {
            var ot = l.apply(g, Tr([et], E));
            return a && te ? ot[0] : ot;
          };
          j && i && typeof W == "function" && W.length != 1 && (T = j = !1);
          var te = this.__chain__, _e = !!this.__actions__.length, Ae = _ && !te, Ye = T && !_e;
          if (!_ && j) {
            m = Ye ? m : new it(this);
            var Te = e.apply(m, E);
            return Te.__actions__.push({ func: df, args: [z], thisArg: n }), new tr(Te, te);
          }
          return Ae && Ye ? e.apply(this, E) : (Te = this.thru(z), Ae ? a ? Te.value()[0] : Te.value() : Te);
        });
      }), at(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
        var t = Do[e], i = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", a = /^(?:pop|shift)$/.test(e);
        g.prototype[e] = function() {
          var l = arguments;
          if (a && !this.__chain__) {
            var _ = this.value();
            return t.apply(De(_) ? _ : [], l);
          }
          return this[i](function(m) {
            return t.apply(De(m) ? m : [], l);
          });
        };
      }), Or(it.prototype, function(e, t) {
        var i = g[t];
        if (i) {
          var a = i.name + "";
          bt.call(Ri, a) || (Ri[a] = []), Ri[a].push({ name: t, func: i });
        }
      }), Ri[ff(n, mt).name] = [{
        name: "wrapper",
        func: n
      }], it.prototype.clone = Lh, it.prototype.reverse = Mh, it.prototype.value = $h, g.prototype.at = cp, g.prototype.chain = lp, g.prototype.commit = hp, g.prototype.next = dp, g.prototype.plant = gp, g.prototype.reverse = vp, g.prototype.toJSON = g.prototype.valueOf = g.prototype.value = _p, g.prototype.first = g.prototype.head, no && (g.prototype[no] = pp), g;
    }, wi = hh();
    w ? ((w.exports = wi)._ = wi, c._ = wi) : Xt._ = wi;
  }).call(di);
})(Af, Af.exports);
var I_ = Af.exports;
const br = /* @__PURE__ */ Ro(I_), P_ = "6.13.4";
function Za(o, r, n) {
  for (let s in r) {
    let v = r[s];
    Object.defineProperty(o, s, { enumerable: !0, value: v, writable: !1 });
  }
}
function Mi(o) {
  if (o == null)
    return "null";
  if (Array.isArray(o))
    return "[ " + o.map(Mi).join(", ") + " ]";
  if (o instanceof Uint8Array) {
    const r = "0123456789abcdef";
    let n = "0x";
    for (let s = 0; s < o.length; s++)
      n += r[o[s] >> 4], n += r[o[s] & 15];
    return n;
  }
  if (typeof o == "object" && typeof o.toJSON == "function")
    return Mi(o.toJSON());
  switch (typeof o) {
    case "boolean":
    case "symbol":
      return o.toString();
    case "bigint":
      return BigInt(o).toString();
    case "number":
      return o.toString();
    case "string":
      return JSON.stringify(o);
    case "object": {
      const r = Object.keys(o);
      return r.sort(), "{ " + r.map((n) => `${Mi(n)}: ${Mi(o[n])}`).join(", ") + " }";
    }
  }
  return "[ COULD NOT SERIALIZE ]";
}
function C_(o, r, n) {
  let s = o;
  {
    const R = [];
    if (n) {
      if ("message" in n || "code" in n || "name" in n)
        throw new Error(`value will overwrite populated values: ${Mi(n)}`);
      for (const I in n) {
        if (I === "shortMessage")
          continue;
        const L = n[I];
        R.push(I + "=" + Mi(L));
      }
    }
    R.push(`code=${r}`), R.push(`version=${P_}`), R.length && (o += " (" + R.join(", ") + ")");
  }
  let v;
  switch (r) {
    case "INVALID_ARGUMENT":
      v = new TypeError(o);
      break;
    case "NUMERIC_FAULT":
    case "BUFFER_OVERRUN":
      v = new RangeError(o);
      break;
    default:
      v = new Error(o);
  }
  return Za(v, { code: r }), n && Object.assign(v, n), v.shortMessage == null && Za(v, { shortMessage: s }), v;
}
function ar(o, r, n, s) {
  if (!o)
    throw C_(r, n, s);
}
function cn(o, r, n, s) {
  ar(o, r, "INVALID_ARGUMENT", { argument: n, value: s });
}
["NFD", "NFC", "NFKD", "NFKC"].reduce((o, r) => {
  try {
    if ("test".normalize(r) !== "test")
      throw new Error("bad");
    if (r === "NFD" && "é".normalize("NFD") !== "é")
      throw new Error("broken");
    o.push(r);
  } catch {
  }
  return o;
}, []);
function U_(o, r, n) {
  if (o !== r) {
    let s = n, v = "new";
    s += ".", v += " " + n, ar(!1, `private constructor; use ${s}from* methods`, "UNSUPPORTED_OPERATION", {
      operation: v
    });
  }
}
function L_(o, r, n) {
  if (o instanceof Uint8Array)
    return o;
  if (typeof o == "string" && o.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
    const s = new Uint8Array((o.length - 2) / 2);
    let v = 2;
    for (let R = 0; R < s.length; R++)
      s[R] = parseInt(o.substring(v, v + 2), 16), v += 2;
    return s;
  }
  cn(!1, "invalid BytesLike value", r, o);
}
function M_(o, r) {
  return L_(o, r);
}
const El = BigInt(0), $i = BigInt(1), Ni = 9007199254740991;
function Xa(o, r) {
  const n = Sl(o, "value"), s = BigInt(Pf(r, "width"));
  if (ar(n >> s === El, "overflow", "NUMERIC_FAULT", {
    operation: "fromTwos",
    fault: "overflow",
    value: o
  }), n >> s - $i) {
    const v = ($i << s) - $i;
    return -((~n & v) + $i);
  }
  return n;
}
function Fc(o, r) {
  const n = Sl(o, "value"), s = BigInt(Pf(r, "bits"));
  return n & ($i << s) - $i;
}
function xs(o, r) {
  switch (typeof o) {
    case "bigint":
      return o;
    case "number":
      return cn(Number.isInteger(o), "underflow", r || "value", o), cn(o >= -Ni && o <= Ni, "overflow", r || "value", o), BigInt(o);
    case "string":
      try {
        if (o === "")
          throw new Error("empty string");
        return o[0] === "-" && o[1] !== "-" ? -BigInt(o.substring(1)) : BigInt(o);
      } catch (n) {
        cn(!1, `invalid BigNumberish string: ${n.message}`, r || "value", o);
      }
  }
  cn(!1, "invalid BigNumberish value", r || "value", o);
}
function Sl(o, r) {
  const n = xs(o, r);
  return ar(n >= El, "unsigned value cannot be negative", "NUMERIC_FAULT", {
    fault: "overflow",
    operation: "getUint",
    value: o
  }), n;
}
const Dc = "0123456789abcdef";
function $_(o) {
  if (o instanceof Uint8Array) {
    let r = "0x0";
    for (const n of o)
      r += Dc[n >> 4], r += Dc[n & 15];
    return BigInt(r);
  }
  return xs(o);
}
function Pf(o, r) {
  switch (typeof o) {
    case "bigint":
      return cn(o >= -Ni && o <= Ni, "overflow", r || "value", o), Number(o);
    case "number":
      return cn(Number.isInteger(o), "underflow", r || "value", o), cn(o >= -Ni && o <= Ni, "overflow", r || "value", o), o;
    case "string":
      try {
        if (o === "")
          throw new Error("empty string");
        return Pf(BigInt(o), r);
      } catch (n) {
        cn(!1, `invalid numeric string: ${n.message}`, r || "value", o);
      }
  }
  cn(!1, "invalid numeric value", r || "value", o);
}
const N_ = BigInt(-1), yr = BigInt(0), Fi = BigInt(1), F_ = BigInt(5), Ui = {};
let Bi = "0000";
for (; Bi.length < 80; )
  Bi += Bi;
function li(o) {
  let r = Bi;
  for (; r.length < o; )
    r += r;
  return BigInt("1" + r.substring(0, o));
}
function bo(o, r, n) {
  const s = BigInt(r.width);
  if (r.signed) {
    const v = Fi << s - Fi;
    ar(n == null || o >= -v && o < v, "overflow", "NUMERIC_FAULT", {
      operation: n,
      fault: "overflow",
      value: o
    }), o > yr ? o = Xa(Fc(o, s), s) : o = -Xa(Fc(-o, s), s);
  } else {
    const v = Fi << s;
    ar(n == null || o >= 0 && o < v, "overflow", "NUMERIC_FAULT", {
      operation: n,
      fault: "overflow",
      value: o
    }), o = (o % v + v) % v & v - Fi;
  }
  return o;
}
function Ha(o) {
  typeof o == "number" && (o = `fixed128x${o}`);
  let r = !0, n = 128, s = 18;
  if (typeof o == "string") {
    if (o !== "fixed") if (o === "ufixed")
      r = !1;
    else {
      const R = o.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
      cn(R, "invalid fixed format", "format", o), r = R[1] !== "u", n = parseInt(R[2]), s = parseInt(R[3]);
    }
  } else if (o) {
    const R = o, I = (L, G, Z) => R[L] == null ? Z : (cn(typeof R[L] === G, "invalid fixed format (" + L + " not " + G + ")", "format." + L, R[L]), R[L]);
    r = I("signed", "boolean", r), n = I("width", "number", n), s = I("decimals", "number", s);
  }
  cn(n % 8 === 0, "invalid FixedNumber width (not byte aligned)", "format.width", n), cn(s <= 80, "invalid FixedNumber decimals (too large)", "format.decimals", s);
  const v = (r ? "" : "u") + "fixed" + String(n) + "x" + String(s);
  return { signed: r, width: n, decimals: s, name: v };
}
function D_(o, r) {
  let n = "";
  o < yr && (n = "-", o *= N_);
  let s = o.toString();
  if (r === 0)
    return n + s;
  for (; s.length <= r; )
    s = Bi + s;
  const v = s.length - r;
  for (s = s.substring(0, v) + "." + s.substring(v); s[0] === "0" && s[1] !== "."; )
    s = s.substring(1);
  for (; s[s.length - 1] === "0" && s[s.length - 2] !== "."; )
    s = s.substring(0, s.length - 1);
  return n + s;
}
var xr, Et, mn, _t, hi, Yr, es, ts, ns, rs;
const Qr = class Qr {
  // Use this when changing this file to get some typing info,
  // but then switch to any to mask the internal type
  //constructor(guard: any, value: bigint, format: _FixedFormat) {
  /**
   *  @private
   */
  constructor(r, n, s) {
    _o(this, _t);
    /**
     *  The specific fixed-point arithmetic field for this value.
     */
    Cr(this, "format");
    _o(this, xr);
    // The actual value (accounting for decimals)
    _o(this, Et);
    // A base-10 value to multiple values by to maintain the magnitude
    _o(this, mn);
    /**
     *  This is a property so console.log shows a human-meaningful value.
     *
     *  @private
     */
    Cr(this, "_value");
    U_(r, Ui, "FixedNumber"), mf(this, Et, n), mf(this, xr, s);
    const v = D_(n, s.decimals);
    Za(this, { format: s.name, _value: v }), mf(this, mn, li(s.decimals));
  }
  /**
   *  If true, negative values are permitted, otherwise only
   *  positive values and zero are allowed.
   */
  get signed() {
    return Be(this, xr).signed;
  }
  /**
   *  The number of bits available to store the value.
   */
  get width() {
    return Be(this, xr).width;
  }
  /**
   *  The number of decimal places in the fixed-point arithment field.
   */
  get decimals() {
    return Be(this, xr).decimals;
  }
  /**
   *  The value as an integer, based on the smallest unit the
   *  [[decimals]] allow.
   */
  get value() {
    return Be(this, Et);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% added
   *  to %%other%%, ignoring overflow.
   */
  addUnsafe(r) {
    return Dt(this, _t, es).call(this, r);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% added
   *  to %%other%%. A [[NumericFaultError]] is thrown if overflow
   *  occurs.
   */
  add(r) {
    return Dt(this, _t, es).call(this, r, "add");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
   *  from %%this%%, ignoring overflow.
   */
  subUnsafe(r) {
    return Dt(this, _t, ts).call(this, r);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%other%% subtracted
   *  from %%this%%. A [[NumericFaultError]] is thrown if overflow
   *  occurs.
   */
  sub(r) {
    return Dt(this, _t, ts).call(this, r, "sub");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
   *  by %%other%%, ignoring overflow and underflow (precision loss).
   */
  mulUnsafe(r) {
    return Dt(this, _t, ns).call(this, r);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
   *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
   *  occurs.
   */
  mul(r) {
    return Dt(this, _t, ns).call(this, r, "mul");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% multiplied
   *  by %%other%%. A [[NumericFaultError]] is thrown if overflow
   *  occurs or if underflow (precision loss) occurs.
   */
  mulSignal(r) {
    Dt(this, _t, hi).call(this, r);
    const n = Be(this, Et) * Be(r, Et);
    return ar(n % Be(this, mn) === yr, "precision lost during signalling mul", "NUMERIC_FAULT", {
      operation: "mulSignal",
      fault: "underflow",
      value: this
    }), Dt(this, _t, Yr).call(this, n / Be(this, mn), "mulSignal");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% divided
   *  by %%other%%, ignoring underflow (precision loss). A
   *  [[NumericFaultError]] is thrown if overflow occurs.
   */
  divUnsafe(r) {
    return Dt(this, _t, rs).call(this, r);
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% divided
   *  by %%other%%, ignoring underflow (precision loss). A
   *  [[NumericFaultError]] is thrown if overflow occurs.
   */
  div(r) {
    return Dt(this, _t, rs).call(this, r, "div");
  }
  /**
   *  Returns a new [[FixedNumber]] with the result of %%this%% divided
   *  by %%other%%. A [[NumericFaultError]] is thrown if underflow
   *  (precision loss) occurs.
   */
  divSignal(r) {
    ar(Be(r, Et) !== yr, "division by zero", "NUMERIC_FAULT", {
      operation: "div",
      fault: "divide-by-zero",
      value: this
    }), Dt(this, _t, hi).call(this, r);
    const n = Be(this, Et) * Be(this, mn);
    return ar(n % Be(r, Et) === yr, "precision lost during signalling div", "NUMERIC_FAULT", {
      operation: "divSignal",
      fault: "underflow",
      value: this
    }), Dt(this, _t, Yr).call(this, n / Be(r, Et), "divSignal");
  }
  /**
   *  Returns a comparison result between %%this%% and %%other%%.
   *
   *  This is suitable for use in sorting, where ``-1`` implies %%this%%
   *  is smaller, ``1`` implies %%this%% is larger and ``0`` implies
   *  both are equal.
   */
  cmp(r) {
    let n = this.value, s = r.value;
    const v = this.decimals - r.decimals;
    return v > 0 ? s *= li(v) : v < 0 && (n *= li(-v)), n < s ? -1 : n > s ? 1 : 0;
  }
  /**
   *  Returns true if %%other%% is equal to %%this%%.
   */
  eq(r) {
    return this.cmp(r) === 0;
  }
  /**
   *  Returns true if %%other%% is less than to %%this%%.
   */
  lt(r) {
    return this.cmp(r) < 0;
  }
  /**
   *  Returns true if %%other%% is less than or equal to %%this%%.
   */
  lte(r) {
    return this.cmp(r) <= 0;
  }
  /**
   *  Returns true if %%other%% is greater than to %%this%%.
   */
  gt(r) {
    return this.cmp(r) > 0;
  }
  /**
   *  Returns true if %%other%% is greater than or equal to %%this%%.
   */
  gte(r) {
    return this.cmp(r) >= 0;
  }
  /**
   *  Returns a new [[FixedNumber]] which is the largest **integer**
   *  that is less than or equal to %%this%%.
   *
   *  The decimal component of the result will always be ``0``.
   */
  floor() {
    let r = Be(this, Et);
    return Be(this, Et) < yr && (r -= Be(this, mn) - Fi), r = Be(this, Et) / Be(this, mn) * Be(this, mn), Dt(this, _t, Yr).call(this, r, "floor");
  }
  /**
   *  Returns a new [[FixedNumber]] which is the smallest **integer**
   *  that is greater than or equal to %%this%%.
   *
   *  The decimal component of the result will always be ``0``.
   */
  ceiling() {
    let r = Be(this, Et);
    return Be(this, Et) > yr && (r += Be(this, mn) - Fi), r = Be(this, Et) / Be(this, mn) * Be(this, mn), Dt(this, _t, Yr).call(this, r, "ceiling");
  }
  /**
   *  Returns a new [[FixedNumber]] with the decimal component
   *  rounded up on ties at %%decimals%% places.
   */
  round(r) {
    if (r == null && (r = 0), r >= this.decimals)
      return this;
    const n = this.decimals - r, s = F_ * li(n - 1);
    let v = this.value + s;
    const R = li(n);
    return v = v / R * R, bo(v, Be(this, xr), "round"), new Qr(Ui, v, Be(this, xr));
  }
  /**
   *  Returns true if %%this%% is equal to ``0``.
   */
  isZero() {
    return Be(this, Et) === yr;
  }
  /**
   *  Returns true if %%this%% is less than ``0``.
   */
  isNegative() {
    return Be(this, Et) < yr;
  }
  /**
   *  Returns the string representation of %%this%%.
   */
  toString() {
    return this._value;
  }
  /**
   *  Returns a float approximation.
   *
   *  Due to IEEE 754 precission (or lack thereof), this function
   *  can only return an approximation and most values will contain
   *  rounding errors.
   */
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  /**
   *  Return a new [[FixedNumber]] with the same value but has had
   *  its field set to %%format%%.
   *
   *  This will throw if the value cannot fit into %%format%%.
   */
  toFormat(r) {
    return Qr.fromString(this.toString(), r);
  }
  /**
   *  Creates a new [[FixedNumber]] for %%value%% divided by
   *  %%decimal%% places with %%format%%.
   *
   *  This will throw a [[NumericFaultError]] if %%value%% (once adjusted
   *  for %%decimals%%) cannot fit in %%format%%, either due to overflow
   *  or underflow (precision loss).
   */
  static fromValue(r, n, s) {
    const v = n == null ? 0 : Pf(n), R = Ha(s);
    let I = xs(r, "value");
    const L = v - R.decimals;
    if (L > 0) {
      const G = li(L);
      ar(I % G === yr, "value loses precision for format", "NUMERIC_FAULT", {
        operation: "fromValue",
        fault: "underflow",
        value: r
      }), I /= G;
    } else L < 0 && (I *= li(-L));
    return bo(I, R, "fromValue"), new Qr(Ui, I, R);
  }
  /**
   *  Creates a new [[FixedNumber]] for %%value%% with %%format%%.
   *
   *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
   *  in %%format%%, either due to overflow or underflow (precision loss).
   */
  static fromString(r, n) {
    const s = r.match(/^(-?)([0-9]*)\.?([0-9]*)$/);
    cn(s && s[2].length + s[3].length > 0, "invalid FixedNumber string value", "value", r);
    const v = Ha(n);
    let R = s[2] || "0", I = s[3] || "";
    for (; I.length < v.decimals; )
      I += Bi;
    ar(I.substring(v.decimals).match(/^0*$/), "too many decimals for format", "NUMERIC_FAULT", {
      operation: "fromString",
      fault: "underflow",
      value: r
    }), I = I.substring(0, v.decimals);
    const L = BigInt(s[1] + R + I);
    return bo(L, v, "fromString"), new Qr(Ui, L, v);
  }
  /**
   *  Creates a new [[FixedNumber]] with the big-endian representation
   *  %%value%% with %%format%%.
   *
   *  This will throw a [[NumericFaultError]] if %%value%% cannot fit
   *  in %%format%% due to overflow.
   */
  static fromBytes(r, n) {
    let s = $_(M_(r, "value"));
    const v = Ha(n);
    return v.signed && (s = Xa(s, v.width)), bo(s, v, "fromBytes"), new Qr(Ui, s, v);
  }
};
xr = new WeakMap(), Et = new WeakMap(), mn = new WeakMap(), _t = new WeakSet(), hi = function(r) {
  cn(this.format === r.format, "incompatible format; use fixedNumber.toFormat", "other", r);
}, Yr = function(r, n) {
  return r = bo(r, Be(this, xr), n), new Qr(Ui, r, Be(this, xr));
}, es = function(r, n) {
  return Dt(this, _t, hi).call(this, r), Dt(this, _t, Yr).call(this, Be(this, Et) + Be(r, Et), n);
}, ts = function(r, n) {
  return Dt(this, _t, hi).call(this, r), Dt(this, _t, Yr).call(this, Be(this, Et) - Be(r, Et), n);
}, ns = function(r, n) {
  return Dt(this, _t, hi).call(this, r), Dt(this, _t, Yr).call(this, Be(this, Et) * Be(r, Et) / Be(this, mn), n);
}, rs = function(r, n) {
  return ar(Be(r, Et) !== yr, "division by zero", "NUMERIC_FAULT", {
    operation: "div",
    fault: "divide-by-zero",
    value: this
  }), Dt(this, _t, hi).call(this, r), Dt(this, _t, Yr).call(this, Be(this, Et) * Be(this, mn) / Be(r, Et), n);
};
let Qa = Qr;
const B_ = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function Bc(o, r) {
  let n = 18;
  {
    const s = B_.indexOf(r);
    cn(s >= 0, "invalid unit", "unit", r), n = 3 * s;
  }
  return Qa.fromValue(o, n, { decimals: n, width: 512 }).toString();
}
var wn = /* @__PURE__ */ ((o) => (o.Connect = "Connect", o.SignMessage = "SignMessage", o.SignTransaction = "SignTransaction", o.SendTransaction = "SendTransaction", o.Disconnect = "Disconnect", o))(wn || {}), Rl = /* @__PURE__ */ ((o) => (o.Open = "PreventOpen", o.Close = "PreventClose", o))(Rl || {}), is = /* @__PURE__ */ ((o) => (o.Remote = "remote", o.Injected = "injected", o))(is || {});
const W_ = [
  "UNSENT",
  "OPENED",
  "HEADERS_RECEIVED",
  "LOADING",
  "DONE"
];
let j_ = class {
  constructor(r, n = {}) {
    Cr(this, "ERROR", -1);
    Cr(this, "CONNECTING", 0);
    Cr(this, "OPEN", 1);
    Cr(this, "CLOSED", 2);
    Cr(this, "CRLF", `\r
`);
    Cr(this, "LF", `
`);
    Cr(this, "CR", "\r");
    if (this.lastEventId = null, this.status = this.CONNECTING, this.eventHandlers = {
      open: [],
      message: [],
      error: [],
      close: []
    }, this.method = n.method || "GET", this.timeout = n.timeout ?? 0, this.timeoutBeforeConnection = n.timeoutBeforeConnection ?? 500, this.withCredentials = n.withCredentials || !1, this.headers = n.headers || {}, this.body = n.body || void 0, this.debug = n.debug || !1, this.interval = n.pollingInterval ?? 5e3, this.lineEndingCharacter = n.lineEndingCharacter || null, this._xhr = null, this._pollTimer = null, this._lastIndexProcessed = 0, !r || typeof r != "string" && typeof r.toString != "function")
      throw new SyntaxError("[EventSource] Invalid URL argument.");
    typeof r.toString == "function" ? this.url = r.toString() : this.url = r, this._pollAgain(this.timeoutBeforeConnection, !0);
  }
  _pollAgain(r, n) {
    (r > 0 || n) && (this._logDebug(`[EventSource] Will open new connection in ${r} ms.`), this._pollTimer = setTimeout(() => {
      this.open();
    }, r));
  }
  open() {
    try {
      if (this.status = this.CONNECTING, this._lastIndexProcessed = 0, this._xhr = new XMLHttpRequest(), this._xhr.open(this.method, this.url, !0), this.withCredentials && (this._xhr.withCredentials = !0), this._xhr.setRequestHeader("Accept", "text/event-stream"), this._xhr.setRequestHeader("Cache-Control", "no-cache"), this._xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest"), this.headers)
        for (const [r, n] of Object.entries(this.headers))
          this._xhr.setRequestHeader(r, n);
      this.lastEventId !== null && this._xhr.setRequestHeader("Last-Event-ID", this.lastEventId), this._xhr.timeout = this.timeout, this._xhr.onreadystatechange = () => {
        if (this.status === this.CLOSED)
          return;
        const r = this._xhr;
        this._logDebug(`[EventSource][onreadystatechange] ReadyState: ${W_[r.readyState] || "Unknown"}(${r.readyState}), status: ${r.status}`), [XMLHttpRequest.DONE, XMLHttpRequest.LOADING].includes(r.readyState) && (r.status >= 200 && r.status < 400 ? (this.status === this.CONNECTING && (this.status = this.OPEN, this.dispatch("open", { type: "open" }), this._logDebug("[EventSource][onreadystatechange][OPEN] Connection opened.")), this._handleEvent(r.responseText || ""), r.readyState === XMLHttpRequest.DONE && (this._logDebug("[EventSource][onreadystatechange][DONE] Operation done."), this._pollAgain(this.interval, !1))) : r.status !== 0 && (this.status = this.ERROR, this.dispatch("error", {
          type: "error",
          message: r.responseText,
          xhrStatus: r.status,
          xhrState: r.readyState
        }), r.readyState === XMLHttpRequest.DONE && (this._logDebug("[EventSource][onreadystatechange][ERROR] Response status error."), this._pollAgain(this.interval, !1))));
      }, this._xhr.onerror = () => {
        this.status !== this.CLOSED && (this.status = this.ERROR, this.dispatch("error", {
          type: "error",
          message: this._xhr.responseText,
          xhrStatus: this._xhr.status,
          xhrState: this._xhr.readyState
        }));
      }, this.body ? this._xhr.send(this.body) : this._xhr.send(), this.timeout > 0 && setTimeout(() => {
        this._xhr.readyState === XMLHttpRequest.LOADING && (this.dispatch("error", { type: "timeout" }), this.close());
      }, this.timeout);
    } catch (r) {
      this.status = this.ERROR, this.dispatch("error", {
        type: "exception",
        message: r.message,
        error: r
      });
    }
  }
  _logDebug(...r) {
    this.debug && console.debug(...r);
  }
  _handleEvent(r) {
    if (this.lineEndingCharacter === null) {
      const Z = this._detectNewlineChar(r);
      if (Z !== null)
        this._logDebug(`[EventSource] Automatically detected lineEndingCharacter: ${JSON.stringify(Z).slice(1, -1)}`), this.lineEndingCharacter = Z;
      else {
        console.warn("[EventSource] Unable to identify the line ending character. Ensure your server delivers a standard line ending character: \\r\\n, \\n, \\r, or specify your custom character using the 'lineEndingCharacter' option.");
        return;
      }
    }
    const n = this._getLastDoubleNewlineIndex(r);
    if (n <= this._lastIndexProcessed)
      return;
    const s = r.substring(this._lastIndexProcessed, n).split(this.lineEndingCharacter);
    this._lastIndexProcessed = n;
    let v, R = null, I = [], L = 0, G = "";
    for (let Z = 0; Z < s.length; Z++)
      if (G = s[Z].trim(), G.startsWith("event"))
        v = G.replace(/event:?\s*/, "");
      else if (G.startsWith("retry"))
        L = parseInt(G.replace(/retry:?\s*/, ""), 10), isNaN(L) || (this.interval = L);
      else if (G.startsWith("data"))
        I.push(G.replace(/data:?\s*/, ""));
      else if (G.startsWith("id"))
        R = G.replace(/id:?\s*/, ""), R !== "" ? this.lastEventId = R : this.lastEventId = null;
      else if (G === "" && I.length > 0) {
        const he = v || "message", me = {
          type: he,
          data: I.join(`
`),
          url: this.url,
          lastEventId: this.lastEventId
        };
        this.dispatch(he, me), I = [], v = void 0;
      }
  }
  _detectNewlineChar(r) {
    const n = [this.CRLF, this.LF, this.CR];
    for (const s of n)
      if (r.includes(s))
        return s;
    return null;
  }
  _getLastDoubleNewlineIndex(r) {
    const n = this.lineEndingCharacter + this.lineEndingCharacter, s = r.lastIndexOf(n);
    return s === -1 ? -1 : s + n.length;
  }
  addEventListener(r, n) {
    this.eventHandlers[r] === void 0 && (this.eventHandlers[r] = []), this.eventHandlers[r].push(n);
  }
  removeEventListener(r, n) {
    this.eventHandlers[r] !== void 0 && (this.eventHandlers[r] = this.eventHandlers[r].filter((s) => s !== n));
  }
  removeAllEventListeners(r) {
    const n = Object.keys(this.eventHandlers);
    if (r === void 0)
      for (const s of n)
        this.eventHandlers[s] = [];
    else {
      if (!n.includes(r))
        throw Error(`[EventSource] '${r}' type is not supported event type.`);
      this.eventHandlers[r] = [];
    }
  }
  dispatch(r, n) {
    if (Object.keys(this.eventHandlers).includes(r))
      for (const v of Object.values(this.eventHandlers[r]))
        v(n);
  }
  close() {
    this.status !== this.CLOSED && (this.status = this.CLOSED, this.dispatch("close", { type: "close" })), clearTimeout(this._pollTimer), this._xhr && this._xhr.abort();
  }
};
const k_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j_
}, Symbol.toStringTag, { value: "Module" })), K_ = /* @__PURE__ */ al(k_), Y_ = K_;
var z_ = Y_;
const Wc = /* @__PURE__ */ Ro(z_);
var Al = { exports: {} };
(function(o) {
  (function(r, n) {
    o.exports ? o.exports = n() : (r.nacl || (r.nacl = {}), r.nacl.util = n());
  })(di, function() {
    var r = {};
    function n(s) {
      if (!/^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/.test(s))
        throw new TypeError("invalid encoding");
    }
    return r.decodeUTF8 = function(s) {
      if (typeof s != "string") throw new TypeError("expected string");
      var v, R = unescape(encodeURIComponent(s)), I = new Uint8Array(R.length);
      for (v = 0; v < R.length; v++) I[v] = R.charCodeAt(v);
      return I;
    }, r.encodeUTF8 = function(s) {
      var v, R = [];
      for (v = 0; v < s.length; v++) R.push(String.fromCharCode(s[v]));
      return decodeURIComponent(escape(R.join("")));
    }, typeof atob > "u" ? typeof Buffer.from < "u" ? (r.encodeBase64 = function(s) {
      return Buffer.from(s).toString("base64");
    }, r.decodeBase64 = function(s) {
      return n(s), new Uint8Array(Array.prototype.slice.call(Buffer.from(s, "base64"), 0));
    }) : (r.encodeBase64 = function(s) {
      return new Buffer(s).toString("base64");
    }, r.decodeBase64 = function(s) {
      return n(s), new Uint8Array(Array.prototype.slice.call(new Buffer(s, "base64"), 0));
    }) : (r.encodeBase64 = function(s) {
      var v, R = [], I = s.length;
      for (v = 0; v < I; v++) R.push(String.fromCharCode(s[v]));
      return btoa(R.join(""));
    }, r.decodeBase64 = function(s) {
      n(s);
      var v, R = atob(s), I = new Uint8Array(R.length);
      for (v = 0; v < R.length; v++) I[v] = R.charCodeAt(v);
      return I;
    }), r;
  });
})(Al);
var Tl = Al.exports;
const So = /* @__PURE__ */ Ro(Tl);
function H_(o) {
  throw new Error('Could not dynamically require "' + o + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Ol = { exports: {} };
const G_ = {}, q_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: G_
}, Symbol.toStringTag, { value: "Module" })), V_ = /* @__PURE__ */ al(q_);
(function(o) {
  (function(r) {
    var n = function(u) {
      var p, d = new Float64Array(16);
      if (u) for (p = 0; p < u.length; p++) d[p] = u[p];
      return d;
    }, s = function() {
      throw new Error("no PRNG");
    }, v = new Uint8Array(16), R = new Uint8Array(32);
    R[0] = 9;
    var I = n(), L = n([1]), G = n([56129, 1]), Z = n([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), he = n([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), me = n([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), Me = n([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), be = n([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function tt(u, p, d, f) {
      u[p] = d >> 24 & 255, u[p + 1] = d >> 16 & 255, u[p + 2] = d >> 8 & 255, u[p + 3] = d & 255, u[p + 4] = f >> 24 & 255, u[p + 5] = f >> 16 & 255, u[p + 6] = f >> 8 & 255, u[p + 7] = f & 255;
    }
    function We(u, p, d, f, y) {
      var h, x = 0;
      for (h = 0; h < y; h++) x |= u[p + h] ^ d[f + h];
      return (1 & x - 1 >>> 8) - 1;
    }
    function Ge(u, p, d, f) {
      return We(u, p, d, f, 16);
    }
    function mt(u, p, d, f) {
      return We(u, p, d, f, 32);
    }
    function Fe(u, p, d, f) {
      for (var y = f[0] & 255 | (f[1] & 255) << 8 | (f[2] & 255) << 16 | (f[3] & 255) << 24, h = d[0] & 255 | (d[1] & 255) << 8 | (d[2] & 255) << 16 | (d[3] & 255) << 24, x = d[4] & 255 | (d[5] & 255) << 8 | (d[6] & 255) << 16 | (d[7] & 255) << 24, S = d[8] & 255 | (d[9] & 255) << 8 | (d[10] & 255) << 16 | (d[11] & 255) << 24, M = d[12] & 255 | (d[13] & 255) << 8 | (d[14] & 255) << 16 | (d[15] & 255) << 24, V = f[4] & 255 | (f[5] & 255) << 8 | (f[6] & 255) << 16 | (f[7] & 255) << 24, Y = p[0] & 255 | (p[1] & 255) << 8 | (p[2] & 255) << 16 | (p[3] & 255) << 24, ie = p[4] & 255 | (p[5] & 255) << 8 | (p[6] & 255) << 16 | (p[7] & 255) << 24, k = p[8] & 255 | (p[9] & 255) << 8 | (p[10] & 255) << 16 | (p[11] & 255) << 24, ae = p[12] & 255 | (p[13] & 255) << 8 | (p[14] & 255) << 16 | (p[15] & 255) << 24, oe = f[8] & 255 | (f[9] & 255) << 8 | (f[10] & 255) << 16 | (f[11] & 255) << 24, se = d[16] & 255 | (d[17] & 255) << 8 | (d[18] & 255) << 16 | (d[19] & 255) << 24, pe = d[20] & 255 | (d[21] & 255) << 8 | (d[22] & 255) << 16 | (d[23] & 255) << 24, xe = d[24] & 255 | (d[25] & 255) << 8 | (d[26] & 255) << 16 | (d[27] & 255) << 24, ve = d[28] & 255 | (d[29] & 255) << 8 | (d[30] & 255) << 16 | (d[31] & 255) << 24, ce = f[12] & 255 | (f[13] & 255) << 8 | (f[14] & 255) << 16 | (f[15] & 255) << 24, ne = y, ge = h, Q = x, re = S, fe = M, X = V, C = Y, U = ie, K = k, D = ae, B = oe, H = se, ye = pe, Ue = xe, Ie = ve, Se = ce, b, Le = 0; Le < 20; Le += 2)
        b = ne + ye | 0, fe ^= b << 7 | b >>> 25, b = fe + ne | 0, K ^= b << 9 | b >>> 23, b = K + fe | 0, ye ^= b << 13 | b >>> 19, b = ye + K | 0, ne ^= b << 18 | b >>> 14, b = X + ge | 0, D ^= b << 7 | b >>> 25, b = D + X | 0, Ue ^= b << 9 | b >>> 23, b = Ue + D | 0, ge ^= b << 13 | b >>> 19, b = ge + Ue | 0, X ^= b << 18 | b >>> 14, b = B + C | 0, Ie ^= b << 7 | b >>> 25, b = Ie + B | 0, Q ^= b << 9 | b >>> 23, b = Q + Ie | 0, C ^= b << 13 | b >>> 19, b = C + Q | 0, B ^= b << 18 | b >>> 14, b = Se + H | 0, re ^= b << 7 | b >>> 25, b = re + Se | 0, U ^= b << 9 | b >>> 23, b = U + re | 0, H ^= b << 13 | b >>> 19, b = H + U | 0, Se ^= b << 18 | b >>> 14, b = ne + re | 0, ge ^= b << 7 | b >>> 25, b = ge + ne | 0, Q ^= b << 9 | b >>> 23, b = Q + ge | 0, re ^= b << 13 | b >>> 19, b = re + Q | 0, ne ^= b << 18 | b >>> 14, b = X + fe | 0, C ^= b << 7 | b >>> 25, b = C + X | 0, U ^= b << 9 | b >>> 23, b = U + C | 0, fe ^= b << 13 | b >>> 19, b = fe + U | 0, X ^= b << 18 | b >>> 14, b = B + D | 0, H ^= b << 7 | b >>> 25, b = H + B | 0, K ^= b << 9 | b >>> 23, b = K + H | 0, D ^= b << 13 | b >>> 19, b = D + K | 0, B ^= b << 18 | b >>> 14, b = Se + Ie | 0, ye ^= b << 7 | b >>> 25, b = ye + Se | 0, Ue ^= b << 9 | b >>> 23, b = Ue + ye | 0, Ie ^= b << 13 | b >>> 19, b = Ie + Ue | 0, Se ^= b << 18 | b >>> 14;
      ne = ne + y | 0, ge = ge + h | 0, Q = Q + x | 0, re = re + S | 0, fe = fe + M | 0, X = X + V | 0, C = C + Y | 0, U = U + ie | 0, K = K + k | 0, D = D + ae | 0, B = B + oe | 0, H = H + se | 0, ye = ye + pe | 0, Ue = Ue + xe | 0, Ie = Ie + ve | 0, Se = Se + ce | 0, u[0] = ne >>> 0 & 255, u[1] = ne >>> 8 & 255, u[2] = ne >>> 16 & 255, u[3] = ne >>> 24 & 255, u[4] = ge >>> 0 & 255, u[5] = ge >>> 8 & 255, u[6] = ge >>> 16 & 255, u[7] = ge >>> 24 & 255, u[8] = Q >>> 0 & 255, u[9] = Q >>> 8 & 255, u[10] = Q >>> 16 & 255, u[11] = Q >>> 24 & 255, u[12] = re >>> 0 & 255, u[13] = re >>> 8 & 255, u[14] = re >>> 16 & 255, u[15] = re >>> 24 & 255, u[16] = fe >>> 0 & 255, u[17] = fe >>> 8 & 255, u[18] = fe >>> 16 & 255, u[19] = fe >>> 24 & 255, u[20] = X >>> 0 & 255, u[21] = X >>> 8 & 255, u[22] = X >>> 16 & 255, u[23] = X >>> 24 & 255, u[24] = C >>> 0 & 255, u[25] = C >>> 8 & 255, u[26] = C >>> 16 & 255, u[27] = C >>> 24 & 255, u[28] = U >>> 0 & 255, u[29] = U >>> 8 & 255, u[30] = U >>> 16 & 255, u[31] = U >>> 24 & 255, u[32] = K >>> 0 & 255, u[33] = K >>> 8 & 255, u[34] = K >>> 16 & 255, u[35] = K >>> 24 & 255, u[36] = D >>> 0 & 255, u[37] = D >>> 8 & 255, u[38] = D >>> 16 & 255, u[39] = D >>> 24 & 255, u[40] = B >>> 0 & 255, u[41] = B >>> 8 & 255, u[42] = B >>> 16 & 255, u[43] = B >>> 24 & 255, u[44] = H >>> 0 & 255, u[45] = H >>> 8 & 255, u[46] = H >>> 16 & 255, u[47] = H >>> 24 & 255, u[48] = ye >>> 0 & 255, u[49] = ye >>> 8 & 255, u[50] = ye >>> 16 & 255, u[51] = ye >>> 24 & 255, u[52] = Ue >>> 0 & 255, u[53] = Ue >>> 8 & 255, u[54] = Ue >>> 16 & 255, u[55] = Ue >>> 24 & 255, u[56] = Ie >>> 0 & 255, u[57] = Ie >>> 8 & 255, u[58] = Ie >>> 16 & 255, u[59] = Ie >>> 24 & 255, u[60] = Se >>> 0 & 255, u[61] = Se >>> 8 & 255, u[62] = Se >>> 16 & 255, u[63] = Se >>> 24 & 255;
    }
    function yt(u, p, d, f) {
      for (var y = f[0] & 255 | (f[1] & 255) << 8 | (f[2] & 255) << 16 | (f[3] & 255) << 24, h = d[0] & 255 | (d[1] & 255) << 8 | (d[2] & 255) << 16 | (d[3] & 255) << 24, x = d[4] & 255 | (d[5] & 255) << 8 | (d[6] & 255) << 16 | (d[7] & 255) << 24, S = d[8] & 255 | (d[9] & 255) << 8 | (d[10] & 255) << 16 | (d[11] & 255) << 24, M = d[12] & 255 | (d[13] & 255) << 8 | (d[14] & 255) << 16 | (d[15] & 255) << 24, V = f[4] & 255 | (f[5] & 255) << 8 | (f[6] & 255) << 16 | (f[7] & 255) << 24, Y = p[0] & 255 | (p[1] & 255) << 8 | (p[2] & 255) << 16 | (p[3] & 255) << 24, ie = p[4] & 255 | (p[5] & 255) << 8 | (p[6] & 255) << 16 | (p[7] & 255) << 24, k = p[8] & 255 | (p[9] & 255) << 8 | (p[10] & 255) << 16 | (p[11] & 255) << 24, ae = p[12] & 255 | (p[13] & 255) << 8 | (p[14] & 255) << 16 | (p[15] & 255) << 24, oe = f[8] & 255 | (f[9] & 255) << 8 | (f[10] & 255) << 16 | (f[11] & 255) << 24, se = d[16] & 255 | (d[17] & 255) << 8 | (d[18] & 255) << 16 | (d[19] & 255) << 24, pe = d[20] & 255 | (d[21] & 255) << 8 | (d[22] & 255) << 16 | (d[23] & 255) << 24, xe = d[24] & 255 | (d[25] & 255) << 8 | (d[26] & 255) << 16 | (d[27] & 255) << 24, ve = d[28] & 255 | (d[29] & 255) << 8 | (d[30] & 255) << 16 | (d[31] & 255) << 24, ce = f[12] & 255 | (f[13] & 255) << 8 | (f[14] & 255) << 16 | (f[15] & 255) << 24, ne = y, ge = h, Q = x, re = S, fe = M, X = V, C = Y, U = ie, K = k, D = ae, B = oe, H = se, ye = pe, Ue = xe, Ie = ve, Se = ce, b, Le = 0; Le < 20; Le += 2)
        b = ne + ye | 0, fe ^= b << 7 | b >>> 25, b = fe + ne | 0, K ^= b << 9 | b >>> 23, b = K + fe | 0, ye ^= b << 13 | b >>> 19, b = ye + K | 0, ne ^= b << 18 | b >>> 14, b = X + ge | 0, D ^= b << 7 | b >>> 25, b = D + X | 0, Ue ^= b << 9 | b >>> 23, b = Ue + D | 0, ge ^= b << 13 | b >>> 19, b = ge + Ue | 0, X ^= b << 18 | b >>> 14, b = B + C | 0, Ie ^= b << 7 | b >>> 25, b = Ie + B | 0, Q ^= b << 9 | b >>> 23, b = Q + Ie | 0, C ^= b << 13 | b >>> 19, b = C + Q | 0, B ^= b << 18 | b >>> 14, b = Se + H | 0, re ^= b << 7 | b >>> 25, b = re + Se | 0, U ^= b << 9 | b >>> 23, b = U + re | 0, H ^= b << 13 | b >>> 19, b = H + U | 0, Se ^= b << 18 | b >>> 14, b = ne + re | 0, ge ^= b << 7 | b >>> 25, b = ge + ne | 0, Q ^= b << 9 | b >>> 23, b = Q + ge | 0, re ^= b << 13 | b >>> 19, b = re + Q | 0, ne ^= b << 18 | b >>> 14, b = X + fe | 0, C ^= b << 7 | b >>> 25, b = C + X | 0, U ^= b << 9 | b >>> 23, b = U + C | 0, fe ^= b << 13 | b >>> 19, b = fe + U | 0, X ^= b << 18 | b >>> 14, b = B + D | 0, H ^= b << 7 | b >>> 25, b = H + B | 0, K ^= b << 9 | b >>> 23, b = K + H | 0, D ^= b << 13 | b >>> 19, b = D + K | 0, B ^= b << 18 | b >>> 14, b = Se + Ie | 0, ye ^= b << 7 | b >>> 25, b = ye + Se | 0, Ue ^= b << 9 | b >>> 23, b = Ue + ye | 0, Ie ^= b << 13 | b >>> 19, b = Ie + Ue | 0, Se ^= b << 18 | b >>> 14;
      u[0] = ne >>> 0 & 255, u[1] = ne >>> 8 & 255, u[2] = ne >>> 16 & 255, u[3] = ne >>> 24 & 255, u[4] = X >>> 0 & 255, u[5] = X >>> 8 & 255, u[6] = X >>> 16 & 255, u[7] = X >>> 24 & 255, u[8] = B >>> 0 & 255, u[9] = B >>> 8 & 255, u[10] = B >>> 16 & 255, u[11] = B >>> 24 & 255, u[12] = Se >>> 0 & 255, u[13] = Se >>> 8 & 255, u[14] = Se >>> 16 & 255, u[15] = Se >>> 24 & 255, u[16] = C >>> 0 & 255, u[17] = C >>> 8 & 255, u[18] = C >>> 16 & 255, u[19] = C >>> 24 & 255, u[20] = U >>> 0 & 255, u[21] = U >>> 8 & 255, u[22] = U >>> 16 & 255, u[23] = U >>> 24 & 255, u[24] = K >>> 0 & 255, u[25] = K >>> 8 & 255, u[26] = K >>> 16 & 255, u[27] = K >>> 24 & 255, u[28] = D >>> 0 & 255, u[29] = D >>> 8 & 255, u[30] = D >>> 16 & 255, u[31] = D >>> 24 & 255;
    }
    function ft(u, p, d, f) {
      Fe(u, p, d, f);
    }
    function nt(u, p, d, f) {
      yt(u, p, d, f);
    }
    var ht = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function Ut(u, p, d, f, y, h, x) {
      var S = new Uint8Array(16), M = new Uint8Array(64), V, Y;
      for (Y = 0; Y < 16; Y++) S[Y] = 0;
      for (Y = 0; Y < 8; Y++) S[Y] = h[Y];
      for (; y >= 64; ) {
        for (ft(M, S, x, ht), Y = 0; Y < 64; Y++) u[p + Y] = d[f + Y] ^ M[Y];
        for (V = 1, Y = 8; Y < 16; Y++)
          V = V + (S[Y] & 255) | 0, S[Y] = V & 255, V >>>= 8;
        y -= 64, p += 64, f += 64;
      }
      if (y > 0)
        for (ft(M, S, x, ht), Y = 0; Y < y; Y++) u[p + Y] = d[f + Y] ^ M[Y];
      return 0;
    }
    function nn(u, p, d, f, y) {
      var h = new Uint8Array(16), x = new Uint8Array(64), S, M;
      for (M = 0; M < 16; M++) h[M] = 0;
      for (M = 0; M < 8; M++) h[M] = f[M];
      for (; d >= 64; ) {
        for (ft(x, h, y, ht), M = 0; M < 64; M++) u[p + M] = x[M];
        for (S = 1, M = 8; M < 16; M++)
          S = S + (h[M] & 255) | 0, h[M] = S & 255, S >>>= 8;
        d -= 64, p += 64;
      }
      if (d > 0)
        for (ft(x, h, y, ht), M = 0; M < d; M++) u[p + M] = x[M];
      return 0;
    }
    function Sn(u, p, d, f, y) {
      var h = new Uint8Array(32);
      nt(h, f, y, ht);
      for (var x = new Uint8Array(8), S = 0; S < 8; S++) x[S] = f[S + 16];
      return nn(u, p, d, x, h);
    }
    function Mn(u, p, d, f, y, h, x) {
      var S = new Uint8Array(32);
      nt(S, h, x, ht);
      for (var M = new Uint8Array(8), V = 0; V < 8; V++) M[V] = h[V + 16];
      return Ut(u, p, d, f, y, M, S);
    }
    var zn = function(u) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var p, d, f, y, h, x, S, M;
      p = u[0] & 255 | (u[1] & 255) << 8, this.r[0] = p & 8191, d = u[2] & 255 | (u[3] & 255) << 8, this.r[1] = (p >>> 13 | d << 3) & 8191, f = u[4] & 255 | (u[5] & 255) << 8, this.r[2] = (d >>> 10 | f << 6) & 7939, y = u[6] & 255 | (u[7] & 255) << 8, this.r[3] = (f >>> 7 | y << 9) & 8191, h = u[8] & 255 | (u[9] & 255) << 8, this.r[4] = (y >>> 4 | h << 12) & 255, this.r[5] = h >>> 1 & 8190, x = u[10] & 255 | (u[11] & 255) << 8, this.r[6] = (h >>> 14 | x << 2) & 8191, S = u[12] & 255 | (u[13] & 255) << 8, this.r[7] = (x >>> 11 | S << 5) & 8065, M = u[14] & 255 | (u[15] & 255) << 8, this.r[8] = (S >>> 8 | M << 8) & 8191, this.r[9] = M >>> 5 & 127, this.pad[0] = u[16] & 255 | (u[17] & 255) << 8, this.pad[1] = u[18] & 255 | (u[19] & 255) << 8, this.pad[2] = u[20] & 255 | (u[21] & 255) << 8, this.pad[3] = u[22] & 255 | (u[23] & 255) << 8, this.pad[4] = u[24] & 255 | (u[25] & 255) << 8, this.pad[5] = u[26] & 255 | (u[27] & 255) << 8, this.pad[6] = u[28] & 255 | (u[29] & 255) << 8, this.pad[7] = u[30] & 255 | (u[31] & 255) << 8;
    };
    zn.prototype.blocks = function(u, p, d) {
      for (var f = this.fin ? 0 : 2048, y, h, x, S, M, V, Y, ie, k, ae, oe, se, pe, xe, ve, ce, ne, ge, Q, re = this.h[0], fe = this.h[1], X = this.h[2], C = this.h[3], U = this.h[4], K = this.h[5], D = this.h[6], B = this.h[7], H = this.h[8], ye = this.h[9], Ue = this.r[0], Ie = this.r[1], Se = this.r[2], b = this.r[3], Le = this.r[4], je = this.r[5], qe = this.r[6], Pe = this.r[7], Ve = this.r[8], ze = this.r[9]; d >= 16; )
        y = u[p + 0] & 255 | (u[p + 1] & 255) << 8, re += y & 8191, h = u[p + 2] & 255 | (u[p + 3] & 255) << 8, fe += (y >>> 13 | h << 3) & 8191, x = u[p + 4] & 255 | (u[p + 5] & 255) << 8, X += (h >>> 10 | x << 6) & 8191, S = u[p + 6] & 255 | (u[p + 7] & 255) << 8, C += (x >>> 7 | S << 9) & 8191, M = u[p + 8] & 255 | (u[p + 9] & 255) << 8, U += (S >>> 4 | M << 12) & 8191, K += M >>> 1 & 8191, V = u[p + 10] & 255 | (u[p + 11] & 255) << 8, D += (M >>> 14 | V << 2) & 8191, Y = u[p + 12] & 255 | (u[p + 13] & 255) << 8, B += (V >>> 11 | Y << 5) & 8191, ie = u[p + 14] & 255 | (u[p + 15] & 255) << 8, H += (Y >>> 8 | ie << 8) & 8191, ye += ie >>> 5 | f, k = 0, ae = k, ae += re * Ue, ae += fe * (5 * ze), ae += X * (5 * Ve), ae += C * (5 * Pe), ae += U * (5 * qe), k = ae >>> 13, ae &= 8191, ae += K * (5 * je), ae += D * (5 * Le), ae += B * (5 * b), ae += H * (5 * Se), ae += ye * (5 * Ie), k += ae >>> 13, ae &= 8191, oe = k, oe += re * Ie, oe += fe * Ue, oe += X * (5 * ze), oe += C * (5 * Ve), oe += U * (5 * Pe), k = oe >>> 13, oe &= 8191, oe += K * (5 * qe), oe += D * (5 * je), oe += B * (5 * Le), oe += H * (5 * b), oe += ye * (5 * Se), k += oe >>> 13, oe &= 8191, se = k, se += re * Se, se += fe * Ie, se += X * Ue, se += C * (5 * ze), se += U * (5 * Ve), k = se >>> 13, se &= 8191, se += K * (5 * Pe), se += D * (5 * qe), se += B * (5 * je), se += H * (5 * Le), se += ye * (5 * b), k += se >>> 13, se &= 8191, pe = k, pe += re * b, pe += fe * Se, pe += X * Ie, pe += C * Ue, pe += U * (5 * ze), k = pe >>> 13, pe &= 8191, pe += K * (5 * Ve), pe += D * (5 * Pe), pe += B * (5 * qe), pe += H * (5 * je), pe += ye * (5 * Le), k += pe >>> 13, pe &= 8191, xe = k, xe += re * Le, xe += fe * b, xe += X * Se, xe += C * Ie, xe += U * Ue, k = xe >>> 13, xe &= 8191, xe += K * (5 * ze), xe += D * (5 * Ve), xe += B * (5 * Pe), xe += H * (5 * qe), xe += ye * (5 * je), k += xe >>> 13, xe &= 8191, ve = k, ve += re * je, ve += fe * Le, ve += X * b, ve += C * Se, ve += U * Ie, k = ve >>> 13, ve &= 8191, ve += K * Ue, ve += D * (5 * ze), ve += B * (5 * Ve), ve += H * (5 * Pe), ve += ye * (5 * qe), k += ve >>> 13, ve &= 8191, ce = k, ce += re * qe, ce += fe * je, ce += X * Le, ce += C * b, ce += U * Se, k = ce >>> 13, ce &= 8191, ce += K * Ie, ce += D * Ue, ce += B * (5 * ze), ce += H * (5 * Ve), ce += ye * (5 * Pe), k += ce >>> 13, ce &= 8191, ne = k, ne += re * Pe, ne += fe * qe, ne += X * je, ne += C * Le, ne += U * b, k = ne >>> 13, ne &= 8191, ne += K * Se, ne += D * Ie, ne += B * Ue, ne += H * (5 * ze), ne += ye * (5 * Ve), k += ne >>> 13, ne &= 8191, ge = k, ge += re * Ve, ge += fe * Pe, ge += X * qe, ge += C * je, ge += U * Le, k = ge >>> 13, ge &= 8191, ge += K * b, ge += D * Se, ge += B * Ie, ge += H * Ue, ge += ye * (5 * ze), k += ge >>> 13, ge &= 8191, Q = k, Q += re * ze, Q += fe * Ve, Q += X * Pe, Q += C * qe, Q += U * je, k = Q >>> 13, Q &= 8191, Q += K * Le, Q += D * b, Q += B * Se, Q += H * Ie, Q += ye * Ue, k += Q >>> 13, Q &= 8191, k = (k << 2) + k | 0, k = k + ae | 0, ae = k & 8191, k = k >>> 13, oe += k, re = ae, fe = oe, X = se, C = pe, U = xe, K = ve, D = ce, B = ne, H = ge, ye = Q, p += 16, d -= 16;
      this.h[0] = re, this.h[1] = fe, this.h[2] = X, this.h[3] = C, this.h[4] = U, this.h[5] = K, this.h[6] = D, this.h[7] = B, this.h[8] = H, this.h[9] = ye;
    }, zn.prototype.finish = function(u, p) {
      var d = new Uint16Array(10), f, y, h, x;
      if (this.leftover) {
        for (x = this.leftover, this.buffer[x++] = 1; x < 16; x++) this.buffer[x] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (f = this.h[1] >>> 13, this.h[1] &= 8191, x = 2; x < 10; x++)
        this.h[x] += f, f = this.h[x] >>> 13, this.h[x] &= 8191;
      for (this.h[0] += f * 5, f = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += f, f = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += f, d[0] = this.h[0] + 5, f = d[0] >>> 13, d[0] &= 8191, x = 1; x < 10; x++)
        d[x] = this.h[x] + f, f = d[x] >>> 13, d[x] &= 8191;
      for (d[9] -= 8192, y = (f ^ 1) - 1, x = 0; x < 10; x++) d[x] &= y;
      for (y = ~y, x = 0; x < 10; x++) this.h[x] = this.h[x] & y | d[x];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, h = this.h[0] + this.pad[0], this.h[0] = h & 65535, x = 1; x < 8; x++)
        h = (this.h[x] + this.pad[x] | 0) + (h >>> 16) | 0, this.h[x] = h & 65535;
      u[p + 0] = this.h[0] >>> 0 & 255, u[p + 1] = this.h[0] >>> 8 & 255, u[p + 2] = this.h[1] >>> 0 & 255, u[p + 3] = this.h[1] >>> 8 & 255, u[p + 4] = this.h[2] >>> 0 & 255, u[p + 5] = this.h[2] >>> 8 & 255, u[p + 6] = this.h[3] >>> 0 & 255, u[p + 7] = this.h[3] >>> 8 & 255, u[p + 8] = this.h[4] >>> 0 & 255, u[p + 9] = this.h[4] >>> 8 & 255, u[p + 10] = this.h[5] >>> 0 & 255, u[p + 11] = this.h[5] >>> 8 & 255, u[p + 12] = this.h[6] >>> 0 & 255, u[p + 13] = this.h[6] >>> 8 & 255, u[p + 14] = this.h[7] >>> 0 & 255, u[p + 15] = this.h[7] >>> 8 & 255;
    }, zn.prototype.update = function(u, p, d) {
      var f, y;
      if (this.leftover) {
        for (y = 16 - this.leftover, y > d && (y = d), f = 0; f < y; f++)
          this.buffer[this.leftover + f] = u[p + f];
        if (d -= y, p += y, this.leftover += y, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (d >= 16 && (y = d - d % 16, this.blocks(u, p, y), p += y, d -= y), d) {
        for (f = 0; f < d; f++)
          this.buffer[this.leftover + f] = u[p + f];
        this.leftover += d;
      }
    };
    function $n(u, p, d, f, y, h) {
      var x = new zn(h);
      return x.update(d, f, y), x.finish(u, p), 0;
    }
    function kt(u, p, d, f, y, h) {
      var x = new Uint8Array(16);
      return $n(x, 0, d, f, y, h), Ge(u, p, x, 0);
    }
    function Kt(u, p, d, f, y) {
      var h;
      if (d < 32) return -1;
      for (Mn(u, 0, p, 0, d, f, y), $n(u, 16, u, 32, d - 32, u), h = 0; h < 16; h++) u[h] = 0;
      return 0;
    }
    function Lt(u, p, d, f, y) {
      var h, x = new Uint8Array(32);
      if (d < 32 || (Sn(x, 0, 32, f, y), kt(p, 16, p, 32, d - 32, x) !== 0)) return -1;
      for (Mn(u, 0, p, 0, d, f, y), h = 0; h < 32; h++) u[h] = 0;
      return 0;
    }
    function Mt(u, p) {
      var d;
      for (d = 0; d < 16; d++) u[d] = p[d] | 0;
    }
    function de(u) {
      var p, d, f = 1;
      for (p = 0; p < 16; p++)
        d = u[p] + f + 65535, f = Math.floor(d / 65536), u[p] = d - f * 65536;
      u[0] += f - 1 + 37 * (f - 1);
    }
    function It(u, p, d) {
      for (var f, y = ~(d - 1), h = 0; h < 16; h++)
        f = y & (u[h] ^ p[h]), u[h] ^= f, p[h] ^= f;
    }
    function ln(u, p) {
      var d, f, y, h = n(), x = n();
      for (d = 0; d < 16; d++) x[d] = p[d];
      for (de(x), de(x), de(x), f = 0; f < 2; f++) {
        for (h[0] = x[0] - 65517, d = 1; d < 15; d++)
          h[d] = x[d] - 65535 - (h[d - 1] >> 16 & 1), h[d - 1] &= 65535;
        h[15] = x[15] - 32767 - (h[14] >> 16 & 1), y = h[15] >> 16 & 1, h[14] &= 65535, It(x, h, 1 - y);
      }
      for (d = 0; d < 16; d++)
        u[2 * d] = x[d] & 255, u[2 * d + 1] = x[d] >> 8;
    }
    function fn(u, p) {
      var d = new Uint8Array(32), f = new Uint8Array(32);
      return ln(d, u), ln(f, p), mt(d, 0, f, 0);
    }
    function O(u) {
      var p = new Uint8Array(32);
      return ln(p, u), p[0] & 1;
    }
    function J(u, p) {
      var d;
      for (d = 0; d < 16; d++) u[d] = p[2 * d] + (p[2 * d + 1] << 8);
      u[15] &= 32767;
    }
    function Ee(u, p, d) {
      for (var f = 0; f < 16; f++) u[f] = p[f] + d[f];
    }
    function Oe(u, p, d) {
      for (var f = 0; f < 16; f++) u[f] = p[f] - d[f];
    }
    function ee(u, p, d) {
      var f, y, h = 0, x = 0, S = 0, M = 0, V = 0, Y = 0, ie = 0, k = 0, ae = 0, oe = 0, se = 0, pe = 0, xe = 0, ve = 0, ce = 0, ne = 0, ge = 0, Q = 0, re = 0, fe = 0, X = 0, C = 0, U = 0, K = 0, D = 0, B = 0, H = 0, ye = 0, Ue = 0, Ie = 0, Se = 0, b = d[0], Le = d[1], je = d[2], qe = d[3], Pe = d[4], Ve = d[5], ze = d[6], dt = d[7], rt = d[8], ut = d[9], pt = d[10], Rt = d[11], wt = d[12], Nt = d[13], Wt = d[14], zt = d[15];
      f = p[0], h += f * b, x += f * Le, S += f * je, M += f * qe, V += f * Pe, Y += f * Ve, ie += f * ze, k += f * dt, ae += f * rt, oe += f * ut, se += f * pt, pe += f * Rt, xe += f * wt, ve += f * Nt, ce += f * Wt, ne += f * zt, f = p[1], x += f * b, S += f * Le, M += f * je, V += f * qe, Y += f * Pe, ie += f * Ve, k += f * ze, ae += f * dt, oe += f * rt, se += f * ut, pe += f * pt, xe += f * Rt, ve += f * wt, ce += f * Nt, ne += f * Wt, ge += f * zt, f = p[2], S += f * b, M += f * Le, V += f * je, Y += f * qe, ie += f * Pe, k += f * Ve, ae += f * ze, oe += f * dt, se += f * rt, pe += f * ut, xe += f * pt, ve += f * Rt, ce += f * wt, ne += f * Nt, ge += f * Wt, Q += f * zt, f = p[3], M += f * b, V += f * Le, Y += f * je, ie += f * qe, k += f * Pe, ae += f * Ve, oe += f * ze, se += f * dt, pe += f * rt, xe += f * ut, ve += f * pt, ce += f * Rt, ne += f * wt, ge += f * Nt, Q += f * Wt, re += f * zt, f = p[4], V += f * b, Y += f * Le, ie += f * je, k += f * qe, ae += f * Pe, oe += f * Ve, se += f * ze, pe += f * dt, xe += f * rt, ve += f * ut, ce += f * pt, ne += f * Rt, ge += f * wt, Q += f * Nt, re += f * Wt, fe += f * zt, f = p[5], Y += f * b, ie += f * Le, k += f * je, ae += f * qe, oe += f * Pe, se += f * Ve, pe += f * ze, xe += f * dt, ve += f * rt, ce += f * ut, ne += f * pt, ge += f * Rt, Q += f * wt, re += f * Nt, fe += f * Wt, X += f * zt, f = p[6], ie += f * b, k += f * Le, ae += f * je, oe += f * qe, se += f * Pe, pe += f * Ve, xe += f * ze, ve += f * dt, ce += f * rt, ne += f * ut, ge += f * pt, Q += f * Rt, re += f * wt, fe += f * Nt, X += f * Wt, C += f * zt, f = p[7], k += f * b, ae += f * Le, oe += f * je, se += f * qe, pe += f * Pe, xe += f * Ve, ve += f * ze, ce += f * dt, ne += f * rt, ge += f * ut, Q += f * pt, re += f * Rt, fe += f * wt, X += f * Nt, C += f * Wt, U += f * zt, f = p[8], ae += f * b, oe += f * Le, se += f * je, pe += f * qe, xe += f * Pe, ve += f * Ve, ce += f * ze, ne += f * dt, ge += f * rt, Q += f * ut, re += f * pt, fe += f * Rt, X += f * wt, C += f * Nt, U += f * Wt, K += f * zt, f = p[9], oe += f * b, se += f * Le, pe += f * je, xe += f * qe, ve += f * Pe, ce += f * Ve, ne += f * ze, ge += f * dt, Q += f * rt, re += f * ut, fe += f * pt, X += f * Rt, C += f * wt, U += f * Nt, K += f * Wt, D += f * zt, f = p[10], se += f * b, pe += f * Le, xe += f * je, ve += f * qe, ce += f * Pe, ne += f * Ve, ge += f * ze, Q += f * dt, re += f * rt, fe += f * ut, X += f * pt, C += f * Rt, U += f * wt, K += f * Nt, D += f * Wt, B += f * zt, f = p[11], pe += f * b, xe += f * Le, ve += f * je, ce += f * qe, ne += f * Pe, ge += f * Ve, Q += f * ze, re += f * dt, fe += f * rt, X += f * ut, C += f * pt, U += f * Rt, K += f * wt, D += f * Nt, B += f * Wt, H += f * zt, f = p[12], xe += f * b, ve += f * Le, ce += f * je, ne += f * qe, ge += f * Pe, Q += f * Ve, re += f * ze, fe += f * dt, X += f * rt, C += f * ut, U += f * pt, K += f * Rt, D += f * wt, B += f * Nt, H += f * Wt, ye += f * zt, f = p[13], ve += f * b, ce += f * Le, ne += f * je, ge += f * qe, Q += f * Pe, re += f * Ve, fe += f * ze, X += f * dt, C += f * rt, U += f * ut, K += f * pt, D += f * Rt, B += f * wt, H += f * Nt, ye += f * Wt, Ue += f * zt, f = p[14], ce += f * b, ne += f * Le, ge += f * je, Q += f * qe, re += f * Pe, fe += f * Ve, X += f * ze, C += f * dt, U += f * rt, K += f * ut, D += f * pt, B += f * Rt, H += f * wt, ye += f * Nt, Ue += f * Wt, Ie += f * zt, f = p[15], ne += f * b, ge += f * Le, Q += f * je, re += f * qe, fe += f * Pe, X += f * Ve, C += f * ze, U += f * dt, K += f * rt, D += f * ut, B += f * pt, H += f * Rt, ye += f * wt, Ue += f * Nt, Ie += f * Wt, Se += f * zt, h += 38 * ge, x += 38 * Q, S += 38 * re, M += 38 * fe, V += 38 * X, Y += 38 * C, ie += 38 * U, k += 38 * K, ae += 38 * D, oe += 38 * B, se += 38 * H, pe += 38 * ye, xe += 38 * Ue, ve += 38 * Ie, ce += 38 * Se, y = 1, f = h + y + 65535, y = Math.floor(f / 65536), h = f - y * 65536, f = x + y + 65535, y = Math.floor(f / 65536), x = f - y * 65536, f = S + y + 65535, y = Math.floor(f / 65536), S = f - y * 65536, f = M + y + 65535, y = Math.floor(f / 65536), M = f - y * 65536, f = V + y + 65535, y = Math.floor(f / 65536), V = f - y * 65536, f = Y + y + 65535, y = Math.floor(f / 65536), Y = f - y * 65536, f = ie + y + 65535, y = Math.floor(f / 65536), ie = f - y * 65536, f = k + y + 65535, y = Math.floor(f / 65536), k = f - y * 65536, f = ae + y + 65535, y = Math.floor(f / 65536), ae = f - y * 65536, f = oe + y + 65535, y = Math.floor(f / 65536), oe = f - y * 65536, f = se + y + 65535, y = Math.floor(f / 65536), se = f - y * 65536, f = pe + y + 65535, y = Math.floor(f / 65536), pe = f - y * 65536, f = xe + y + 65535, y = Math.floor(f / 65536), xe = f - y * 65536, f = ve + y + 65535, y = Math.floor(f / 65536), ve = f - y * 65536, f = ce + y + 65535, y = Math.floor(f / 65536), ce = f - y * 65536, f = ne + y + 65535, y = Math.floor(f / 65536), ne = f - y * 65536, h += y - 1 + 37 * (y - 1), y = 1, f = h + y + 65535, y = Math.floor(f / 65536), h = f - y * 65536, f = x + y + 65535, y = Math.floor(f / 65536), x = f - y * 65536, f = S + y + 65535, y = Math.floor(f / 65536), S = f - y * 65536, f = M + y + 65535, y = Math.floor(f / 65536), M = f - y * 65536, f = V + y + 65535, y = Math.floor(f / 65536), V = f - y * 65536, f = Y + y + 65535, y = Math.floor(f / 65536), Y = f - y * 65536, f = ie + y + 65535, y = Math.floor(f / 65536), ie = f - y * 65536, f = k + y + 65535, y = Math.floor(f / 65536), k = f - y * 65536, f = ae + y + 65535, y = Math.floor(f / 65536), ae = f - y * 65536, f = oe + y + 65535, y = Math.floor(f / 65536), oe = f - y * 65536, f = se + y + 65535, y = Math.floor(f / 65536), se = f - y * 65536, f = pe + y + 65535, y = Math.floor(f / 65536), pe = f - y * 65536, f = xe + y + 65535, y = Math.floor(f / 65536), xe = f - y * 65536, f = ve + y + 65535, y = Math.floor(f / 65536), ve = f - y * 65536, f = ce + y + 65535, y = Math.floor(f / 65536), ce = f - y * 65536, f = ne + y + 65535, y = Math.floor(f / 65536), ne = f - y * 65536, h += y - 1 + 37 * (y - 1), u[0] = h, u[1] = x, u[2] = S, u[3] = M, u[4] = V, u[5] = Y, u[6] = ie, u[7] = k, u[8] = ae, u[9] = oe, u[10] = se, u[11] = pe, u[12] = xe, u[13] = ve, u[14] = ce, u[15] = ne;
    }
    function $e(u, p) {
      ee(u, p, p);
    }
    function st(u, p) {
      var d = n(), f;
      for (f = 0; f < 16; f++) d[f] = p[f];
      for (f = 253; f >= 0; f--)
        $e(d, d), f !== 2 && f !== 4 && ee(d, d, p);
      for (f = 0; f < 16; f++) u[f] = d[f];
    }
    function Xe(u, p) {
      var d = n(), f;
      for (f = 0; f < 16; f++) d[f] = p[f];
      for (f = 250; f >= 0; f--)
        $e(d, d), f !== 1 && ee(d, d, p);
      for (f = 0; f < 16; f++) u[f] = d[f];
    }
    function Ke(u, p, d) {
      var f = new Uint8Array(32), y = new Float64Array(80), h, x, S = n(), M = n(), V = n(), Y = n(), ie = n(), k = n();
      for (x = 0; x < 31; x++) f[x] = p[x];
      for (f[31] = p[31] & 127 | 64, f[0] &= 248, J(y, d), x = 0; x < 16; x++)
        M[x] = y[x], Y[x] = S[x] = V[x] = 0;
      for (S[0] = Y[0] = 1, x = 254; x >= 0; --x)
        h = f[x >>> 3] >>> (x & 7) & 1, It(S, M, h), It(V, Y, h), Ee(ie, S, V), Oe(S, S, V), Ee(V, M, Y), Oe(M, M, Y), $e(Y, ie), $e(k, S), ee(S, V, S), ee(V, M, ie), Ee(ie, S, V), Oe(S, S, V), $e(M, S), Oe(V, Y, k), ee(S, V, G), Ee(S, S, Y), ee(V, V, S), ee(S, Y, k), ee(Y, M, y), $e(M, ie), It(S, M, h), It(V, Y, h);
      for (x = 0; x < 16; x++)
        y[x + 16] = S[x], y[x + 32] = V[x], y[x + 48] = M[x], y[x + 64] = Y[x];
      var ae = y.subarray(32), oe = y.subarray(16);
      return st(ae, ae), ee(oe, oe, ae), ln(u, oe), 0;
    }
    function St(u, p) {
      return Ke(u, p, R);
    }
    function sr(u, p) {
      return s(p, 32), St(u, p);
    }
    function Rn(u, p, d) {
      var f = new Uint8Array(32);
      return Ke(f, d, p), nt(u, v, f, ht);
    }
    var Hn = Kt, an = Lt;
    function An(u, p, d, f, y, h) {
      var x = new Uint8Array(32);
      return Rn(x, y, h), Hn(u, p, d, f, x);
    }
    function Gn(u, p, d, f, y, h) {
      var x = new Uint8Array(32);
      return Rn(x, y, h), an(u, p, d, f, x);
    }
    var qt = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function mr(u, p, d, f) {
      for (var y = new Int32Array(16), h = new Int32Array(16), x, S, M, V, Y, ie, k, ae, oe, se, pe, xe, ve, ce, ne, ge, Q, re, fe, X, C, U, K, D, B, H, ye = u[0], Ue = u[1], Ie = u[2], Se = u[3], b = u[4], Le = u[5], je = u[6], qe = u[7], Pe = p[0], Ve = p[1], ze = p[2], dt = p[3], rt = p[4], ut = p[5], pt = p[6], Rt = p[7], wt = 0; f >= 128; ) {
        for (fe = 0; fe < 16; fe++)
          X = 8 * fe + wt, y[fe] = d[X + 0] << 24 | d[X + 1] << 16 | d[X + 2] << 8 | d[X + 3], h[fe] = d[X + 4] << 24 | d[X + 5] << 16 | d[X + 6] << 8 | d[X + 7];
        for (fe = 0; fe < 80; fe++)
          if (x = ye, S = Ue, M = Ie, V = Se, Y = b, ie = Le, k = je, ae = qe, oe = Pe, se = Ve, pe = ze, xe = dt, ve = rt, ce = ut, ne = pt, ge = Rt, C = qe, U = Rt, K = U & 65535, D = U >>> 16, B = C & 65535, H = C >>> 16, C = (b >>> 14 | rt << 18) ^ (b >>> 18 | rt << 14) ^ (rt >>> 9 | b << 23), U = (rt >>> 14 | b << 18) ^ (rt >>> 18 | b << 14) ^ (b >>> 9 | rt << 23), K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, C = b & Le ^ ~b & je, U = rt & ut ^ ~rt & pt, K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, C = qt[fe * 2], U = qt[fe * 2 + 1], K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, C = y[fe % 16], U = h[fe % 16], K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, D += K >>> 16, B += D >>> 16, H += B >>> 16, Q = B & 65535 | H << 16, re = K & 65535 | D << 16, C = Q, U = re, K = U & 65535, D = U >>> 16, B = C & 65535, H = C >>> 16, C = (ye >>> 28 | Pe << 4) ^ (Pe >>> 2 | ye << 30) ^ (Pe >>> 7 | ye << 25), U = (Pe >>> 28 | ye << 4) ^ (ye >>> 2 | Pe << 30) ^ (ye >>> 7 | Pe << 25), K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, C = ye & Ue ^ ye & Ie ^ Ue & Ie, U = Pe & Ve ^ Pe & ze ^ Ve & ze, K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, D += K >>> 16, B += D >>> 16, H += B >>> 16, ae = B & 65535 | H << 16, ge = K & 65535 | D << 16, C = V, U = xe, K = U & 65535, D = U >>> 16, B = C & 65535, H = C >>> 16, C = Q, U = re, K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, D += K >>> 16, B += D >>> 16, H += B >>> 16, V = B & 65535 | H << 16, xe = K & 65535 | D << 16, Ue = x, Ie = S, Se = M, b = V, Le = Y, je = ie, qe = k, ye = ae, Ve = oe, ze = se, dt = pe, rt = xe, ut = ve, pt = ce, Rt = ne, Pe = ge, fe % 16 === 15)
            for (X = 0; X < 16; X++)
              C = y[X], U = h[X], K = U & 65535, D = U >>> 16, B = C & 65535, H = C >>> 16, C = y[(X + 9) % 16], U = h[(X + 9) % 16], K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, Q = y[(X + 1) % 16], re = h[(X + 1) % 16], C = (Q >>> 1 | re << 31) ^ (Q >>> 8 | re << 24) ^ Q >>> 7, U = (re >>> 1 | Q << 31) ^ (re >>> 8 | Q << 24) ^ (re >>> 7 | Q << 25), K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, Q = y[(X + 14) % 16], re = h[(X + 14) % 16], C = (Q >>> 19 | re << 13) ^ (re >>> 29 | Q << 3) ^ Q >>> 6, U = (re >>> 19 | Q << 13) ^ (Q >>> 29 | re << 3) ^ (re >>> 6 | Q << 26), K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, D += K >>> 16, B += D >>> 16, H += B >>> 16, y[X] = B & 65535 | H << 16, h[X] = K & 65535 | D << 16;
        C = ye, U = Pe, K = U & 65535, D = U >>> 16, B = C & 65535, H = C >>> 16, C = u[0], U = p[0], K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, D += K >>> 16, B += D >>> 16, H += B >>> 16, u[0] = ye = B & 65535 | H << 16, p[0] = Pe = K & 65535 | D << 16, C = Ue, U = Ve, K = U & 65535, D = U >>> 16, B = C & 65535, H = C >>> 16, C = u[1], U = p[1], K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, D += K >>> 16, B += D >>> 16, H += B >>> 16, u[1] = Ue = B & 65535 | H << 16, p[1] = Ve = K & 65535 | D << 16, C = Ie, U = ze, K = U & 65535, D = U >>> 16, B = C & 65535, H = C >>> 16, C = u[2], U = p[2], K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, D += K >>> 16, B += D >>> 16, H += B >>> 16, u[2] = Ie = B & 65535 | H << 16, p[2] = ze = K & 65535 | D << 16, C = Se, U = dt, K = U & 65535, D = U >>> 16, B = C & 65535, H = C >>> 16, C = u[3], U = p[3], K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, D += K >>> 16, B += D >>> 16, H += B >>> 16, u[3] = Se = B & 65535 | H << 16, p[3] = dt = K & 65535 | D << 16, C = b, U = rt, K = U & 65535, D = U >>> 16, B = C & 65535, H = C >>> 16, C = u[4], U = p[4], K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, D += K >>> 16, B += D >>> 16, H += B >>> 16, u[4] = b = B & 65535 | H << 16, p[4] = rt = K & 65535 | D << 16, C = Le, U = ut, K = U & 65535, D = U >>> 16, B = C & 65535, H = C >>> 16, C = u[5], U = p[5], K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, D += K >>> 16, B += D >>> 16, H += B >>> 16, u[5] = Le = B & 65535 | H << 16, p[5] = ut = K & 65535 | D << 16, C = je, U = pt, K = U & 65535, D = U >>> 16, B = C & 65535, H = C >>> 16, C = u[6], U = p[6], K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, D += K >>> 16, B += D >>> 16, H += B >>> 16, u[6] = je = B & 65535 | H << 16, p[6] = pt = K & 65535 | D << 16, C = qe, U = Rt, K = U & 65535, D = U >>> 16, B = C & 65535, H = C >>> 16, C = u[7], U = p[7], K += U & 65535, D += U >>> 16, B += C & 65535, H += C >>> 16, D += K >>> 16, B += D >>> 16, H += B >>> 16, u[7] = qe = B & 65535 | H << 16, p[7] = Rt = K & 65535 | D << 16, wt += 128, f -= 128;
      }
      return f;
    }
    function sn(u, p, d) {
      var f = new Int32Array(8), y = new Int32Array(8), h = new Uint8Array(256), x, S = d;
      for (f[0] = 1779033703, f[1] = 3144134277, f[2] = 1013904242, f[3] = 2773480762, f[4] = 1359893119, f[5] = 2600822924, f[6] = 528734635, f[7] = 1541459225, y[0] = 4089235720, y[1] = 2227873595, y[2] = 4271175723, y[3] = 1595750129, y[4] = 2917565137, y[5] = 725511199, y[6] = 4215389547, y[7] = 327033209, mr(f, y, p, d), d %= 128, x = 0; x < d; x++) h[x] = p[S - d + x];
      for (h[d] = 128, d = 256 - 128 * (d < 112 ? 1 : 0), h[d - 9] = 0, tt(h, d - 8, S / 536870912 | 0, S << 3), mr(f, y, h, d), x = 0; x < 8; x++) tt(u, 8 * x, f[x], y[x]);
      return 0;
    }
    function Yt(u, p) {
      var d = n(), f = n(), y = n(), h = n(), x = n(), S = n(), M = n(), V = n(), Y = n();
      Oe(d, u[1], u[0]), Oe(Y, p[1], p[0]), ee(d, d, Y), Ee(f, u[0], u[1]), Ee(Y, p[0], p[1]), ee(f, f, Y), ee(y, u[3], p[3]), ee(y, y, he), ee(h, u[2], p[2]), Ee(h, h, h), Oe(x, f, d), Oe(S, h, y), Ee(M, h, y), Ee(V, f, d), ee(u[0], x, S), ee(u[1], V, M), ee(u[2], M, S), ee(u[3], x, V);
    }
    function Bt(u, p, d) {
      var f;
      for (f = 0; f < 4; f++)
        It(u[f], p[f], d);
    }
    function hn(u, p) {
      var d = n(), f = n(), y = n();
      st(y, p[2]), ee(d, p[0], y), ee(f, p[1], y), ln(u, f), u[31] ^= O(d) << 7;
    }
    function Nn(u, p, d) {
      var f, y;
      for (Mt(u[0], I), Mt(u[1], L), Mt(u[2], L), Mt(u[3], I), y = 255; y >= 0; --y)
        f = d[y / 8 | 0] >> (y & 7) & 1, Bt(u, p, f), Yt(p, u), Yt(u, u), Bt(u, p, f);
    }
    function ur(u, p) {
      var d = [n(), n(), n(), n()];
      Mt(d[0], me), Mt(d[1], Me), Mt(d[2], L), ee(d[3], me, Me), Nn(u, d, p);
    }
    function dn(u, p, d) {
      var f = new Uint8Array(64), y = [n(), n(), n(), n()], h;
      for (d || s(p, 32), sn(f, p, 32), f[0] &= 248, f[31] &= 127, f[31] |= 64, ur(y, f), hn(u, y), h = 0; h < 32; h++) p[h + 32] = u[h];
      return 0;
    }
    var qn = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function rn(u, p) {
      var d, f, y, h;
      for (f = 63; f >= 32; --f) {
        for (d = 0, y = f - 32, h = f - 12; y < h; ++y)
          p[y] += d - 16 * p[f] * qn[y - (f - 32)], d = Math.floor((p[y] + 128) / 256), p[y] -= d * 256;
        p[y] += d, p[f] = 0;
      }
      for (d = 0, y = 0; y < 32; y++)
        p[y] += d - (p[31] >> 4) * qn[y], d = p[y] >> 8, p[y] &= 255;
      for (y = 0; y < 32; y++) p[y] -= d * qn[y];
      for (f = 0; f < 32; f++)
        p[f + 1] += p[f] >> 8, u[f] = p[f] & 255;
    }
    function Tn(u) {
      var p = new Float64Array(64), d;
      for (d = 0; d < 64; d++) p[d] = u[d];
      for (d = 0; d < 64; d++) u[d] = 0;
      rn(u, p);
    }
    function cr(u, p, d, f) {
      var y = new Uint8Array(64), h = new Uint8Array(64), x = new Uint8Array(64), S, M, V = new Float64Array(64), Y = [n(), n(), n(), n()];
      sn(y, f, 32), y[0] &= 248, y[31] &= 127, y[31] |= 64;
      var ie = d + 64;
      for (S = 0; S < d; S++) u[64 + S] = p[S];
      for (S = 0; S < 32; S++) u[32 + S] = y[32 + S];
      for (sn(x, u.subarray(32), d + 32), Tn(x), ur(Y, x), hn(u, Y), S = 32; S < 64; S++) u[S] = f[S];
      for (sn(h, u, d + 64), Tn(h), S = 0; S < 64; S++) V[S] = 0;
      for (S = 0; S < 32; S++) V[S] = x[S];
      for (S = 0; S < 32; S++)
        for (M = 0; M < 32; M++)
          V[S + M] += h[S] * y[M];
      return rn(u.subarray(32), V), ie;
    }
    function wr(u, p) {
      var d = n(), f = n(), y = n(), h = n(), x = n(), S = n(), M = n();
      return Mt(u[2], L), J(u[1], p), $e(y, u[1]), ee(h, y, Z), Oe(y, y, u[2]), Ee(h, u[2], h), $e(x, h), $e(S, x), ee(M, S, x), ee(d, M, y), ee(d, d, h), Xe(d, d), ee(d, d, y), ee(d, d, h), ee(d, d, h), ee(u[0], d, h), $e(f, u[0]), ee(f, f, h), fn(f, y) && ee(u[0], u[0], be), $e(f, u[0]), ee(f, f, h), fn(f, y) ? -1 : (O(u[0]) === p[31] >> 7 && Oe(u[0], I, u[0]), ee(u[3], u[0], u[1]), 0);
    }
    function vn(u, p, d, f) {
      var y, h = new Uint8Array(32), x = new Uint8Array(64), S = [n(), n(), n(), n()], M = [n(), n(), n(), n()];
      if (d < 64 || wr(M, f)) return -1;
      for (y = 0; y < d; y++) u[y] = p[y];
      for (y = 0; y < 32; y++) u[y + 32] = f[y];
      if (sn(x, u, d), Tn(x), Nn(S, M, x), ur(M, p.subarray(32)), Yt(S, M), hn(h, S), d -= 64, mt(p, 0, h, 0)) {
        for (y = 0; y < d; y++) u[y] = 0;
        return -1;
      }
      for (y = 0; y < d; y++) u[y] = p[y + 64];
      return d;
    }
    var lr = 32, Vn = 24, Fn = 32, Jt = 16, On = 32, Jn = 32, hr = 32, In = 32, Er = 32, _n = Vn, Zn = Fn, Xn = Jt, Zt = 64, Dn = 32, Bn = 64, Sr = 32, Rr = 64;
    r.lowlevel = {
      crypto_core_hsalsa20: nt,
      crypto_stream_xor: Mn,
      crypto_stream: Sn,
      crypto_stream_salsa20_xor: Ut,
      crypto_stream_salsa20: nn,
      crypto_onetimeauth: $n,
      crypto_onetimeauth_verify: kt,
      crypto_verify_16: Ge,
      crypto_verify_32: mt,
      crypto_secretbox: Kt,
      crypto_secretbox_open: Lt,
      crypto_scalarmult: Ke,
      crypto_scalarmult_base: St,
      crypto_box_beforenm: Rn,
      crypto_box_afternm: Hn,
      crypto_box: An,
      crypto_box_open: Gn,
      crypto_box_keypair: sr,
      crypto_hash: sn,
      crypto_sign: cr,
      crypto_sign_keypair: dn,
      crypto_sign_open: vn,
      crypto_secretbox_KEYBYTES: lr,
      crypto_secretbox_NONCEBYTES: Vn,
      crypto_secretbox_ZEROBYTES: Fn,
      crypto_secretbox_BOXZEROBYTES: Jt,
      crypto_scalarmult_BYTES: On,
      crypto_scalarmult_SCALARBYTES: Jn,
      crypto_box_PUBLICKEYBYTES: hr,
      crypto_box_SECRETKEYBYTES: In,
      crypto_box_BEFORENMBYTES: Er,
      crypto_box_NONCEBYTES: _n,
      crypto_box_ZEROBYTES: Zn,
      crypto_box_BOXZEROBYTES: Xn,
      crypto_sign_BYTES: Zt,
      crypto_sign_PUBLICKEYBYTES: Dn,
      crypto_sign_SECRETKEYBYTES: Bn,
      crypto_sign_SEEDBYTES: Sr,
      crypto_hash_BYTES: Rr,
      gf: n,
      D: Z,
      L: qn,
      pack25519: ln,
      unpack25519: J,
      M: ee,
      A: Ee,
      S: $e,
      Z: Oe,
      pow2523: Xe,
      add: Yt,
      set25519: Mt,
      modL: rn,
      scalarmult: Nn,
      scalarbase: ur
    };
    function Ur(u, p) {
      if (u.length !== lr) throw new Error("bad key size");
      if (p.length !== Vn) throw new Error("bad nonce size");
    }
    function dr(u, p) {
      if (u.length !== hr) throw new Error("bad public key size");
      if (p.length !== In) throw new Error("bad secret key size");
    }
    function $t() {
      for (var u = 0; u < arguments.length; u++)
        if (!(arguments[u] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function Ar(u) {
      for (var p = 0; p < u.length; p++) u[p] = 0;
    }
    r.randomBytes = function(u) {
      var p = new Uint8Array(u);
      return s(p, u), p;
    }, r.secretbox = function(u, p, d) {
      $t(u, p, d), Ur(d, p);
      for (var f = new Uint8Array(Fn + u.length), y = new Uint8Array(f.length), h = 0; h < u.length; h++) f[h + Fn] = u[h];
      return Kt(y, f, f.length, p, d), y.subarray(Jt);
    }, r.secretbox.open = function(u, p, d) {
      $t(u, p, d), Ur(d, p);
      for (var f = new Uint8Array(Jt + u.length), y = new Uint8Array(f.length), h = 0; h < u.length; h++) f[h + Jt] = u[h];
      return f.length < 32 || Lt(y, f, f.length, p, d) !== 0 ? null : y.subarray(Fn);
    }, r.secretbox.keyLength = lr, r.secretbox.nonceLength = Vn, r.secretbox.overheadLength = Jt, r.scalarMult = function(u, p) {
      if ($t(u, p), u.length !== Jn) throw new Error("bad n size");
      if (p.length !== On) throw new Error("bad p size");
      var d = new Uint8Array(On);
      return Ke(d, u, p), d;
    }, r.scalarMult.base = function(u) {
      if ($t(u), u.length !== Jn) throw new Error("bad n size");
      var p = new Uint8Array(On);
      return St(p, u), p;
    }, r.scalarMult.scalarLength = Jn, r.scalarMult.groupElementLength = On, r.box = function(u, p, d, f) {
      var y = r.box.before(d, f);
      return r.secretbox(u, p, y);
    }, r.box.before = function(u, p) {
      $t(u, p), dr(u, p);
      var d = new Uint8Array(Er);
      return Rn(d, u, p), d;
    }, r.box.after = r.secretbox, r.box.open = function(u, p, d, f) {
      var y = r.box.before(d, f);
      return r.secretbox.open(u, p, y);
    }, r.box.open.after = r.secretbox.open, r.box.keyPair = function() {
      var u = new Uint8Array(hr), p = new Uint8Array(In);
      return sr(u, p), { publicKey: u, secretKey: p };
    }, r.box.keyPair.fromSecretKey = function(u) {
      if ($t(u), u.length !== In)
        throw new Error("bad secret key size");
      var p = new Uint8Array(hr);
      return St(p, u), { publicKey: p, secretKey: new Uint8Array(u) };
    }, r.box.publicKeyLength = hr, r.box.secretKeyLength = In, r.box.sharedKeyLength = Er, r.box.nonceLength = _n, r.box.overheadLength = r.secretbox.overheadLength, r.sign = function(u, p) {
      if ($t(u, p), p.length !== Bn)
        throw new Error("bad secret key size");
      var d = new Uint8Array(Zt + u.length);
      return cr(d, u, u.length, p), d;
    }, r.sign.open = function(u, p) {
      if ($t(u, p), p.length !== Dn)
        throw new Error("bad public key size");
      var d = new Uint8Array(u.length), f = vn(d, u, u.length, p);
      if (f < 0) return null;
      for (var y = new Uint8Array(f), h = 0; h < y.length; h++) y[h] = d[h];
      return y;
    }, r.sign.detached = function(u, p) {
      for (var d = r.sign(u, p), f = new Uint8Array(Zt), y = 0; y < f.length; y++) f[y] = d[y];
      return f;
    }, r.sign.detached.verify = function(u, p, d) {
      if ($t(u, p, d), p.length !== Zt)
        throw new Error("bad signature size");
      if (d.length !== Dn)
        throw new Error("bad public key size");
      var f = new Uint8Array(Zt + u.length), y = new Uint8Array(Zt + u.length), h;
      for (h = 0; h < Zt; h++) f[h] = p[h];
      for (h = 0; h < u.length; h++) f[h + Zt] = u[h];
      return vn(y, f, f.length, d) >= 0;
    }, r.sign.keyPair = function() {
      var u = new Uint8Array(Dn), p = new Uint8Array(Bn);
      return dn(u, p), { publicKey: u, secretKey: p };
    }, r.sign.keyPair.fromSecretKey = function(u) {
      if ($t(u), u.length !== Bn)
        throw new Error("bad secret key size");
      for (var p = new Uint8Array(Dn), d = 0; d < p.length; d++) p[d] = u[32 + d];
      return { publicKey: p, secretKey: new Uint8Array(u) };
    }, r.sign.keyPair.fromSeed = function(u) {
      if ($t(u), u.length !== Sr)
        throw new Error("bad seed size");
      for (var p = new Uint8Array(Dn), d = new Uint8Array(Bn), f = 0; f < 32; f++) d[f] = u[f];
      return dn(p, d, !0), { publicKey: p, secretKey: d };
    }, r.sign.publicKeyLength = Dn, r.sign.secretKeyLength = Bn, r.sign.seedLength = Sr, r.sign.signatureLength = Zt, r.hash = function(u) {
      $t(u);
      var p = new Uint8Array(Rr);
      return sn(p, u, u.length), p;
    }, r.hash.hashLength = Rr, r.verify = function(u, p) {
      return $t(u, p), u.length === 0 || p.length === 0 || u.length !== p.length ? !1 : We(u, 0, p, 0, u.length) === 0;
    }, r.setPRNG = function(u) {
      s = u;
    }, function() {
      var u = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (u && u.getRandomValues) {
        var p = 65536;
        r.setPRNG(function(d, f) {
          var y, h = new Uint8Array(f);
          for (y = 0; y < f; y += p)
            u.getRandomValues(h.subarray(y, y + Math.min(f - y, p)));
          for (y = 0; y < f; y++) d[y] = h[y];
          Ar(h);
        });
      } else typeof H_ < "u" && (u = V_, u && u.randomBytes && r.setPRNG(function(d, f) {
        var y, h = u.randomBytes(f);
        for (y = 0; y < f; y++) d[y] = h[y];
        Ar(h);
      }));
    }();
  })(o.exports ? o.exports : self.nacl = self.nacl || {});
})(Ol);
var J_ = Ol.exports;
const wf = /* @__PURE__ */ Ro(J_);
var jc;
(function(o) {
  o[o.UNKNOWN_ERROR = 0] = "UNKNOWN_ERROR", o[o.BAD_REQUEST_ERROR = 1] = "BAD_REQUEST_ERROR", o[o.MANIFEST_NOT_FOUND_ERROR = 2] = "MANIFEST_NOT_FOUND_ERROR", o[o.MANIFEST_CONTENT_ERROR = 3] = "MANIFEST_CONTENT_ERROR", o[o.UNKNOWN_APP_ERROR = 100] = "UNKNOWN_APP_ERROR", o[o.USER_REJECTS_ERROR = 300] = "USER_REJECTS_ERROR", o[o.METHOD_NOT_SUPPORTED = 400] = "METHOD_NOT_SUPPORTED";
})(jc || (jc = {}));
var kc;
(function(o) {
  o[o.UNKNOWN_ERROR = 0] = "UNKNOWN_ERROR", o[o.METHOD_NOT_SUPPORTED = 400] = "METHOD_NOT_SUPPORTED";
})(kc || (kc = {}));
var Kc;
(function(o) {
  o[o.UNKNOWN_ERROR = 0] = "UNKNOWN_ERROR", o[o.BAD_REQUEST_ERROR = 1] = "BAD_REQUEST_ERROR", o[o.UNKNOWN_APP_ERROR = 100] = "UNKNOWN_APP_ERROR", o[o.USER_REJECTS_ERROR = 300] = "USER_REJECTS_ERROR", o[o.METHOD_NOT_SUPPORTED = 400] = "METHOD_NOT_SUPPORTED";
})(Kc || (Kc = {}));
var Yc;
(function(o) {
  o[o.UNKNOWN_ERROR = 0] = "UNKNOWN_ERROR", o[o.BAD_REQUEST_ERROR = 1] = "BAD_REQUEST_ERROR", o[o.UNKNOWN_APP_ERROR = 100] = "UNKNOWN_APP_ERROR", o[o.USER_REJECTS_ERROR = 300] = "USER_REJECTS_ERROR", o[o.METHOD_NOT_SUPPORTED = 400] = "METHOD_NOT_SUPPORTED";
})(Yc || (Yc = {}));
var zc;
(function(o) {
  o[o.UNKNOWN_ERROR = 0] = "UNKNOWN_ERROR", o[o.BAD_REQUEST_ERROR = 1] = "BAD_REQUEST_ERROR", o[o.UNKNOWN_APP_ERROR = 100] = "UNKNOWN_APP_ERROR", o[o.METHOD_NOT_SUPPORTED = 400] = "METHOD_NOT_SUPPORTED";
})(zc || (zc = {}));
var Hc;
(function(o) {
  o.MAINNET = "-239", o.TESTNET = "-3";
})(Hc || (Hc = {}));
function Z_(o, r) {
  const n = So.encodeBase64(o);
  return r ? encodeURIComponent(n) : n;
}
function X_(o, r) {
  return r && (o = decodeURIComponent(o)), So.decodeBase64(o);
}
function Q_(o, r = !1) {
  let n;
  return o instanceof Uint8Array ? n = o : (typeof o != "string" && (o = JSON.stringify(o)), n = So.decodeUTF8(o)), Z_(n, r);
}
function ey(o, r = !1) {
  const n = X_(o, r);
  return {
    toString() {
      return So.encodeUTF8(n);
    },
    toObject() {
      try {
        return JSON.parse(So.encodeUTF8(n));
      } catch {
        return null;
      }
    },
    toUint8Array() {
      return n;
    }
  };
}
const Gc = {
  encode: Q_,
  decode: ey
};
function ty(o, r) {
  const n = new Uint8Array(o.length + r.length);
  return n.set(o), n.set(r, o.length), n;
}
function ny(o, r) {
  if (r >= o.length)
    throw new Error("Index is out of buffer");
  const n = o.slice(0, r), s = o.slice(r);
  return [n, s];
}
function Ga(o) {
  let r = "";
  return o.forEach((n) => {
    r += ("0" + (n & 255).toString(16)).slice(-2);
  }), r;
}
function Tf(o) {
  if (o.length % 2 !== 0)
    throw new Error(`Cannot convert ${o} to bytesArray`);
  const r = new Uint8Array(o.length / 2);
  for (let n = 0; n < o.length; n += 2)
    r[n / 2] = parseInt(o.slice(n, n + 2), 16);
  return r;
}
class os {
  constructor(r) {
    this.nonceLength = 24, this.keyPair = r ? this.createKeypairFromString(r) : this.createKeypair(), this.sessionId = Ga(this.keyPair.publicKey);
  }
  createKeypair() {
    return wf.box.keyPair();
  }
  createKeypairFromString(r) {
    return {
      publicKey: Tf(r.publicKey),
      secretKey: Tf(r.secretKey)
    };
  }
  createNonce() {
    return wf.randomBytes(this.nonceLength);
  }
  encrypt(r, n) {
    const s = new TextEncoder().encode(r), v = this.createNonce(), R = wf.box(s, v, n, this.keyPair.secretKey);
    return ty(v, R);
  }
  decrypt(r, n) {
    const [s, v] = ny(r, this.nonceLength), R = wf.box.open(v, s, n, this.keyPair.secretKey);
    if (!R)
      throw new Error(`Decryption error: 
 message: ${r.toString()} 
 sender pubkey: ${n.toString()} 
 keypair pubkey: ${this.keyPair.publicKey.toString()} 
 keypair secretkey: ${this.keyPair.secretKey.toString()}`);
    return new TextDecoder().decode(R);
  }
  stringifyKeypair() {
    return {
      publicKey: Ga(this.keyPair.publicKey),
      secretKey: Ga(this.keyPair.secretKey)
    };
  }
}
var fs = function(o, r) {
  return fs = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, s) {
    n.__proto__ = s;
  } || function(n, s) {
    for (var v in s) Object.prototype.hasOwnProperty.call(s, v) && (n[v] = s[v]);
  }, fs(o, r);
};
function Cf(o, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  fs(o, r);
  function n() {
    this.constructor = o;
  }
  o.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
}
function as(o) {
  var r = typeof Symbol == "function" && Symbol.iterator, n = r && o[r], s = 0;
  if (n) return n.call(o);
  if (o && typeof o.length == "number") return {
    next: function() {
      return o && s >= o.length && (o = void 0), { value: o && o[s++], done: !o };
    }
  };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function ss(o, r) {
  var n = typeof Symbol == "function" && o[Symbol.iterator];
  if (!n) return o;
  var s = n.call(o), v, R = [], I;
  try {
    for (; (r === void 0 || r-- > 0) && !(v = s.next()).done; ) R.push(v.value);
  } catch (L) {
    I = { error: L };
  } finally {
    try {
      v && !v.done && (n = s.return) && n.call(s);
    } finally {
      if (I) throw I.error;
    }
  }
  return R;
}
function us(o, r, n) {
  if (n || arguments.length === 2) for (var s = 0, v = r.length, R; s < v; s++)
    (R || !(s in r)) && (R || (R = Array.prototype.slice.call(r, 0, s)), R[s] = r[s]);
  return o.concat(R || Array.prototype.slice.call(r));
}
function zr(o) {
  return typeof o == "function";
}
function Il(o) {
  var r = function(s) {
    Error.call(s), s.stack = new Error().stack;
  }, n = o(r);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var qa = Il(function(o) {
  return function(n) {
    o(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(s, v) {
      return v + 1 + ") " + s.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function cs(o, r) {
  if (o) {
    var n = o.indexOf(r);
    0 <= n && o.splice(n, 1);
  }
}
var Uf = function() {
  function o(r) {
    this.initialTeardown = r, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return o.prototype.unsubscribe = function() {
    var r, n, s, v, R;
    if (!this.closed) {
      this.closed = !0;
      var I = this._parentage;
      if (I)
        if (this._parentage = null, Array.isArray(I))
          try {
            for (var L = as(I), G = L.next(); !G.done; G = L.next()) {
              var Z = G.value;
              Z.remove(this);
            }
          } catch (We) {
            r = { error: We };
          } finally {
            try {
              G && !G.done && (n = L.return) && n.call(L);
            } finally {
              if (r) throw r.error;
            }
          }
        else
          I.remove(this);
      var he = this.initialTeardown;
      if (zr(he))
        try {
          he();
        } catch (We) {
          R = We instanceof qa ? We.errors : [We];
        }
      var me = this._finalizers;
      if (me) {
        this._finalizers = null;
        try {
          for (var Me = as(me), be = Me.next(); !be.done; be = Me.next()) {
            var tt = be.value;
            try {
              qc(tt);
            } catch (We) {
              R = R ?? [], We instanceof qa ? R = us(us([], ss(R)), ss(We.errors)) : R.push(We);
            }
          }
        } catch (We) {
          s = { error: We };
        } finally {
          try {
            be && !be.done && (v = Me.return) && v.call(Me);
          } finally {
            if (s) throw s.error;
          }
        }
      }
      if (R)
        throw new qa(R);
    }
  }, o.prototype.add = function(r) {
    var n;
    if (r && r !== this)
      if (this.closed)
        qc(r);
      else {
        if (r instanceof o) {
          if (r.closed || r._hasParent(this))
            return;
          r._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(r);
      }
  }, o.prototype._hasParent = function(r) {
    var n = this._parentage;
    return n === r || Array.isArray(n) && n.includes(r);
  }, o.prototype._addParent = function(r) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(r), n) : n ? [n, r] : r;
  }, o.prototype._removeParent = function(r) {
    var n = this._parentage;
    n === r ? this._parentage = null : Array.isArray(n) && cs(n, r);
  }, o.prototype.remove = function(r) {
    var n = this._finalizers;
    n && cs(n, r), r instanceof o && r._removeParent(this);
  }, o.EMPTY = function() {
    var r = new o();
    return r.closed = !0, r;
  }(), o;
}(), Pl = Uf.EMPTY;
function Cl(o) {
  return o instanceof Uf || o && "closed" in o && zr(o.remove) && zr(o.add) && zr(o.unsubscribe);
}
function qc(o) {
  zr(o) ? o() : o.unsubscribe();
}
var Ul = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, ry = {
  setTimeout: function(o, r) {
    for (var n = [], s = 2; s < arguments.length; s++)
      n[s - 2] = arguments[s];
    return setTimeout.apply(void 0, us([o, r], ss(n)));
  },
  clearTimeout: function(o) {
    return clearTimeout(o);
  },
  delegate: void 0
};
function iy(o) {
  ry.setTimeout(function() {
    throw o;
  });
}
function Vc() {
}
function Rf(o) {
  o();
}
var Ll = function(o) {
  Cf(r, o);
  function r(n) {
    var s = o.call(this) || this;
    return s.isStopped = !1, n ? (s.destination = n, Cl(n) && n.add(s)) : s.destination = sy, s;
  }
  return r.create = function(n, s, v) {
    return new ls(n, s, v);
  }, r.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, r.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, r.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, r.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, o.prototype.unsubscribe.call(this), this.destination = null);
  }, r.prototype._next = function(n) {
    this.destination.next(n);
  }, r.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, r.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, r;
}(Uf), oy = Function.prototype.bind;
function Va(o, r) {
  return oy.call(o, r);
}
var fy = function() {
  function o(r) {
    this.partialObserver = r;
  }
  return o.prototype.next = function(r) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(r);
      } catch (s) {
        Ef(s);
      }
  }, o.prototype.error = function(r) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(r);
      } catch (s) {
        Ef(s);
      }
    else
      Ef(r);
  }, o.prototype.complete = function() {
    var r = this.partialObserver;
    if (r.complete)
      try {
        r.complete();
      } catch (n) {
        Ef(n);
      }
  }, o;
}(), ls = function(o) {
  Cf(r, o);
  function r(n, s, v) {
    var R = o.call(this) || this, I;
    if (zr(n) || !n)
      I = {
        next: n ?? void 0,
        error: s ?? void 0,
        complete: v ?? void 0
      };
    else {
      var L;
      R && Ul.useDeprecatedNextContext ? (L = Object.create(n), L.unsubscribe = function() {
        return R.unsubscribe();
      }, I = {
        next: n.next && Va(n.next, L),
        error: n.error && Va(n.error, L),
        complete: n.complete && Va(n.complete, L)
      }) : I = n;
    }
    return R.destination = new fy(I), R;
  }
  return r;
}(Ll);
function Ef(o) {
  iy(o);
}
function ay(o) {
  throw o;
}
var sy = {
  closed: !0,
  next: Vc,
  error: ay,
  complete: Vc
}, uy = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function cy(o) {
  return o;
}
function ly(o) {
  return o.length === 0 ? cy : o.length === 1 ? o[0] : function(n) {
    return o.reduce(function(s, v) {
      return v(s);
    }, n);
  };
}
var Jc = function() {
  function o(r) {
    r && (this._subscribe = r);
  }
  return o.prototype.lift = function(r) {
    var n = new o();
    return n.source = this, n.operator = r, n;
  }, o.prototype.subscribe = function(r, n, s) {
    var v = this, R = dy(r) ? r : new ls(r, n, s);
    return Rf(function() {
      var I = v, L = I.operator, G = I.source;
      R.add(L ? L.call(R, G) : G ? v._subscribe(R) : v._trySubscribe(R));
    }), R;
  }, o.prototype._trySubscribe = function(r) {
    try {
      return this._subscribe(r);
    } catch (n) {
      r.error(n);
    }
  }, o.prototype.forEach = function(r, n) {
    var s = this;
    return n = Zc(n), new n(function(v, R) {
      var I = new ls({
        next: function(L) {
          try {
            r(L);
          } catch (G) {
            R(G), I.unsubscribe();
          }
        },
        error: R,
        complete: v
      });
      s.subscribe(I);
    });
  }, o.prototype._subscribe = function(r) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(r);
  }, o.prototype[uy] = function() {
    return this;
  }, o.prototype.pipe = function() {
    for (var r = [], n = 0; n < arguments.length; n++)
      r[n] = arguments[n];
    return ly(r)(this);
  }, o.prototype.toPromise = function(r) {
    var n = this;
    return r = Zc(r), new r(function(s, v) {
      var R;
      n.subscribe(function(I) {
        return R = I;
      }, function(I) {
        return v(I);
      }, function() {
        return s(R);
      });
    });
  }, o.create = function(r) {
    return new o(r);
  }, o;
}();
function Zc(o) {
  var r;
  return (r = o ?? Ul.Promise) !== null && r !== void 0 ? r : Promise;
}
function hy(o) {
  return o && zr(o.next) && zr(o.error) && zr(o.complete);
}
function dy(o) {
  return o && o instanceof Ll || hy(o) && Cl(o);
}
var py = Il(function(o) {
  return function() {
    o(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), Ml = function(o) {
  Cf(r, o);
  function r() {
    var n = o.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return r.prototype.lift = function(n) {
    var s = new Xc(this, this);
    return s.operator = n, s;
  }, r.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new py();
  }, r.prototype.next = function(n) {
    var s = this;
    Rf(function() {
      var v, R;
      if (s._throwIfClosed(), !s.isStopped) {
        s.currentObservers || (s.currentObservers = Array.from(s.observers));
        try {
          for (var I = as(s.currentObservers), L = I.next(); !L.done; L = I.next()) {
            var G = L.value;
            G.next(n);
          }
        } catch (Z) {
          v = { error: Z };
        } finally {
          try {
            L && !L.done && (R = I.return) && R.call(I);
          } finally {
            if (v) throw v.error;
          }
        }
      }
    });
  }, r.prototype.error = function(n) {
    var s = this;
    Rf(function() {
      if (s._throwIfClosed(), !s.isStopped) {
        s.hasError = s.isStopped = !0, s.thrownError = n;
        for (var v = s.observers; v.length; )
          v.shift().error(n);
      }
    });
  }, r.prototype.complete = function() {
    var n = this;
    Rf(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var s = n.observers; s.length; )
          s.shift().complete();
      }
    });
  }, r.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(r.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), r.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), o.prototype._trySubscribe.call(this, n);
  }, r.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, r.prototype._innerSubscribe = function(n) {
    var s = this, v = this, R = v.hasError, I = v.isStopped, L = v.observers;
    return R || I ? Pl : (this.currentObservers = null, L.push(n), new Uf(function() {
      s.currentObservers = null, cs(L, n);
    }));
  }, r.prototype._checkFinalizedStatuses = function(n) {
    var s = this, v = s.hasError, R = s.thrownError, I = s.isStopped;
    v ? n.error(R) : I && n.complete();
  }, r.prototype.asObservable = function() {
    var n = new Jc();
    return n.source = this, n;
  }, r.create = function(n, s) {
    return new Xc(n, s);
  }, r;
}(Jc), Xc = function(o) {
  Cf(r, o);
  function r(n, s) {
    var v = o.call(this) || this;
    return v.destination = n, v.source = s, v;
  }
  return r.prototype.next = function(n) {
    var s, v;
    (v = (s = this.destination) === null || s === void 0 ? void 0 : s.next) === null || v === void 0 || v.call(s, n);
  }, r.prototype.error = function(n) {
    var s, v;
    (v = (s = this.destination) === null || s === void 0 ? void 0 : s.error) === null || v === void 0 || v.call(s, n);
  }, r.prototype.complete = function() {
    var n, s;
    (s = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || s === void 0 || s.call(n);
  }, r.prototype._subscribe = function(n) {
    var s, v;
    return (v = (s = this.source) === null || s === void 0 ? void 0 : s.subscribe(n)) !== null && v !== void 0 ? v : Pl;
  }, r;
}(Ml), gy = (o) => {
  if (Object.prototype.toString.call(o) !== "[object Object]")
    return !1;
  const r = Object.getPrototypeOf(o);
  return r === null || r === Object.prototype;
};
const Of = gy, { hasOwnProperty: $l } = Object.prototype, { propertyIsEnumerable: vy } = Object, Yi = (o, r, n) => Object.defineProperty(o, r, {
  value: n,
  writable: !0,
  enumerable: !0,
  configurable: !0
}), _y = di, Qc = {
  concatArrays: !1,
  ignoreUndefined: !1
}, Lf = (o) => {
  const r = [];
  for (const n in o)
    $l.call(o, n) && r.push(n);
  if (Object.getOwnPropertySymbols) {
    const n = Object.getOwnPropertySymbols(o);
    for (const s of n)
      vy.call(o, s) && r.push(s);
  }
  return r;
};
function qi(o) {
  return Array.isArray(o) ? yy(o) : Of(o) ? xy(o) : o;
}
function yy(o) {
  const r = o.slice(0, 0);
  return Lf(o).forEach((n) => {
    Yi(r, n, qi(o[n]));
  }), r;
}
function xy(o) {
  const r = Object.getPrototypeOf(o) === null ? /* @__PURE__ */ Object.create(null) : {};
  return Lf(o).forEach((n) => {
    Yi(r, n, qi(o[n]));
  }), r;
}
const Nl = (o, r, n, s) => (n.forEach((v) => {
  typeof r[v] > "u" && s.ignoreUndefined || (v in o && o[v] !== Object.getPrototypeOf(o) ? Yi(o, v, hs(o[v], r[v], s)) : Yi(o, v, qi(r[v])));
}), o), by = (o, r, n) => {
  let s = o.slice(0, 0), v = 0;
  return [o, r].forEach((R) => {
    const I = [];
    for (let L = 0; L < R.length; L++)
      $l.call(R, L) && (I.push(String(L)), R === o ? Yi(s, v++, R[L]) : Yi(s, v++, qi(R[L])));
    s = Nl(s, R, Lf(R).filter((L) => !I.includes(L)), n);
  }), s;
};
function hs(o, r, n) {
  return n.concatArrays && Array.isArray(o) && Array.isArray(r) ? by(o, r, n) : !Of(r) || !Of(o) ? qi(r) : Nl(o, r, Lf(r), n);
}
var my = function(...o) {
  const r = hs(qi(Qc), this !== _y && this || {}, Qc);
  let n = { _: {} };
  for (const s of o)
    if (s !== void 0) {
      if (!Of(s))
        throw new TypeError("`" + s + "` is not an Option Object");
      n = hs(n, { _: s }, r);
    }
  return n._;
};
const wy = /* @__PURE__ */ Ro(my), Ey = wy.bind({
  concatArrays: !0,
  ignoreUndefined: !0
});
function Sy(o, r) {
  const n = window.localStorage.getItem(o);
  if (n) {
    const s = JSON.parse(n), v = JSON.parse(r), R = JSON.stringify(Ey(s, v));
    window.localStorage.setItem(o, R);
  } else
    window.localStorage.setItem(o, r);
}
function Li(o, r) {
  return new Promise((n, s) => {
    try {
      const v = o();
      r == null || r(null, v), n(v);
    } catch (v) {
      r == null || r(v), s(v);
    }
  });
}
function Sf(o, r, n) {
  return Promise.all(o).then((s) => {
    const v = (n == null ? void 0 : n(s)) ?? null;
    return r == null || r(null, v), Promise.resolve(v);
  }, (s) => (r == null || r(s), Promise.reject(s)));
}
const Di = {
  /**
   * Fetches `key` value.
   */
  getItem: (o, r) => Li(() => window.localStorage.getItem(o), r),
  /**
   * Sets `value` for `key`.
   */
  setItem: (o, r, n) => Li(() => window.localStorage.setItem(o, r), n),
  /**
   * Removes a `key`
   */
  removeItem: (o, r) => Li(() => window.localStorage.removeItem(o), r),
  /**
   * Merges existing value with input value, assuming they are stringified JSON.
   */
  mergeItem: (o, r, n) => Li(() => Sy(o, r), n),
  /**
   * Erases *all* AsyncStorage for the domain.
   */
  clear: (o) => Li(() => window.localStorage.clear(), o),
  /**
   * Gets *all* keys known to the app, for all callers, libraries, etc.
   */
  getAllKeys: (o) => Li(() => {
    const r = window.localStorage.length, n = [];
    for (let s = 0; s < r; s += 1) {
      const v = window.localStorage.key(s) || "";
      n.push(v);
    }
    return n;
  }, o),
  /**
   * (stub) Flushes any pending requests using a single batch call to get the data.
   */
  flushGetRequests: () => {
  },
  /**
   * multiGet resolves to an array of key-value pair arrays that matches the
   * input format of multiSet.
   *
   *   multiGet(['k1', 'k2']) -> [['k1', 'val1'], ['k2', 'val2']]
   */
  multiGet: (o, r) => {
    const n = o.map((v) => Di.getItem(v));
    return Sf(n, r, (v) => v.map((R, I) => [o[I], R]));
  },
  /**
   * Takes an array of key-value array pairs.
   *   multiSet([['k1', 'val1'], ['k2', 'val2']])
   */
  multiSet: (o, r) => {
    const n = o.map((s) => Di.setItem(s[0], s[1]));
    return Sf(n, r);
  },
  /**
   * Delete all the keys in the `keys` array.
   */
  multiRemove: (o, r) => {
    const n = o.map((s) => Di.removeItem(s));
    return Sf(n, r);
  },
  /**
   * Takes an array of key-value array pairs and merges them with existing
   * values, assuming they are stringified JSON.
   *
   *   multiMerge([['k1', 'val1'], ['k2', 'val2']])
   */
  multiMerge: (o, r) => {
    const n = o.map((s) => Di.mergeItem(s[0], s[1]));
    return Sf(n, r);
  }
};
class Ry {
  constructor() {
    this.eventIdStoreKey = "omni-connect-event-id", this.eventId = 0, Di.getItem(this.eventIdStoreKey).then((r) => {
      this.eventId = Number(r);
    }).catch(() => {
    });
  }
  getId() {
    return this.eventId++, Di.setItem(this.eventIdStoreKey, String(this.eventId)).catch(() => {
    }), this.eventId;
  }
}
const el = new Ry(), Ay = (o) => {
  Ki().setItem(ki, JSON.stringify(o));
}, Ty = (o) => {
  const r = Ki().getItem(ki);
  if (r)
    try {
      const n = JSON.parse(r);
      Ki().setItem(
        ki,
        JSON.stringify({ ...n, ...o })
      );
    } catch (n) {
      console.error(n);
    }
}, Oy = () => {
  Ki().removeItem(ki);
}, tl = new Ml(), bs = (o) => {
  const r = new os(o ?? void 0), n = r.stringifyKeypair(), s = r.sessionId;
  return { sessionKeyPair: n, sessionId: s };
}, If = {
  namespaceKey: "",
  connected: !1,
  result: {}
};
class Mf {
  constructor(r) {
    this.defaultTtl = 300, this.bridgeUrl = A_, this.deeplink = $c, this.eventSource = null, this.valid = !0, this.connection = {
      sessionKeyPair: {
        publicKey: "",
        secretKey: ""
      },
      from: ""
    }, this.metadata = r.metadata, this.namespace = r.namespace;
    const n = Object.keys(r.namespace);
    this.namespaceKey = n[0], this.deeplink = r.deeplink || $c, this.walletInfo = { ...If };
  }
  getWalletInfo() {
    return this.walletInfo;
  }
  onStatusChange(r, n) {
    return tl.subscribe({
      next: (s) => {
        console.log(`[${Kr}]: observer: `, s), s != null && s.error ? n(s.error) : r(s);
      }
    });
  }
  syncEventSourceMessage() {
    return this.eventSource.removeAllEventListeners("message"), new Promise((r, n) => {
      this.resolve = r, this.reject = n, this.eventSource.addEventListener(
        "message",
        br.debounce(this.handleMessage.bind(this), 200)
      );
    });
  }
  async connect(r) {
    if (this.validationAssert(), this.close(), r != null && r.request && !br.isObject(r == null ? void 0 : r.request))
      throw new Error("Invalid request type.");
    const n = r == null ? void 0 : r.ret;
    if (n && !br.isString(n))
      throw new Error("Invalid ret type.");
    const { sessionKeyPair: s, sessionId: v } = bs(), R = `${this.bridgeUrl}/events?client_id=${v}`;
    return this.eventSource = new Wc(R), this.eventSource.addEventListener("open", async () => {
      console.log(`[${Kr}]: sse connect: opened`), this.connection.sessionKeyPair = s;
      const I = {
        metadata: this.metadata,
        namespace: this.namespace,
        namespaceKey: this.namespaceKey,
        method: wn.Connect,
        ...r == null ? void 0 : r.request
      }, L = `v=1&id=${encodeURIComponent(
        v
      )}&r=${encodeURIComponent(
        JSON.stringify(I)
      )}&ret=${encodeURIComponent(n || "none")}`;
      console.log(L), Nc(
        `${this.deeplink}?startapp=omniconnect-${T_(
          L
        )}`
      );
    }), this.eventSource.addEventListener("error", this.eventSourceErrorHandle), this.syncEventSourceMessage();
  }
  getAddress() {
    var r, n;
    try {
      const s = JSON.parse(
        Ki().getItem(ki) || "{}"
      );
      return (n = (r = s == null ? void 0 : s.walletInfo) == null ? void 0 : r.result) == null ? void 0 : n.address;
    } catch (s) {
      return console.error(s), "";
    }
  }
  disconnect(r) {
    this.connectedNeededAssert();
    const n = {
      id: el.getId(),
      metadata: this.metadata,
      namespaceKey: this.namespaceKey,
      method: wn.Disconnect
    };
    this.send(n), this.setWalletInfo({
      ...If,
      ...r,
      event: wn.Disconnect
    }), this.close(), this.removeConnection();
  }
  async distribute({
    method: r,
    payload: n,
    settings: s
  }) {
    const v = {
      id: el.getId(),
      metadata: this.metadata,
      namespaceKey: this.namespaceKey,
      method: r,
      payload: n
    };
    return this.send(v), this.openlinkInCommonWay(s == null ? void 0 : s.preventPopup), this.syncEventSourceMessage();
  }
  async handleMessage(r) {
    var n, s, v, R;
    try {
      const { data: I, lastEventId: L, type: G, url: Z } = r;
      Ty({ lastEventId: L });
      const { from: he, message: me } = JSON.parse(I);
      this.connection.from = he;
      const Me = new os(this.connection.sessionKeyPair), be = JSON.parse(
        Me.decrypt(
          Gc.decode(me).toUint8Array(),
          Tf(he)
        )
      );
      if (console.log("handleMessage response", be), be != null && be.error) {
        this.next({
          error: be == null ? void 0 : be.error
        }), (n = this.reject) == null || n.call(this, be == null ? void 0 : be.error);
        return;
      }
      const { event: tt, namespaceKey: We, result: Ge } = be;
      switch (tt) {
        case wn.Connect:
          this.setWalletInfo({
            ...this.walletInfo,
            ...be,
            connected: !0
          }), Ay({
            event: tt,
            namespaceKey: We,
            type: is.Remote,
            connection: this.connection,
            lastEventId: L,
            walletInfo: this.walletInfo
          }), (s = this.resolve) == null || s.call(this, this.walletInfo);
          break;
        case wn.SignMessage:
        case wn.SignTransaction:
        case wn.SendTransaction:
          this.setWalletInfo({ ...this.walletInfo, ...be }), (v = this.resolve) == null || v.call(this, this.walletInfo);
          break;
        case wn.Disconnect:
          this.disconnect(be);
          break;
        default:
          break;
      }
    } catch (I) {
      (R = this.reject) == null || R.call(this, {
        error: {
          message: `[${Kr}]: bridge response error: ${I}`
        }
      }), console.error(`[${Kr}]: bridge response error: ${I}`);
    }
  }
  async send(r, n) {
    this.validationAssert(), this.connectedNeededAssert();
    try {
      const s = new os(this.connection.sessionKeyPair), v = this.connection.from, R = `${this.bridgeUrl}/message?client_id=${s.sessionId}&to=${v}&ttl=${n || this.defaultTtl}`, I = s.encrypt(
        JSON.stringify(r),
        Tf(v)
      );
      await fetch(R, {
        body: Gc.encode(I),
        method: "POST"
      });
    } catch (s) {
      console.error(`[${Kr}]: send fail: ${s}`);
    }
  }
  async restoreConnection(r) {
    const n = JSON.parse(
      Ki().getItem(ki) || "{}"
    );
    if (n.connection && n.event === wn.Connect && n.type === is.Remote) {
      const { namespaceKey: s, connection: v, lastEventId: R, walletInfo: I } = n;
      if (s !== this.namespaceKey) return;
      const L = v.sessionKeyPair.publicKey;
      this.connection = v;
      const G = `${this.bridgeUrl}/events?client_id=${L}&last_event_id=${R}`;
      return this.eventSource = new Wc(G), this.eventSource.addEventListener(
        "message",
        br.debounce(this.handleMessage.bind(this), 200)
      ), this.eventSource.addEventListener("error", this.eventSourceErrorHandle), new Promise((Z, he) => {
        this.reject = he, this.eventSource.addEventListener("open", async () => {
          this.setWalletInfo(I), Z(I);
        });
      });
    }
  }
  setWalletInfo(r) {
    this.walletInfo = r, this.next(this.walletInfo);
  }
  next(r) {
    tl.next(r);
  }
  close() {
    this.eventSource && (this.eventSource.removeAllEventListeners(), this.eventSource.close(), this.eventSource = null, console.log(`[${Kr}]: sse close`));
  }
  eventSourceErrorHandle(r) {
    var s;
    const n = {
      error: {
        code: 400,
        message: `[${Kr}]: sse connect: error: ${r}`
      }
    };
    (s = this.reject) == null || s.call(this, n), this.next(n);
  }
  removeConnection() {
    Oy();
  }
  connectedNeededAssert() {
    var r;
    En(
      this.walletInfo.connected || !!((r = this.walletInfo.result) != null && r.address),
      "Please connect your wallet first."
    );
  }
  openlinkInCommonWay(r) {
    r !== Rl.Open && Nc(`${this.deeplink}?startapp=${Kr.toLowerCase()}`);
  }
  validationAssert() {
    En(
      this.valid,
      "The SDK has not been initialized or verified successfully."
    );
  }
}
const Iy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseProvider: Mf,
  InitWalletInfo: If,
  generateClientId: bs
}, Symbol.toStringTag, { value: "Module" }));
function Py(o, { strict: r = !0 } = {}) {
  return !o || typeof o != "string" ? !1 : r ? /^0x[0-9a-fA-F]*$/.test(o) : o.startsWith("0x");
}
function nl(o) {
  return Py(o, { strict: !1 }) ? Math.ceil((o.length - 2) / 2) : o.length;
}
const Fl = "2.21.45";
let mo = {
  getDocsUrl: ({ docsBaseUrl: o, docsPath: r = "", docsSlug: n }) => r ? `${o ?? "https://viem.sh"}${r}${n ? `#${n}` : ""}` : void 0,
  version: `viem@${Fl}`
};
class zi extends Error {
  constructor(r, n = {}) {
    var L;
    const s = (() => {
      var G;
      return n.cause instanceof zi ? n.cause.details : (G = n.cause) != null && G.message ? n.cause.message : n.details;
    })(), v = n.cause instanceof zi && n.cause.docsPath || n.docsPath, R = (L = mo.getDocsUrl) == null ? void 0 : L.call(mo, { ...n, docsPath: v }), I = [
      r || "An error occurred.",
      "",
      ...n.metaMessages ? [...n.metaMessages, ""] : [],
      ...R ? [`Docs: ${R}`] : [],
      ...s ? [`Details: ${s}`] : [],
      ...mo.version ? [`Version: ${mo.version}`] : []
    ].join(`
`);
    super(I, n.cause ? { cause: n.cause } : void 0), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BaseError"
    }), this.details = s, this.docsPath = v, this.metaMessages = n.metaMessages, this.name = n.name ?? this.name, this.shortMessage = r, this.version = Fl;
  }
  walk(r) {
    return Dl(this, r);
  }
}
function Dl(o, r) {
  return r != null && r(o) ? o : o && typeof o == "object" && "cause" in o && o.cause !== void 0 ? Dl(o.cause, r) : r ? null : o;
}
class Bl extends zi {
  constructor({ size: r, targetSize: n, type: s }) {
    super(`${s.charAt(0).toUpperCase()}${s.slice(1).toLowerCase()} size (${r}) exceeds padding size (${n}).`, { name: "SizeExceedsPaddingSizeError" });
  }
}
function Cy(o, { dir: r, size: n = 32 } = {}) {
  return typeof o == "string" ? Uy(o, { dir: r, size: n }) : Ly(o, { dir: r, size: n });
}
function Uy(o, { dir: r, size: n = 32 } = {}) {
  if (n === null)
    return o;
  const s = o.replace("0x", "");
  if (s.length > n * 2)
    throw new Bl({
      size: Math.ceil(s.length / 2),
      targetSize: n,
      type: "hex"
    });
  return `0x${s[r === "right" ? "padEnd" : "padStart"](n * 2, "0")}`;
}
function Ly(o, { dir: r, size: n = 32 } = {}) {
  if (n === null)
    return o;
  if (o.length > n)
    throw new Bl({
      size: o.length,
      targetSize: n,
      type: "bytes"
    });
  const s = new Uint8Array(n);
  for (let v = 0; v < n; v++) {
    const R = r === "right";
    s[R ? v : n - v - 1] = o[R ? v : o.length - v - 1];
  }
  return s;
}
class My extends zi {
  constructor({ givenSize: r, maxSize: n }) {
    super(`Size cannot exceed ${n} bytes. Given size: ${r} bytes.`, { name: "SizeOverflowError" });
  }
}
function $y(o, { dir: r = "left" } = {}) {
  let n = typeof o == "string" ? o.replace("0x", "") : o, s = 0;
  for (let v = 0; v < n.length - 1 && n[r === "left" ? v : n.length - v - 1].toString() === "0"; v++)
    s++;
  return n = r === "left" ? n.slice(s) : n.slice(0, n.length - s), typeof o == "string" ? (n.length === 1 && r === "right" && (n = `${n}0`), `0x${n.length % 2 === 1 ? `0${n}` : n}`) : n;
}
function Wl(o, { size: r }) {
  if (nl(o) > r)
    throw new My({
      givenSize: nl(o),
      maxSize: r
    });
}
function Ny(o, r = {}) {
  let n = Fy(o);
  return r.size && (Wl(n, { size: r.size }), n = $y(n, { dir: "right" })), new TextDecoder().decode(n);
}
const kr = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function rl(o) {
  if (o >= kr.zero && o <= kr.nine)
    return o - kr.zero;
  if (o >= kr.A && o <= kr.F)
    return o - (kr.A - 10);
  if (o >= kr.a && o <= kr.f)
    return o - (kr.a - 10);
}
function Fy(o, r = {}) {
  let n = o;
  r.size && (Wl(n, { size: r.size }), n = Cy(n, { dir: "right", size: r.size }));
  let s = n.slice(2);
  s.length % 2 && (s = `0${s}`);
  const v = s.length / 2, R = new Uint8Array(v);
  for (let I = 0, L = 0; I < v; I++) {
    const G = rl(s.charCodeAt(L++)), Z = rl(s.charCodeAt(L++));
    if (G === void 0 || Z === void 0)
      throw new zi(`Invalid byte sequence ("${s[L - 2]}${s[L - 1]}" in "${s}").`);
    R[I] = G * 16 + Z;
  }
  return R;
}
var $f = /* @__PURE__ */ ((o) => (o.EthSign = "eth_sign", o.PersonalSign = "personal_sign", o.EthSignTypedData = "eth_signTypedData", o.EthSignTypedDataV3 = "eth_signTypedData_v3", o.EthSignTypedDataV4 = "eth_signTypedData_v4", o.EthSignTransaction = "eth_signTransaction", o.EthSendTransaction = "eth_sendTransaction", o.EthSendRawTransaction = "eth_sendRawTransaction", o))($f || {});
const ms = [
  "668808",
  "1313161554",
  "43114",
  "10000",
  "56",
  "288",
  "32520",
  "199",
  "42220",
  "71394",
  "820",
  "256256",
  "25",
  "1818",
  "2000",
  "61",
  "2152",
  "250",
  "122",
  "86",
  "1280",
  "24",
  "2222",
  "321",
  "8217",
  "998",
  "115",
  "137",
  "82",
  "57",
  "40",
  "8082",
  "8081",
  "1030",
  "88",
  "19330",
  "106",
  "100",
  "20212",
  "324",
  "201022",
  "1442",
  "1101",
  "42161",
  "210425",
  "4689",
  "1666600000",
  "66",
  "10",
  "2019",
  "108",
  "8453",
  "20201022",
  "5000",
  "5001",
  "59144",
  "59140",
  "204",
  "534352",
  "1116",
  "22222",
  "7000",
  "7001",
  "1",
  "128",
  "42766",
  "88888",
  "169",
  "80085",
  "2810",
  "2710",
  "2818",
  "34443",
  "4200",
  "81457",
  "666666666",
  "200901",
  "167000",
  "1329",
  "698",
  "60808",
  "2818",
  "41455"
], jl = {
  chains: ms,
  methods: Object.values($f)
  // events: ["accountsChanged", "chainChanged"],
}, kl = /^0x[a-fA-F0-9]*$/, il = /^(0x|0x[a-fA-F0-9]+)$/, Kl = (o) => {
  const r = [
    {
      condition: !kl.test(o.from),
      message: "Invalid from address, expected a valid Ethereum address."
    },
    // {
    //   condition: !addressRegex.test(params.to),
    //   message: "Invalid to address, expected a valid Ethereum address.",
    // },
    {
      condition: !il.test(o.value),
      message: "Invalid value, expected a hex string."
    },
    {
      condition: !il.test(o.data),
      message: "Invalid data, expected a hex string."
    },
    {
      condition: typeof o.gasLimit != "string",
      message: "Invalid gasLimit, expected a string."
    },
    {
      condition: o.gasPrice && typeof o.gasPrice != "string",
      message: "Invalid gasPrice, expected a string."
    },
    {
      condition: o.maxPriorityFeePerGas && typeof o.maxPriorityFeePerGas != "string",
      message: "Invalid maxPriorityFeePerGas, expected a string."
    },
    {
      condition: o.maxFeePerGas && typeof o.maxFeePerGas != "string",
      message: "Invalid maxFeePerGas, expected a string."
    },
    {
      condition: typeof o.chainId != "string" && typeof o.chainId != "number",
      message: "Invalid chainId: expected a string or number."
    }
  ];
  for (const n of r)
    if (n.condition)
      return `[${Vt}]: ${n.message}`;
  return null;
}, Yl = ({
  method: o,
  params: r
}) => {
  if (!Array.isArray(r) || r.length < 2)
    return `[${Vt}]:Invalid parameters expected an array with at least 2 elements.`;
  const n = r[0];
  if (!kl.test(n))
    return `[${Vt}]:Invalid address expected a valid Ethereum address.`;
  switch (o) {
    case "eth_sign":
      if (typeof r[1] != "string")
        return `[${Vt}]:Invalid params expected a string for message in eth_sign.`;
      break;
    case "personal_sign":
      if (typeof r[1] != "string")
        return `[${Vt}]:Invalid params expected a string for message in personal_sign.`;
      break;
    case "eth_signTypedData":
      const s = ws(r[1]);
      if (s)
        return s;
      break;
    case "eth_signTypedData_v3":
    case "eth_signTypedData_v4":
      const v = Es(r[1]);
      if (v)
        return v;
      break;
    default:
      return `[${Vt}]:Invalid signing method.`;
  }
  return null;
}, ws = (o) => {
  if (!Array.isArray(o) || o === null)
    return `[${Vt}]:Invalid data, expected an array of data.`;
  for (const r of o)
    if (typeof r.name != "string" || typeof r.type != "string")
      return `[${Vt}]:Invalid type definition each type must have 'name' and 'type' as strings.`;
  return null;
}, Es = (o) => {
  if (typeof o != "object" || o === null)
    return `[${Vt}]:Invalid data, expected an object.`;
  if (typeof o.domain != "object" || o.domain === null)
    return `[${Vt}]:Invalid domain expected an object.`;
  const r = [
    "name",
    "version",
    "chainId",
    "verifyingContract"
  ];
  for (const n of r)
    if (n === "chainId") {
      if (typeof o.domain[n] != "string" && typeof o.domain[n] != "number")
        return `[${Vt}]:Invalid domain field "${n}" expected a string or number.`;
    } else if (typeof o.domain[n] != "string")
      return `[${Vt}]:Invalid domain field "${n}" expected a string.`;
  if (typeof o.primaryType != "string")
    return `[${Vt}]:Invalid primaryType expected a string.`;
  if (typeof o.types != "object" || o.types === null)
    return `[${Vt}]:Invalid types expected an object.`;
  if (typeof o.message != "object" || o.message === null)
    return `[${Vt}]:Invalid message expected an object.`;
  for (const n in o.types)
    if (Array.isArray(o.types[n])) {
      for (const s of o.types[n])
        if (typeof s.name != "string" || typeof s.type != "string")
          return `[${Vt}]:Invalid type definition each type must have 'name' and 'type' as strings.`;
    } else
      return `[${Vt}]：Invalid types for "${n}" expected an array of types.`;
  return null;
}, ol = (o) => {
  const { walletInfo: r } = o, n = br.parseInt(o == null ? void 0 : o.nonce), s = {
    ...o,
    nonce: n,
    gas: o == null ? void 0 : o.gasLimit
  };
  if (o != null && o.maxPriorityFeePerGas || o != null && o.maxFeePerGas) {
    const v = Bc(
      // _.parseInt(param?.maxPriorityFeePerGas),
      o == null ? void 0 : o.maxPriorityFeePerGas,
      "gwei"
    ), R = Bc(o == null ? void 0 : o.maxFeePerGas, "gwei");
    s.maxPriorityFeePerGas = v, s.maxFeePerGas = R;
  }
  return {
    source: s,
    from: r == null ? void 0 : r.from
  };
};
class Ss extends Mf {
  constructor(r) {
    var n, s;
    super(r), this.chains = (s = (n = r.namespace) == null ? void 0 : n.eip155) == null ? void 0 : s.chains;
  }
  async request(r) {
    var n, s;
    switch (console.log("OmniConnect Eip155Provider request Args:", r), r.method) {
      case "eth_requestAccounts":
        return this.getAccounts();
      case "eth_accounts":
        return this.getAccounts();
      case "wallet_switchEthereumChain":
        const v = (s = (n = r == null ? void 0 : r.params) == null ? void 0 : n[0]) == null ? void 0 : s.chainId;
        return v && (this.chainId = br.parseInt(v)), v;
      case "eth_chainId":
        return this.chainId;
      case "wallet_getCapabilities":
        return "Not support";
      case "wallet_getCallsStatus":
        return "Not support";
      case "eth_sign":
      case "personal_sign":
      case "eth_signTypedData":
      case "eth_signTypedData_v3":
      case "eth_signTypedData_v4":
        return this.signMessage(r);
      case "eth_signTransaction":
        return this.signTransaction(r);
      case "eth_sendTransaction":
        return this.sendTransaction(r);
    }
  }
  async getAccounts() {
    const r = this.getAddress();
    return br.compact([r]);
  }
  async connect(r) {
    var s, v, R, I, L;
    (s = r == null ? void 0 : r.request) != null && s.chainId && (this.chainId = (v = r == null ? void 0 : r.request) == null ? void 0 : v.chainId, En(
      br.map(this.chains, String).includes(String(this.chainId)),
      "Request chainId must be included in the chains list."
    ));
    const n = await super.connect({
      ...r,
      request: {
        chains: this.chains,
        //wagmi
        ...r == null ? void 0 : r.request
      }
    });
    return this.chainId = (R = n == null ? void 0 : n.result) == null ? void 0 : R.chainId, {
      account: (I = n == null ? void 0 : n.result) == null ? void 0 : I.address,
      chainId: (L = n == null ? void 0 : n.result) == null ? void 0 : L.chainId
    };
  }
  async signMessage(r) {
    var v, R, I, L;
    this.connectedNeededAssert();
    let n;
    switch (r.method) {
      case "eth_sign":
        n = {
          params: r.params,
          __type: "ethSign"
        };
        break;
      case "personal_sign":
        n = {
          data: Ny((v = r.params) == null ? void 0 : v[0]),
          __type: "personal"
        };
        break;
      case "eth_signTypedData":
        n = {
          data: (R = r.params) == null ? void 0 : R[1],
          __type: "typedData"
        };
        break;
      case "eth_signTypedData_v3":
      case "eth_signTypedData_v4":
        n = {
          data: {
            ...(I = r.params) == null ? void 0 : I[1]
          },
          __type: "typedData",
          __v4: !0
        };
        break;
      default:
        En(!1, `[${Vt}]:Unsupported signMessage method.`);
    }
    const s = await this.distribute({
      method: wn.SignMessage,
      payload: {
        ...n,
        chainId: this.chainId
      },
      settings: r == null ? void 0 : r.settings
    });
    return (L = s == null ? void 0 : s.result) == null ? void 0 : L.signature;
  }
  async signTransaction(r) {
    var v, R, I, L, G, Z, he, me, Me;
    this.connectedNeededAssert(), r.method !== "eth_signTransaction" && En(!1, `[${Vt}]:Unsupported signTransaction method.`), En(!!this.getAddress(), "No connected wallet address.");
    const n = ol({
      ...(v = r == null ? void 0 : r.params) == null ? void 0 : v[0],
      chainId: (I = (R = r == null ? void 0 : r.params) == null ? void 0 : R[0]) != null && I.chainId ? br.parseInt((G = (L = r == null ? void 0 : r.params) == null ? void 0 : L[0]) == null ? void 0 : G.chainId) : this.chainId,
      data: ((he = (Z = r == null ? void 0 : r.params) == null ? void 0 : Z[0]) == null ? void 0 : he.data) || "0x",
      walletInfo: {
        ...this.walletInfo,
        from: this.getAddress()
      }
    }), s = await this.distribute({
      payload: n,
      method: wn.SignTransaction,
      settings: r == null ? void 0 : r.settings
    });
    return this.chainId = (me = n.source) == null ? void 0 : me.chainId, (Me = s == null ? void 0 : s.result) == null ? void 0 : Me.signature;
  }
  async sendTransaction(r) {
    var v, R, I, L, G, Z, he, me, Me;
    this.connectedNeededAssert(), r.method !== "eth_sendTransaction" && En(!1, `[${Vt}]:Unsupported sendTransaction method.`), En(!!this.getAddress(), "No connected wallet address.");
    const n = ol({
      ...(v = r == null ? void 0 : r.params) == null ? void 0 : v[0],
      chainId: (I = (R = r == null ? void 0 : r.params) == null ? void 0 : R[0]) != null && I.chainId ? br.parseInt((G = (L = r == null ? void 0 : r.params) == null ? void 0 : L[0]) == null ? void 0 : G.chainId) : this.chainId,
      data: ((he = (Z = r == null ? void 0 : r.params) == null ? void 0 : Z[0]) == null ? void 0 : he.data) || "0x",
      walletInfo: {
        ...this.walletInfo,
        from: this.getAddress()
      }
    }), s = await this.distribute({
      payload: n,
      method: wn.SendTransaction,
      settings: r == null ? void 0 : r.settings
    });
    return this.chainId = (me = n.source) == null ? void 0 : me.chainId, (Me = s == null ? void 0 : s.result) == null ? void 0 : Me.reciept;
  }
  async restoreConnection() {
    var n, s, v;
    const r = await super.restoreConnection();
    return this.chainId = (n = r == null ? void 0 : r.result) == null ? void 0 : n.chainId, {
      account: (s = r == null ? void 0 : r.result) == null ? void 0 : s.address,
      chainId: (v = r == null ? void 0 : r.result) == null ? void 0 : v.chainId
    };
  }
}
const Dy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DefaultSupportedChainIds: ms,
  Eip155Provider: Ss,
  Eip155SigningMethods: $f,
  defaultEip155Namespace: jl,
  validateSignMessageParams: Yl,
  validateTransactionParams: Kl,
  validateTypedDataParams: ws,
  validateTypedDataVParams: Es
}, Symbol.toStringTag, { value: "Module" }));
function By(o) {
  if (o.length >= 255)
    throw new TypeError("Alphabet too long");
  const r = new Uint8Array(256);
  for (let Z = 0; Z < r.length; Z++)
    r[Z] = 255;
  for (let Z = 0; Z < o.length; Z++) {
    const he = o.charAt(Z), me = he.charCodeAt(0);
    if (r[me] !== 255)
      throw new TypeError(he + " is ambiguous");
    r[me] = Z;
  }
  const n = o.length, s = o.charAt(0), v = Math.log(n) / Math.log(256), R = Math.log(256) / Math.log(n);
  function I(Z) {
    if (Z instanceof Uint8Array || (ArrayBuffer.isView(Z) ? Z = new Uint8Array(Z.buffer, Z.byteOffset, Z.byteLength) : Array.isArray(Z) && (Z = Uint8Array.from(Z))), !(Z instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (Z.length === 0)
      return "";
    let he = 0, me = 0, Me = 0;
    const be = Z.length;
    for (; Me !== be && Z[Me] === 0; )
      Me++, he++;
    const tt = (be - Me) * R + 1 >>> 0, We = new Uint8Array(tt);
    for (; Me !== be; ) {
      let Fe = Z[Me], yt = 0;
      for (let ft = tt - 1; (Fe !== 0 || yt < me) && ft !== -1; ft--, yt++)
        Fe += 256 * We[ft] >>> 0, We[ft] = Fe % n >>> 0, Fe = Fe / n >>> 0;
      if (Fe !== 0)
        throw new Error("Non-zero carry");
      me = yt, Me++;
    }
    let Ge = tt - me;
    for (; Ge !== tt && We[Ge] === 0; )
      Ge++;
    let mt = s.repeat(he);
    for (; Ge < tt; ++Ge)
      mt += o.charAt(We[Ge]);
    return mt;
  }
  function L(Z) {
    if (typeof Z != "string")
      throw new TypeError("Expected String");
    if (Z.length === 0)
      return new Uint8Array();
    let he = 0, me = 0, Me = 0;
    for (; Z[he] === s; )
      me++, he++;
    const be = (Z.length - he) * v + 1 >>> 0, tt = new Uint8Array(be);
    for (; Z[he]; ) {
      let Fe = r[Z.charCodeAt(he)];
      if (Fe === 255)
        return;
      let yt = 0;
      for (let ft = be - 1; (Fe !== 0 || yt < Me) && ft !== -1; ft--, yt++)
        Fe += n * tt[ft] >>> 0, tt[ft] = Fe % 256 >>> 0, Fe = Fe / 256 >>> 0;
      if (Fe !== 0)
        throw new Error("Non-zero carry");
      Me = yt, he++;
    }
    let We = be - Me;
    for (; We !== be && tt[We] === 0; )
      We++;
    const Ge = new Uint8Array(me + (be - We));
    let mt = me;
    for (; We !== be; )
      Ge[mt++] = tt[We++];
    return Ge;
  }
  function G(Z) {
    const he = L(Z);
    if (he)
      return he;
    throw new Error("Non-base" + n + " character");
  }
  return {
    encode: I,
    decodeUnsafe: L,
    decode: G
  };
}
var Wy = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
const fl = By(Wy), Hi = {
  legacy: "legacy",
  versioned: "0"
};
function Rs(o) {
  return "version" in o;
}
const As = (o) => Rs(o) ? Hi.versioned : Hi.legacy;
class Ts extends Mf {
  constructor(r) {
    var n, s;
    super(r), this.chains = (s = (n = r.namespace) == null ? void 0 : n.solana) == null ? void 0 : s.chains;
  }
  async connect(r) {
    var s;
    const n = await super.connect({
      ...r,
      chains: this.chains
    });
    return {
      account: (s = n == null ? void 0 : n.result) == null ? void 0 : s.address
    };
  }
  async signMessage(r) {
    var v;
    this.connectedNeededAssert();
    const { message: n } = r, s = await this.distribute({
      method: wn.SignMessage,
      payload: {
        ...r,
        message: O_(Tl.decodeUTF8(n))
      },
      settings: r == null ? void 0 : r.settings
    });
    return (v = s == null ? void 0 : s.result) == null ? void 0 : v.signature;
  }
  async signTransaction(r) {
    var I, L, G;
    this.connectedNeededAssert();
    const { transaction: n } = r;
    En(!!this.getAddress(), "No connected wallet address."), En(
      (n == null ? void 0 : n.serialize) && typeof n.serialize == "function",
      "Illegal input: transaction.serialize is not a function. The input transaction maybe isn't a VersionedTransaction nor a Transaction"
    );
    const s = As(n);
    let v = {};
    switch (s) {
      case Hi.versioned:
        v = {
          version: s,
          serializedTransaction: fl.encode(n.serialize()),
          hex: (I = n == null ? void 0 : n.message) == null ? void 0 : I.recentBlockhash,
          instructions: (L = n == null ? void 0 : n.message) == null ? void 0 : L.compiledInstructions
        };
        break;
      case Hi.legacy:
        v = {
          version: s,
          serializedTransaction: fl.encode(
            new Uint8Array(
              n.serialize({
                requireAllSignatures: !1,
                verifySignatures: !1
              })
            )
          ),
          hex: n == null ? void 0 : n.recentBlockhash,
          instructions: n == null ? void 0 : n.instructions
        };
        break;
      default:
        En(!1, "Invalid input: not supported transaction version");
    }
    console.log("before sign data", { source: v, from: this.getAddress() });
    const R = await this.distribute({
      method: wn.SignTransaction,
      payload: {
        source: v,
        from: this.getAddress()
      },
      settings: r == null ? void 0 : r.settings
    });
    return (G = R == null ? void 0 : R.result) == null ? void 0 : G.signature;
  }
  async restoreConnection() {
    var n;
    const r = await super.restoreConnection();
    return {
      account: (n = r == null ? void 0 : r.result) == null ? void 0 : n.address
    };
  }
}
const jy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SolanaProvider: Ts,
  TransactionVersion: Hi,
  getTransactionVersion: As,
  isVersionedTransaction: Rs
}, Symbol.toStringTag, { value: "Module" })), zl = (o) => {
  o.eip155;
}, ky = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BaseProvider: Mf,
  DefaultSupportedChainIds: ms,
  Eip155Provider: Ss,
  Eip155SigningMethods: $f,
  InitWalletInfo: If,
  SolanaProvider: Ts,
  TransactionVersion: Hi,
  defaultEip155Namespace: jl,
  generateClientId: bs,
  getTransactionVersion: As,
  isVersionedTransaction: Rs,
  validateNamespace: zl,
  validateSignMessageParams: Yl,
  validateTransactionParams: Kl,
  validateTypedDataParams: ws,
  validateTypedDataVParams: Es
}, Symbol.toStringTag, { value: "Module" }));
class qy {
  constructor(r) {
    this.initialize(r);
  }
  async initialize(r) {
    En(r.metadata, "missing parameter metadata!"), En(r.namespace, "missing parameter namespace!"), zl(r.namespace);
    const n = Object.keys(r.namespace);
    En((n == null ? void 0 : n.length) === 1, "Namespace length error!");
    const s = /* @__PURE__ */ Object.assign({ "./providers/base.ts": () => Promise.resolve().then(() => Iy), "./providers/eip155.ts": () => Promise.resolve().then(() => Dy), "./providers/index.ts": () => Promise.resolve().then(() => ky), "./providers/solana.ts": () => Promise.resolve().then(() => jy), "./providers/ton.ts": () => import("./ton-DEgJOqFw.mjs") }), v = br.map(
      Object.keys(s),
      (R) => {
        var I;
        return (I = R == null ? void 0 : R.replace("./providers/", "")) == null ? void 0 : I.replace(".ts", "");
      }
    );
    switch (n[0]) {
      case "eip155":
        this.provider = new Ss(r);
        break;
      case "solana":
        this.provider = new Ts(r);
        break;
      default:
        En(
          v.includes(n[0]),
          `provider ${n[0]} does not exist!`
        );
    }
  }
}
async function Vy() {
  return ys(), await wl();
}
const Ky = (o) => o.split("").map((r) => r.charCodeAt(0).toString(16).padStart(2, "0")).join("");
function Yy(o) {
  const n = new URL(o).searchParams.toString();
  return `https://t.me/BitgetWallet_TGBot/BGW?startapp=wc-${Ky(n)}`;
}
function Jy() {
  const o = ys();
  return window.open = (r, ...n) => {
    try {
      if (r.startsWith("tg://") || r.startsWith("https://t.me") || r.startsWith("https://mini-app.bitkeep.com/")) {
        let s = r;
        (r.startsWith("https://t.me/BitgetWallet_TGBot/BGW") || r.startsWith("https://mini-app.bitkeep.com/")) && (s = Yy(r)), o.openTelegramLink(s);
      } else if (r.startsWith("bitkeep://")) {
        const s = r.substring(10);
        o.openLink(`https://bkcode.vip/?pageAction=${s}`);
      } else
        o.openLink(r);
    } catch (s) {
      console.error("open with tg methods failed", s);
    }
    return null;
  }, !0;
}
export {
  Mf as BaseProvider,
  ms as DefaultSupportedChainIds,
  Ss as Eip155Provider,
  $f as Eip155SigningMethods,
  If as InitWalletInfo,
  qy as OmniConnect,
  is as OmniConnectBridgeType,
  Rl as PreventType,
  wn as RequestMethods,
  Ts as SolanaProvider,
  Hi as TransactionVersion,
  jl as defaultEip155Namespace,
  bs as generateClientId,
  As as getTransactionVersion,
  Vy as isTelegramEnvironment,
  Rs as isVersionedTransaction,
  Jy as overrideWindowOpen,
  zl as validateNamespace,
  Yl as validateSignMessageParams,
  Kl as validateTransactionParams,
  ws as validateTypedDataParams,
  Es as validateTypedDataVParams
};
